/*! Version: 1.28.0.6 Built: 2021-01-12 14:46:58 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["commonUI"] = factory();
	else
		root["commonUI"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	module.exports = __webpack_require__(6);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Accordion = __webpack_require__(7);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Modal = __webpack_require__(16);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Nav = __webpack_require__(18);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Search = __webpack_require__(19);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Table = __webpack_require__(20);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Tabs = __webpack_require__(38);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Tooltip = __webpack_require__(39);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Pagination = __webpack_require__(41);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Loader = __webpack_require__(43);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dropdowns = __webpack_require__(44);
	
	var _Dropdowns2 = _interopRequireDefault(_Dropdowns);
	
	var _BackToTop = __webpack_require__(45);
	
	var _BackToTop2 = _interopRequireDefault(_BackToTop);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Filter = __webpack_require__(47);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _DismissableSidebarPanels = __webpack_require__(48);
	
	var _DismissableSidebarPanels2 = _interopRequireDefault(_DismissableSidebarPanels);
	
	var _CountdownTimer = __webpack_require__(49);
	
	var _CountdownTimer2 = _interopRequireDefault(_CountdownTimer);
	
	var _PriceTick = __webpack_require__(50);
	
	var _PriceTick2 = _interopRequireDefault(_PriceTick);
	
	var _ButtonGroup = __webpack_require__(21);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _Toasts = __webpack_require__(51);
	
	var _Toasts2 = _interopRequireDefault(_Toasts);
	
	var _SplitPanel = __webpack_require__(52);
	
	var _SplitPanel2 = _interopRequireDefault(_SplitPanel);
	
	var _Datepicker = __webpack_require__(53);
	
	var _Datepicker2 = _interopRequireDefault(_Datepicker);
	
	var _updateBrowser = __webpack_require__(12);
	
	var _updateBrowser2 = _interopRequireDefault(_updateBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable newline-after-var */
	
	// IE Symbol Polyfill
	
	__webpack_require__(55);
	__webpack_require__(110);
	
	// IE Array polyfill
	__webpack_require__(121);
	
	// IE Number polyfill
	__webpack_require__(128);
	
	var commonUI = function () {
	  /**
	   * initialize the dropdowns per selector
	   * @param  {Object} config
	   */
	  var initializeDropdown = function initializeDropdown(config) {
	    return _get__('initDropdown')(config);
	  };
	  /**
	   * initialize the tabs per selector
	   * @param  {Object} config
	   */
	  var initializeTabs = function initializeTabs(config) {
	    return _get__('initTabs')(config);
	  };
	  /**
	   * Initialize the modal
	   * @param  {Object} config
	   */
	  var initializeModal = function initializeModal(config) {
	    return _get__('initModal')(config);
	  };
	  /**
	   * Creates a new alert instance
	   * @param  {Object} config
	   */
	  var initializeAlert = function initializeAlert(config) {
	    return _get__('initAlert')(config);
	  };
	  /**
	     * Initialize the table
	     * @param  {Object} config
	     */
	  var initializeTable = function initializeTable(config) {
	    return _get__('initTable')(config);
	  };
	  /**
	     * Initialize the nav
	     * @param  {Object} config
	     */
	  var initializeNavigation = function initializeNavigation(config) {
	    return _get__('initNav')(config);
	  };
	  /**
	   * Initialize the search
	   * @param  {Object} config
	   */
	  var initializeSearch = function initializeSearch(config) {
	    return _get__('initSearch')(config);
	  };
	  /**
	     * Initialize the accordion
	     * @param  {Object} config
	     */
	  var initializeAccordion = function initializeAccordion(config) {
	    return _get__('initAccordion')(config);
	  };
	  /**
	     * Initialize the tooltip
	     * @param  {Object} config
	     */
	  var initializeTooltip = function initializeTooltip(config) {
	    return _get__('initTooltip')(config);
	  };
	  /**
	     * Initialize the pagination
	     * @param  {Object} config
	     */
	  var initializePagination = function initializePagination(config) {
	    return _get__('initPagination')(config);
	  };
	
	  /**
	     * Initialize the loader
	     * @param  {Object} config
	     */
	  var initializeLoader = function initializeLoader(config) {
	    return _get__('initLoader')(config);
	  };
	
	  /**
	     * Initialize the back to top
	     * @param  {Object} config
	     */
	  var initializeBackToTop = function initializeBackToTop(config) {
	    return _get__('initBackToTop')(config);
	  };
	
	  /**
	     * Initialize the drawer
	     * @param  {Object} config
	     */
	  var initializeDrawer = function initializeDrawer(selector, config) {
	    return _get__('initDrawer')(selector, config);
	  };
	
	  /**
	   * Initialize the filter
	   * @param  {Object} config
	   */
	  var initializeFilter = function initializeFilter(selector, config) {
	    return _get__('initFilter')(selector, config);
	  };
	
	  /**
	  * Initialize the filter
	  * @param  {Object} config
	  */
	  var initializeDismissableSidebarPanel = function initializeDismissableSidebarPanel(selector, config) {
	    return _get__('initDismissableSidebarPanel')(selector, config);
	  };
	
	  /**
	   * Initialize the countdown timer
	   * @param  {Object} config
	   */
	  var initializeCountdownTimer = function initializeCountdownTimer(selector, config) {
	    return _get__('initCountdownTimer')(selector, config);
	  };
	
	  /**
	   * Initialize the price ticker
	   * @param  {Object} config
	   */
	  var initializePriceTick = function initializePriceTick(selector, config) {
	    return _get__('initPriceTick')(selector, config);
	  };
	
	  /**
	   * Initialize the button group
	   * @param  {Object} config
	   */
	  var initializeButtonGroup = function initializeButtonGroup(config) {
	    return _get__('initButtonGroup')(config);
	  };
	
	  /**
	   * Initialize the toasts
	   * @param  {Object} config
	   */
	  var initializeToasts = function initializeToasts(config) {
	    return _get__('initToasts')(config);
	  };
	
	  /**
	   * Initialize the split panel
	   * @param  {Object} config
	   */
	  var initializeSplitPanel = function initializeSplitPanel(config) {
	    return _get__('initSplitPanel')(config);
	  };
	
	  var initializeDatepicker = function initializeDatepicker(element, config) {
	    return _get__('initDatepicker')(element, config);
	  };
	
	  var initializeUpdateBrowser = function initializeUpdateBrowser(config) {
	    return _get__('initUpdateBrowser')(config);
	  };
	
	  /**
	   * Reveal public pointers
	   */
	  return {
	    initializeDropdown: initializeDropdown,
	    initializeTabs: initializeTabs,
	    initializeModal: initializeModal,
	    initializeAlert: initializeAlert,
	    initializeTable: initializeTable,
	    initializeNavigation: initializeNavigation,
	    initializeSearch: initializeSearch,
	    initializeAccordion: initializeAccordion,
	    initializeTooltip: initializeTooltip,
	    initializePagination: initializePagination,
	    initializeLoader: initializeLoader,
	    initializeBackToTop: initializeBackToTop,
	    initializeDrawer: initializeDrawer,
	    initializeFilter: initializeFilter,
	    initializeDismissableSidebarPanel: initializeDismissableSidebarPanel,
	    initializeCountdownTimer: initializeCountdownTimer,
	    initializePriceTick: initializePriceTick,
	    initializeButtonGroup: initializeButtonGroup,
	    initializeToasts: initializeToasts,
	    initializeSplitPanel: initializeSplitPanel,
	    initializeDatepicker: initializeDatepicker,
	    initializeUpdateBrowser: initializeUpdateBrowser
	  };
	}();
	
	module.exports = _get__('commonUI');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'initDropdown':
	      return _Dropdowns2.default;

	    case 'initTabs':
	      return _Tabs2.default;

	    case 'initModal':
	      return _Modal2.default;

	    case 'initAlert':
	      return _Alert2.default;

	    case 'initTable':
	      return _Table2.default;

	    case 'initNav':
	      return _Nav2.default;

	    case 'initSearch':
	      return _Search2.default;

	    case 'initAccordion':
	      return _Accordion2.default;

	    case 'initTooltip':
	      return _Tooltip2.default;

	    case 'initPagination':
	      return _Pagination2.default;

	    case 'initLoader':
	      return _Loader2.default;

	    case 'initBackToTop':
	      return _BackToTop2.default;

	    case 'initDrawer':
	      return _Drawer2.default;

	    case 'initFilter':
	      return _Filter2.default;

	    case 'initDismissableSidebarPanel':
	      return _DismissableSidebarPanels2.default;

	    case 'initCountdownTimer':
	      return _CountdownTimer2.default;

	    case 'initPriceTick':
	      return _PriceTick2.default;

	    case 'initButtonGroup':
	      return _ButtonGroup2.default;

	    case 'initToasts':
	      return _Toasts2.default;

	    case 'initSplitPanel':
	      return _SplitPanel2.default;

	    case 'initDatepicker':
	      return _Datepicker2.default;

	    case 'initUpdateBrowser':
	      return _updateBrowser2.default;

	    case 'commonUI':
	      return commonUI;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = _typeof(module.exports);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(module.exports, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(module.exports)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Accordion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initAccordion;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Accordion = exports.Accordion = function () {
	
	  /**
	   * @param  {Dom}    accordion         container to hold accordion
	   * @param  {Bool}   openByDefault     open first item onLoad
	   */
	  function Accordion(accordion, config) {
	    _classCallCheck(this, Accordion);
	
	    this.accordion = accordion;
	    this.openByDefault = config.openByDefault;
	    this.singleOpen = config.singleOpen;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    // this.accordionItems = this.accordion.querySelectorAll('.accordion__item');
	    this.accordionItems = this.accordion.children;
	
	    // Bind the context with the event
	    this.showItem = this.showItem.bind(this);
	
	    // Initialize accordion
	    this.init();
	  }
	
	  _createClass(Accordion, [{
	    key: 'init',
	    value: function init() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.accordionItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var accordionItem = _step.value;
	
	          if (accordionItem.classList.contains('accordion__item')) {
	            _get__('addEvent')(accordionItem.querySelector('.accordion__title'), 'click', this.showItem);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (this.openByDefault) {
	        this.accordionItems[0].classList.add('accordion--open');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.accordionItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var accordionItem = _step2.value;
	
	          _get__('removeEvent')(accordionItem.querySelector('.accordion__title'), 'click', this.showItem);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'showItem',
	    value: function showItem(evt) {
	      _get__('cancelBubble')(evt);
	      var parentItem = evt.currentTarget.parentNode;
	      if (this.singleOpen === true) {
	        if (parentItem.classList.contains('accordion--open')) {
	          parentItem.classList.remove('accordion--open');
	        } else {
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = this.accordionItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var accordionItem = _step3.value;
	
	              accordionItem.classList.remove('accordion--open');
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          parentItem.classList.add('accordion--open');
	        }
	      } else {
	        parentItem.classList.toggle('accordion--open');
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.accordion) {
	        console.warn('CommonUI - Accordion - There\'s no accordion found');
	        return false;
	      } else if (this.accordion.querySelectorAll('.accordion__item').length === 0) {
	        console.warn('CommonUI - Accordion - There\'s no accordion items found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Accordion;
	}();
	
	/**
	 * Creates a new accordion instance
	 * @param  {Object} config
	 */
	
	
	function initAccordion() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$selector = _ref.selector,
	      selector = _ref$selector === undefined ? '.js-accordion' : _ref$selector,
	      _ref$openByDefault = _ref.openByDefault,
	      openByDefault = _ref$openByDefault === undefined ? true : _ref$openByDefault,
	      _ref$singleOpen = _ref.singleOpen,
	      singleOpen = _ref$singleOpen === undefined ? true : _ref$singleOpen;
	
	  var accordions = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = document.querySelectorAll(selector)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var accordion = _step4.value;
	
	        accordions = new (_get__('Accordion'))(accordion, { openByDefault: openByDefault, singleOpen: singleOpen });
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	  }
	  return accordions;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'cancelBubble':
	      return _events.cancelBubble;
	
	    case 'Accordion':
	      return Accordion;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initAccordion === 'undefined' ? 'undefined' : _typeof(initAccordion);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initAccordion, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initAccordion)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addEvent = addEvent;
	exports.removeEvent = removeEvent;
	exports.triggerEvent = triggerEvent;
	exports.cancelBubble = cancelBubble;
	exports.Throttle = Throttle;
	/* eslint-disable id-blacklist, func-style */
	
	function addEvent(object, type, callback) {
	  if (object === null || typeof object === 'undefined') {
	    return;
	  }
	  if (object.addEventListener) {
	    object.addEventListener(type, callback, false);
	  } else if (object.attachEvent) {
	    object.attachEvent('on' + type, callback);
	  } else {
	    object['on' + type] = callback;
	  }
	}
	
	function removeEvent(object, type, callback) {
	  if (object === null || typeof object === 'undefined') {
	    return;
	  }
	  if (object.removeEventListener) {
	    object.removeEventListener(type, callback, false);
	  } else if (object.removeEvent) {
	    object.removeEvent('on' + type);
	  }
	}
	
	function triggerEvent(element, eventName, options) {
	  var event = null;
	  if (window.CustomEvent) {
	    event = new CustomEvent(eventName, options);
	  } else {
	    event = document.createEvent('CustomEvent');
	    event.initCustomEvent(eventName, true, true, options);
	  }
	  element.dispatchEvent(event);
	}
	
	function cancelBubble(event) {
	  var evt = event ? event : window.event;
	  if (evt.stopPropagation) {
	    evt.stopPropagation();
	  }
	  if (evt.cancelBubble !== null) {
	    evt.cancelBubble = true;
	  }
	}
	
	/* eslint-disable prefer-reflect */
	function Throttle(functionToCall, throttleTime) {
	  var wait = false;
	  var trigger = function trigger(context) {
	    if (!wait) {
	      wait = true;
	      setTimeout(function () {
	        if (functionToCall) {
	          functionToCall.call(context);
	        }
	        wait = false;
	      }, throttleTime);
	    }
	  };
	  return {
	    trigger: trigger
	  };
	}
	/* eslint-enable prefer-reflect */

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Alert = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initAlert;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	var _updateBrowser = __webpack_require__(12);
	
	var _updateBrowser2 = _interopRequireDefault(_updateBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TIMEOUT_ALERT_RESIZE_INTERVAL = 10;
	
	var Alert = exports.Alert = function () {
	
	  /**
	   * @param  {Dom}    alert             container to hold modal
	   * @param  {String} closeClickArea    click area for close button
	   */
	  function Alert(alert, config) {
	    _classCallCheck(this, Alert);
	
	    this.alert = alert;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.closeClickArea = alert.querySelector(config.closeSelector);
	    this.autoCloseTime = config.autoCloseTime;
	    this.open = true;
	    this.isInline = config.isInline;
	    this.minimisedCellIndex = config.minimisedCellIndex;
	    this.updatedBrowser = config.updatedBrowser;
	    if (this.isInline) {
	      this.alertOverlay = alert.querySelector('.js-alert-overlay');
	    }
	    // Initialize alert
	    this.init();
	  }
	
	  _createClass(Alert, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      if (this.closeClickArea) {
	        _get__('addEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        _get__('addClasses')(this.alert, ['is-closeable']);
	      }
	      if (this.autoCloseTime) {
	        setTimeout(function () {
	          if (_this.open) {
	            _this.close();
	          }
	        }, this.autoCloseTime);
	      }
	      this.updateMyBrowser();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.isInline) {
	        if (this.minimisedCellIndex && _get__('hasClass')(this.alertOverlay, 'js-pending-alert')) {
	          this.minimiseInlineAlert();
	        } else {
	          _get__('addClasses')(this.alertOverlay, ['hide']);
	          this.open = false;
	        }
	      } else if (this.open) {
	        if (this.closeClickArea) {
	          _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        }
	        this.alert.outerHTML = '';
	        this.open = false;
	      }
	    }
	  }, {
	    key: 'minimiseInlineAlert',
	    value: function minimiseInlineAlert() {
	      var _this2 = this;
	
	      if (this.minimisedCellIndex) {
	        _get__('addClasses')(this.alertOverlay, ['is-minimised']);
	        var targettedCell = this.alert.cells[this.minimisedCellIndex];
	        var rightPos = this.alert.offsetWidth - (targettedCell.offsetLeft + targettedCell.offsetWidth);
	        _get__('setStyles')(this.alertOverlay, {
	          'left': targettedCell.offsetLeft + 'px',
	          'right': rightPos + 'px'
	        });
	        this.windowResizeListener = function () {
	          var updatedRightPos = _this2.alert.offsetWidth - (targettedCell.offsetLeft + targettedCell.offsetWidth);
	          _get__('setStyles')(_this2.alertOverlay, {
	            'left': targettedCell.offsetLeft + 'px',
	            'right': updatedRightPos + 'px'
	          });
	        };
	        this.windowResize = new (_get__('Throttle'))(this.windowResizeListener, _get__('TIMEOUT_ALERT_RESIZE_INTERVAL'));
	        _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	      }
	      this.open = false;
	      if (this.closeClickArea) {
	        _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	      }
	    }
	  }, {
	    key: 'updateMyBrowser',
	    value: function updateMyBrowser() {
	      if (this.updatedBrowser) {
	        if (_typeof(this.updatedBrowser) === 'object') {
	          _get__('updateBrowser')(this.updatedBrowser);
	        } else {
	          _get__('updateBrowser')();
	        }
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.alert) {
	        console.warn('CommonUI - Alert - There\'s no alert found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Alert;
	}();
	
	/**
	 * Creates a new alert instance
	 * @param  {Object} config
	 */
	
	
	function initAlert() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-alert' : _config$selector,
	      _config$closeSelector = config.closeSelector,
	      closeSelector = _config$closeSelector === undefined ? '.js-alert__close' : _config$closeSelector,
	      _config$autoCloseTime = config.autoCloseTime,
	      autoCloseTime = _config$autoCloseTime === undefined ? null : _config$autoCloseTime,
	      _config$inline = config.inline,
	      inline = _config$inline === undefined ? false : _config$inline,
	      _config$minimisedCell = config.minimisedCellIndex,
	      minimisedCellIndex = _config$minimisedCell === undefined ? null : _config$minimisedCell,
	      _config$updatedBrowse = config.updatedBrowser,
	      updatedBrowser = _config$updatedBrowse === undefined ? false : _config$updatedBrowse;
	
	  var alerts = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var alert = _step.value;
	
	        alerts = new (_get__('Alert'))(alert, {
	          closeSelector: closeSelector,
	          autoCloseTime: autoCloseTime,
	          inline: inline,
	          minimisedCellIndex: minimisedCellIndex,
	          updatedBrowser: updatedBrowser
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return alerts;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'TIMEOUT_ALERT_RESIZE_INTERVAL':
	      return TIMEOUT_ALERT_RESIZE_INTERVAL;
	
	    case 'updateBrowser':
	      return _updateBrowser2.default;
	
	    case 'Alert':
	      return Alert;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initAlert === 'undefined' ? 'undefined' : _typeof(initAlert);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initAlert, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initAlert)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable func-style, no-cond-assign, no-console */
	
	
	exports.arrayValueIsInArray = arrayValueIsInArray;
	exports.wrap = wrap;
	exports.unwrap = unwrap;
	exports.getElementWidth = getElementWidth;
	exports.getWidthOfWindow = getWidthOfWindow;
	exports.getHeightOfWindow = getHeightOfWindow;
	exports.offset = offset;
	exports.isOverflowed = isOverflowed;
	exports.hasDirectDescendant = hasDirectDescendant;
	exports.classListContains = classListContains;
	exports.getParentWithSelector = getParentWithSelector;
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.addClasses = addClasses;
	exports.removeClasses = removeClasses;
	exports.setStyles = setStyles;
	exports.clearStyles = clearStyles;
	exports.smoothScroll = smoothScroll;
	exports.htmlFromString = htmlFromString;
	exports.createElement = createElement;
	exports.removeElement = removeElement;
	exports.createElementBefore = createElementBefore;
	exports.fadeOut = fadeOut;
	exports.fadeIn = fadeIn;
	exports.filterByTagName = filterByTagName;
	
	var _easings = __webpack_require__(11);
	
	var easings = _interopRequireWildcard(_easings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var MINUS_ONE = -1;
	function arrayValueIsInArray(arrayValues, arrayMatchValues) {
	  return arrayValues.filter(function (element) {
	    return arrayMatchValues.indexOf(element) > _get__('MINUS_ONE');
	  }).length > 0;
	}
	
	function wrap(element, className) {
	  var wrapper = document.createElement('div');
	  if (className) {
	    wrapper.className = className;
	  }
	  element.parentNode.insertBefore(wrapper, element);
	  wrapper.appendChild(element);
	}
	
	function unwrap(element) {
	  var parent = element.parentNode;
	  var grandParent = parent.parentNode;
	  grandParent.insertBefore(element, parent);
	  grandParent.removeChild(parent);
	}
	
	/**
	 * Returns the width of the specified DOM element.
	 * @param {Element} elem The DOM element that we want the width of.
	 * @return {Number} The width of the specified DOM element.
	 */
	function getElementWidth(elem) {
	  return elem.getBoundingClientRect().width;
	}
	
	function getWidthOfWindow() {
	  var actualWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || document.body.offsetWidth;
	  return actualWidth;
	}
	
	function getHeightOfWindow() {
	  var actualWidth = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || document.body.offsetHeight;
	  return actualWidth;
	}
	
	function offset(element) {
	  var offsetLeft = 0;
	  var offsetTop = 0;
	  if (element.offsetParent) {
	    do {
	      offsetLeft += element.offsetLeft;
	      offsetTop += element.offsetTop;
	    } while (element = element.offsetParent);
	  }
	  return {
	    left: offsetLeft,
	    top: offsetTop
	  };
	}
	
	// Position of left edge relative to frame left courtesy
	// http://www.quirksmode.org/js/findpos.html
	function absleft(element) {
	  var x = 0;
	  for (; element; element = element.offsetParent) {
	    x += element.offsetLeft;
	  }
	  return x;
	}
	
	// Position of top edge relative to top of frame.
	function abstop(element) {
	  var y = 0;
	  for (; element; element = element.offsetParent) {
	    y += element.offsetTop;
	  }
	  return y;
	}
	
	// True if element's bounding rectangle includes a non-zero area
	// the container's bounding rectangle.
	function isOverflowed(element, container) {
	  var cont = container || element.offsetParent;
	  var left = _get__('absleft')(element);
	  var right = left + element.offsetWidth;
	  var top = _get__('abstop')(element);
	  var bottom = top + element.offsetHeight;
	  var cleft = _get__('absleft')(cont);
	  var cright = cleft + cont.offsetWidth;
	  var ctop = _get__('abstop')(cont);
	  var cbottom = ctop + cont.offsetHeight;
	  return left < cleft || top < ctop || right > cright || bottom > cbottom;
	}
	
	function hasDirectDescendant(parent, child) {
	  if (parent.hasChildNodes()) {
	    var children = parent.childNodes;
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].isEqualNode(child)) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function classListContains(cssClassList, cssClassMatches) {
	  var thisContains = false;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = cssClassMatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var cssClass = _step.value;
	
	      if (!thisContains) {
	        thisContains = cssClassList.contains(cssClass);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return thisContains;
	}
	
	function getParentWithSelector(element, selectors) {
	  if (!element.parentNode) {
	    return false;
	  } else if (element.parentNode.classList && _get__('classListContains')(element.parentNode.classList, selectors)) {
	    return element.parentNode;
	  }
	  return _get__('getParentWithSelector')(element.parentNode, selectors);
	}
	
	/**
	 * Checks the specified DOM element for the presence of the specified CSS class.
	 * @param {Element} elem The DOM element on which we are checking for the presence of the CSS class.
	 * @param {String} cssClass The CSS class to check for on the specified element.
	 * @return {boolean}
	 */
	function hasClass(elem, cssClass) {
	  return elem.classList.contains(cssClass.trim());
	}
	
	/**
	 * Adds the specified CSS class to the specified DOM element.
	 * @param {Element} elem The DOM element to add the specified CSS class to.
	 * @param {String} cssClass The CSS class to be added.
	 * @return void
	 */
	function addClass(elem, cssClass) {
	  elem.classList.add(cssClass.trim());
	}
	
	/**
	 * Removes the specified CSS class from the specified DOM element.
	 * @param {Element} elem The DOM element to remove from the specified CSS class.
	 * @param {String} cssClass The CSS class to be removed.
	 * @return void
	 */
	function removeClass(elem, cssClass) {
	  elem.classList.remove(cssClass.trim());
	}
	
	/**
	 * As Internet Explorer does not support adding of multiple classes to an element via Element.classList.add()
	 * this utility method provides the ability to add multiple classes in one operation.
	 * @param elem
	 * @param classes
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
	 * @see http://caniuse.com/#search=classList
	 */
	function addClasses(elem, classes) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = classes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var cls = _step2.value;
	
	      _get__('addClass')(elem, cls);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	/**
	 * As Internet Explorer does not support removing of multiple classes from an element via Element.classList.remove()
	 * this utility method provides the ability to remove multiple classes in one operation.
	 * @param elem
	 * @param classes
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
	 * @see http://caniuse.com/#search=classList
	 */
	function removeClasses(elem, classes) {
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;
	
	  try {
	    for (var _iterator3 = classes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var cls = _step3.value;
	
	      _get__('removeClass')(elem, cls);
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }
	}
	
	/**
	 * Utility method for applying multiple inline styles to an element in one operation.
	 * @param {Element} element The applied being styled.
	 * @param {Object} styles An object defining the styles to be applied.
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (key) {
	    if (key === 'transform') {
	      element.style[key] = 'translateX(' + styles[key] + '%)';
	    }
	    element.style[key] = styles[key];
	  });
	}
	
	/**
	 * Clears all inline styles from the specified DOM element.
	 * @param {Element} element The DOM element on which the inline styles are to be removed.
	 */
	function clearStyles(element) {
	  element.style.cssText = '';
	}
	
	/**
	 * Provides the ability to animate the scrolling of an overflowed element either vertically or horizontally.
	 * @param element
	 * @param options
	 */
	function smoothScroll(element, options) {
	  var milliseconds = 1000;
	  var seconds = 60;
	  var requestAnimFrame = function requestAnimFrame() {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function reqAF(cbk) {
	      window.setTimeout(cbk, milliseconds / seconds);
	    };
	  }();
	  var defaults = {
	    to: 0,
	    duration: 250,
	    axis: 'horizontal',
	    easing: 'easeInOutQuad'
	  };
	  var settings = _extends({}, defaults, options);
	  var direction = settings.axis === 'horizontal' ? 'scrollLeft' : 'scrollTop';
	  var start = element[direction];
	  var change = settings.to - start;
	  var animationStart = Number(new Date());
	  var animating = true;
	  var animateScroll = function animateScroll() {
	    if (!animating) {
	      if (settings.cbk) {
	        settings.cbk();
	      }
	      return;
	    }
	    requestAnimFrame(animateScroll);
	    var now = Number(new Date());
	    element[direction] = Math.floor(_get__('easings')[settings.easing](now - animationStart, start, change, settings.duration));
	
	    if (now > animationStart + settings.duration) {
	      element[direction] = settings.to;
	      animating = false;
	    }
	  };
	  requestAnimFrame(animateScroll);
	}
	
	function htmlFromString(html) {
	  var div = document.createElement('div');
	  div.innerHTML = html.trim();
	
	  // Change this to div.childNodes to support multiple top-level nodes
	  return div.firstChild;
	}
	
	function createElement(elementType, targetElement) {
	  var element = document.createElement(elementType);
	  targetElement.appendChild(element);
	  return element;
	}
	
	function removeElement(element) {
	  var parent = element.parentElement;
	  parent.removeChild(element);
	}
	
	function createElementBefore(elementType, targetElement, beforeElement) {
	  var element = document.createElement(elementType);
	  targetElement.insertBefore(element, beforeElement);
	  return element;
	}
	
	function fadeOut(element) {
	  var OPACITY_INCREMENT = 0.05;
	  (function fade() {
	    if ((element.style.opacity -= OPACITY_INCREMENT) <= 0) {
	      element.style.display = 'none';
	      element.style.opacity = 0;
	    } else {
	      requestAnimationFrame(fade);
	    }
	  })();
	}
	
	function fadeIn(element, display) {
	  var OPACITY_INCREMENT = 0.05;
	  element.style.display = display || 'block';
	  (function fade() {
	    var val = parseFloat(element.style.opacity);
	    if (!((val += OPACITY_INCREMENT) > 1)) {
	      element.style.opacity = val;
	      requestAnimationFrame(fade);
	    }
	  })();
	}
	
	function filterByTagName(htmlCollection, tagname) {
	  var filtered = [];
	  tagname = tagname.toLowerCase();
	
	  for (var i = 0; i < htmlCollection.length; i++) {
	    if (htmlCollection.item(i).tagName.toLowerCase() === tagname) {
	      filtered.push(htmlCollection.item(i));
	    }
	  }
	  return filtered;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'MINUS_ONE':
	      return MINUS_ONE;

	    case 'absleft':
	      return absleft;

	    case 'abstop':
	      return abstop;

	    case 'classListContains':
	      return classListContains;

	    case 'getParentWithSelector':
	      return getParentWithSelector;

	    case 'addClass':
	      return addClass;

	    case 'removeClass':
	      return removeClass;

	    case 'easings':
	      return _filterWildcardImport__(easings);
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	exports.default = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linear = linear;
	exports.easeInQuad = easeInQuad;
	exports.easeOutQuad = easeOutQuad;
	exports.easeInOutQuad = easeInOutQuad;
	exports.easeInCubic = easeInCubic;
	exports.easeOutCubic = easeOutCubic;
	exports.easeInOutCubic = easeInOutCubic;
	exports.easeInQuart = easeInQuart;
	exports.easeOutQuart = easeOutQuart;
	exports.easeInOutQuart = easeInOutQuart;
	exports.easeInQuint = easeInQuint;
	exports.easeOutQuint = easeOutQuint;
	exports.easeInOutQuint = easeInOutQuint;
	/* eslint-disable func-style */
	/**
	 * Easing Functions - inspired from http://gizma.com/easing/
	 */
	
	/**
	 * no easing, no acceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function linear(time, begin, change, duration) {
	  return change * time / duration + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInQuad(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutQuad(time, begin, change, duration) {
	  time /= duration;
	  return -change * time * (time - 2) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutQuad(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time + begin;
	  }
	  time--;
	  return -change / 2 * (time * (time - 2) - 1) + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInCubic(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutCubic(time, begin, change, duration) {
	  time /= duration;
	  time--;
	  return change * (time * time * time + 1) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutCubic(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time * time + begin;
	  }
	  time -= 2;
	  return change / 2 * (time * time * time + 2) + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInQuart(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutQuart(time, begin, change, duration) {
	  time /= duration;
	  time--;
	  return -change * (time * time * time * time - 1) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutQuart(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time * time * time + begin;
	  }
	  time -= 2;
	  return -change / 2 * (time * time * time * time - 2) + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInQuint(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time * time * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutQuint(time, begin, change, duration) {
	  time /= duration;
	  time--;
	  return change * (time * time * time * time * time + 1) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutQuint(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time * time * time * time + begin;
	  }
	  time -= 2;
	  return change / 2 * (time * time * time * time * time + 2) + begin;
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = updateBrowser;
	
	var _detectBrowser = __webpack_require__(13);
	
	var _semver = __webpack_require__(15);
	
	var _semver2 = _interopRequireDefault(_semver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateBrowser() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    chrome: '71.0.0',
	    safari: '12.0.0',
	    ie: '10.0.0',
	    firefox: '64.0.0'
	  };
	
	  var browser = _get__('detect')();
	  var updateAlert = document.querySelector('.alert--update-browser');
	  var browsers = {
	    chrome: 'chrome',
	    safari: 'safari',
	    firefox: 'firefox',
	    ie: 'ie'
	  };
	  if (browser.name === browsers.chrome && _get__('semver').lt(browser.version, config.chrome)) {
	    updateAlert.style.display = 'block';
	  }
	
	  if (browser.name === browsers.safari && _get__('semver').lt(browser.version, config.safari)) {
	    updateAlert.style.display = 'block';
	  }
	
	  if (browser.name === browsers.firefox && _get__('semver').lt(browser.version, config.firefox)) {
	    updateAlert.style.display = 'block';
	  }
	
	  if (browser.name === browsers.ie && _get__('semver').lt(browser.version, config.ie)) {
	    updateAlert.style.display = 'block';
	  }
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'detect':
	      return _detectBrowser.detect;
	
	    case 'semver':
	      return _semver2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof updateBrowser === 'undefined' ? 'undefined' : _typeof(updateBrowser);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(updateBrowser, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(updateBrowser)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var BrowserInfo = /** @class */ (function () {
	    function BrowserInfo(name, version, os) {
	        this.name = name;
	        this.version = version;
	        this.os = os;
	    }
	    return BrowserInfo;
	}());
	exports.BrowserInfo = BrowserInfo;
	var NodeInfo = /** @class */ (function () {
	    function NodeInfo(version) {
	        this.version = version;
	        this.name = 'node';
	        this.os = process.platform;
	    }
	    return NodeInfo;
	}());
	exports.NodeInfo = NodeInfo;
	var BotInfo = /** @class */ (function () {
	    function BotInfo() {
	        this.bot = true; // NOTE: deprecated test name instead
	        this.name = 'bot';
	        this.version = null;
	        this.os = null;
	    }
	    return BotInfo;
	}());
	exports.BotInfo = BotInfo;
	// tslint:disable-next-line:max-line-length
	var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
	var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
	var REQUIRED_VERSION_PARTS = 3;
	var userAgentRules = [
	    ['aol', /AOLShield\/([0-9\._]+)/],
	    ['edge', /Edge\/([0-9\._]+)/],
	    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
	    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
	    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
	    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
	    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
	    ['silk', /\bSilk\/([0-9._-]+)\b/],
	    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
	    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
	    ['edge-chromium', /Edg\/([0-9\.]+)/],
	    [
	        'chromium-webview',
	        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
	    ],
	    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
	    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
	    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
	    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
	    ['fxios', /FxiOS\/([0-9\.]+)/],
	    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
	    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
	    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
	    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
	    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
	    ['ie', /MSIE\s(7\.0)/],
	    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
	    ['android', /Android\s([0-9\.]+)/],
	    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
	    ['safari', /Version\/([0-9\._]+).*Safari/],
	    ['facebook', /FBAV\/([0-9\.]+)/],
	    ['instagram', /Instagram\s([0-9\.]+)/],
	    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
	    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
	    ['searchbot', SEARCHBOX_UA_REGEX],
	];
	var operatingSystemRules = [
	    ['iOS', /iP(hone|od|ad)/],
	    ['Android OS', /Android/],
	    ['BlackBerry OS', /BlackBerry|BB10/],
	    ['Windows Mobile', /IEMobile/],
	    ['Amazon OS', /Kindle/],
	    ['Windows 3.11', /Win16/],
	    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
	    ['Windows 98', /(Windows 98)|(Win98)/],
	    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
	    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
	    ['Windows Server 2003', /(Windows NT 5.2)/],
	    ['Windows Vista', /(Windows NT 6.0)/],
	    ['Windows 7', /(Windows NT 6.1)/],
	    ['Windows 8', /(Windows NT 6.2)/],
	    ['Windows 8.1', /(Windows NT 6.3)/],
	    ['Windows 10', /(Windows NT 10.0)/],
	    ['Windows ME', /Windows ME/],
	    ['Open BSD', /OpenBSD/],
	    ['Sun OS', /SunOS/],
	    ['Chrome OS', /CrOS/],
	    ['Linux', /(Linux)|(X11)/],
	    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
	    ['QNX', /QNX/],
	    ['BeOS', /BeOS/],
	    ['OS/2', /OS\/2/],
	    ['Search Bot', SEARCHBOT_OS_REGEX],
	];
	function detect(userAgent) {
	    if (!!userAgent) {
	        return parseUserAgent(userAgent);
	    }
	    if (typeof navigator !== 'undefined') {
	        return parseUserAgent(navigator.userAgent);
	    }
	    return getNodeVersion();
	}
	exports.detect = detect;
	function parseUserAgent(ua) {
	    // opted for using reduce here rather than Array#first with a regex.test call
	    // this is primarily because using the reduce we only perform the regex
	    // execution once rather than once for the test and for the exec again below
	    // probably something that needs to be benchmarked though
	    var matchedRule = ua !== '' &&
	        userAgentRules.reduce(function (matched, _a) {
	            var browser = _a[0], regex = _a[1];
	            if (matched) {
	                return matched;
	            }
	            var uaMatch = regex.exec(ua);
	            return !!uaMatch && [browser, uaMatch];
	        }, false);
	    if (!matchedRule) {
	        return null;
	    }
	    var name = matchedRule[0], match = matchedRule[1];
	    if (name === 'searchbot') {
	        return new BotInfo();
	    }
	    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
	    if (versionParts) {
	        if (versionParts.length < REQUIRED_VERSION_PARTS) {
	            versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
	        }
	    }
	    else {
	        versionParts = [];
	    }
	    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
	}
	exports.parseUserAgent = parseUserAgent;
	function detectOS(ua) {
	    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
	        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
	        var match = regex.test(ua);
	        if (match) {
	            return os;
	        }
	    }
	    return null;
	}
	exports.detectOS = detectOS;
	function getNodeVersion() {
	    var isNode = typeof process !== 'undefined' && process.version;
	    return isNode ? new NodeInfo(process.version.slice(1)) : null;
	}
	exports.getNodeVersion = getNodeVersion;
	function createVersionParts(count) {
	    var output = [];
	    for (var ii = 0; ii < count; ii++) {
	        output.push('0');
	    }
	    return output;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer
	
	var debug
	/* istanbul ignore next */
	if (typeof process === 'object' &&
	    ({"NODE_ENV":"production"}) &&
	    ({"NODE_ENV":"production"}).NODE_DEBUG &&
	    /\bsemver\b/i.test(({"NODE_ENV":"production"}).NODE_DEBUG)) {
	  debug = function () {
	    var args = Array.prototype.slice.call(arguments, 0)
	    args.unshift('SEMVER')
	    console.log.apply(console, args)
	  }
	} else {
	  debug = function () {}
	}
	
	// Note: this is the semver.org version of the spec that it implements
	// Not necessarily the package version of this code.
	exports.SEMVER_SPEC_VERSION = '2.0.0'
	
	var MAX_LENGTH = 256
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
	  /* istanbul ignore next */ 9007199254740991
	
	// Max safe segment length for coercion.
	var MAX_SAFE_COMPONENT_LENGTH = 16
	
	// The actual regexps go on exports.re
	var re = exports.re = []
	var src = exports.src = []
	var R = 0
	
	// The following Regular Expressions can be used for tokenizing,
	// validating, and parsing SemVer version strings.
	
	// ## Numeric Identifier
	// A single `0`, or a non-zero digit followed by zero or more digits.
	
	var NUMERICIDENTIFIER = R++
	src[NUMERICIDENTIFIER] = '0|[1-9]\\d*'
	var NUMERICIDENTIFIERLOOSE = R++
	src[NUMERICIDENTIFIERLOOSE] = '[0-9]+'
	
	// ## Non-numeric Identifier
	// Zero or more digits, followed by a letter or hyphen, and then zero or
	// more letters, digits, or hyphens.
	
	var NONNUMERICIDENTIFIER = R++
	src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*'
	
	// ## Main Version
	// Three dot-separated numeric identifiers.
	
	var MAINVERSION = R++
	src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')'
	
	var MAINVERSIONLOOSE = R++
	src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')'
	
	// ## Pre-release Version Identifier
	// A numeric identifier, or a non-numeric identifier.
	
	var PRERELEASEIDENTIFIER = R++
	src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
	                            '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	var PRERELEASEIDENTIFIERLOOSE = R++
	src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
	                                 '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	// ## Pre-release Version
	// Hyphen, followed by one or more dot-separated pre-release version
	// identifiers.
	
	var PRERELEASE = R++
	src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
	                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))'
	
	var PRERELEASELOOSE = R++
	src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
	                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))'
	
	// ## Build Metadata Identifier
	// Any combination of digits, letters, or hyphens.
	
	var BUILDIDENTIFIER = R++
	src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+'
	
	// ## Build Metadata
	// Plus sign, followed by one or more period-separated build metadata
	// identifiers.
	
	var BUILD = R++
	src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
	             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))'
	
	// ## Full Version String
	// A main version, followed optionally by a pre-release version and
	// build metadata.
	
	// Note that the only major, minor, patch, and pre-release sections of
	// the version string are capturing groups.  The build metadata is not a
	// capturing group, because it should not ever be used in version
	// comparison.
	
	var FULL = R++
	var FULLPLAIN = 'v?' + src[MAINVERSION] +
	                src[PRERELEASE] + '?' +
	                src[BUILD] + '?'
	
	src[FULL] = '^' + FULLPLAIN + '$'
	
	// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
	// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
	// common in the npm registry.
	var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
	                 src[PRERELEASELOOSE] + '?' +
	                 src[BUILD] + '?'
	
	var LOOSE = R++
	src[LOOSE] = '^' + LOOSEPLAIN + '$'
	
	var GTLT = R++
	src[GTLT] = '((?:<|>)?=?)'
	
	// Something like "2.*" or "1.2.x".
	// Note that "x.x" is a valid xRange identifer, meaning "any version"
	// Only the first item is strictly required.
	var XRANGEIDENTIFIERLOOSE = R++
	src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*'
	var XRANGEIDENTIFIER = R++
	src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*'
	
	var XRANGEPLAIN = R++
	src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:' + src[PRERELEASE] + ')?' +
	                   src[BUILD] + '?' +
	                   ')?)?'
	
	var XRANGEPLAINLOOSE = R++
	src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:' + src[PRERELEASELOOSE] + ')?' +
	                        src[BUILD] + '?' +
	                        ')?)?'
	
	var XRANGE = R++
	src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$'
	var XRANGELOOSE = R++
	src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$'
	
	// Coercion.
	// Extract anything that could conceivably be a part of a valid semver
	var COERCE = R++
	src[COERCE] = '(?:^|[^\\d])' +
	              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:$|[^\\d])'
	
	// Tilde ranges.
	// Meaning is "reasonably at or greater than"
	var LONETILDE = R++
	src[LONETILDE] = '(?:~>?)'
	
	var TILDETRIM = R++
	src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+'
	re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g')
	var tildeTrimReplace = '$1~'
	
	var TILDE = R++
	src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$'
	var TILDELOOSE = R++
	src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$'
	
	// Caret ranges.
	// Meaning is "at least and backwards compatible with"
	var LONECARET = R++
	src[LONECARET] = '(?:\\^)'
	
	var CARETTRIM = R++
	src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+'
	re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g')
	var caretTrimReplace = '$1^'
	
	var CARET = R++
	src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$'
	var CARETLOOSE = R++
	src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$'
	
	// A simple gt/lt/eq thing, or just "" to indicate "any version"
	var COMPARATORLOOSE = R++
	src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$'
	var COMPARATOR = R++
	src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$'
	
	// An expression to strip any whitespace between the gtlt and the thing
	// it modifies, so that `> 1.2.3` ==> `>1.2.3`
	var COMPARATORTRIM = R++
	src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
	                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')'
	
	// this one has to use the /g flag
	re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g')
	var comparatorTrimReplace = '$1$2$3'
	
	// Something like `1.2.3 - 1.2.4`
	// Note that these all use the loose form, because they'll be
	// checked against either the strict or loose comparator form
	// later.
	var HYPHENRANGE = R++
	src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
	                   '\\s+-\\s+' +
	                   '(' + src[XRANGEPLAIN] + ')' +
	                   '\\s*$'
	
	var HYPHENRANGELOOSE = R++
	src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s+-\\s+' +
	                        '(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s*$'
	
	// Star ranges basically just allow anything at all.
	var STAR = R++
	src[STAR] = '(<|>)?=?\\s*\\*'
	
	// Compile to actual regexp objects.
	// All are flag-free, unless they were created above with a flag.
	for (var i = 0; i < R; i++) {
	  debug(i, src[i])
	  if (!re[i]) {
	    re[i] = new RegExp(src[i])
	  }
	}
	
	exports.parse = parse
	function parse (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  if (version.length > MAX_LENGTH) {
	    return null
	  }
	
	  var r = options.loose ? re[LOOSE] : re[FULL]
	  if (!r.test(version)) {
	    return null
	  }
	
	  try {
	    return new SemVer(version, options)
	  } catch (er) {
	    return null
	  }
	}
	
	exports.valid = valid
	function valid (version, options) {
	  var v = parse(version, options)
	  return v ? v.version : null
	}
	
	exports.clean = clean
	function clean (version, options) {
	  var s = parse(version.trim().replace(/^[=v]+/, ''), options)
	  return s ? s.version : null
	}
	
	exports.SemVer = SemVer
	
	function SemVer (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	  if (version instanceof SemVer) {
	    if (version.loose === options.loose) {
	      return version
	    } else {
	      version = version.version
	    }
	  } else if (typeof version !== 'string') {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  if (version.length > MAX_LENGTH) {
	    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')
	  }
	
	  if (!(this instanceof SemVer)) {
	    return new SemVer(version, options)
	  }
	
	  debug('SemVer', version, options)
	  this.options = options
	  this.loose = !!options.loose
	
	  var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL])
	
	  if (!m) {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  this.raw = version
	
	  // these are actually numbers
	  this.major = +m[1]
	  this.minor = +m[2]
	  this.patch = +m[3]
	
	  if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
	    throw new TypeError('Invalid major version')
	  }
	
	  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
	    throw new TypeError('Invalid minor version')
	  }
	
	  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
	    throw new TypeError('Invalid patch version')
	  }
	
	  // numberify any prerelease numeric ids
	  if (!m[4]) {
	    this.prerelease = []
	  } else {
	    this.prerelease = m[4].split('.').map(function (id) {
	      if (/^[0-9]+$/.test(id)) {
	        var num = +id
	        if (num >= 0 && num < MAX_SAFE_INTEGER) {
	          return num
	        }
	      }
	      return id
	    })
	  }
	
	  this.build = m[5] ? m[5].split('.') : []
	  this.format()
	}
	
	SemVer.prototype.format = function () {
	  this.version = this.major + '.' + this.minor + '.' + this.patch
	  if (this.prerelease.length) {
	    this.version += '-' + this.prerelease.join('.')
	  }
	  return this.version
	}
	
	SemVer.prototype.toString = function () {
	  return this.version
	}
	
	SemVer.prototype.compare = function (other) {
	  debug('SemVer.compare', this.version, this.options, other)
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return this.compareMain(other) || this.comparePre(other)
	}
	
	SemVer.prototype.compareMain = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return compareIdentifiers(this.major, other.major) ||
	         compareIdentifiers(this.minor, other.minor) ||
	         compareIdentifiers(this.patch, other.patch)
	}
	
	SemVer.prototype.comparePre = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  // NOT having a prerelease is > having one
	  if (this.prerelease.length && !other.prerelease.length) {
	    return -1
	  } else if (!this.prerelease.length && other.prerelease.length) {
	    return 1
	  } else if (!this.prerelease.length && !other.prerelease.length) {
	    return 0
	  }
	
	  var i = 0
	  do {
	    var a = this.prerelease[i]
	    var b = other.prerelease[i]
	    debug('prerelease compare', i, a, b)
	    if (a === undefined && b === undefined) {
	      return 0
	    } else if (b === undefined) {
	      return 1
	    } else if (a === undefined) {
	      return -1
	    } else if (a === b) {
	      continue
	    } else {
	      return compareIdentifiers(a, b)
	    }
	  } while (++i)
	}
	
	// preminor will bump the version up to the next minor release, and immediately
	// down to pre-release. premajor and prepatch work the same way.
	SemVer.prototype.inc = function (release, identifier) {
	  switch (release) {
	    case 'premajor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor = 0
	      this.major++
	      this.inc('pre', identifier)
	      break
	    case 'preminor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor++
	      this.inc('pre', identifier)
	      break
	    case 'prepatch':
	      // If this is already a prerelease, it will bump to the next version
	      // drop any prereleases that might already exist, since they are not
	      // relevant at this point.
	      this.prerelease.length = 0
	      this.inc('patch', identifier)
	      this.inc('pre', identifier)
	      break
	    // If the input is a non-prerelease version, this acts the same as
	    // prepatch.
	    case 'prerelease':
	      if (this.prerelease.length === 0) {
	        this.inc('patch', identifier)
	      }
	      this.inc('pre', identifier)
	      break
	
	    case 'major':
	      // If this is a pre-major version, bump up to the same major version.
	      // Otherwise increment major.
	      // 1.0.0-5 bumps to 1.0.0
	      // 1.1.0 bumps to 2.0.0
	      if (this.minor !== 0 ||
	          this.patch !== 0 ||
	          this.prerelease.length === 0) {
	        this.major++
	      }
	      this.minor = 0
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'minor':
	      // If this is a pre-minor version, bump up to the same minor version.
	      // Otherwise increment minor.
	      // 1.2.0-5 bumps to 1.2.0
	      // 1.2.1 bumps to 1.3.0
	      if (this.patch !== 0 || this.prerelease.length === 0) {
	        this.minor++
	      }
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'patch':
	      // If this is not a pre-release version, it will increment the patch.
	      // If it is a pre-release it will bump up to the same patch version.
	      // 1.2.0-5 patches to 1.2.0
	      // 1.2.0 patches to 1.2.1
	      if (this.prerelease.length === 0) {
	        this.patch++
	      }
	      this.prerelease = []
	      break
	    // This probably shouldn't be used publicly.
	    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
	    case 'pre':
	      if (this.prerelease.length === 0) {
	        this.prerelease = [0]
	      } else {
	        var i = this.prerelease.length
	        while (--i >= 0) {
	          if (typeof this.prerelease[i] === 'number') {
	            this.prerelease[i]++
	            i = -2
	          }
	        }
	        if (i === -1) {
	          // didn't increment anything
	          this.prerelease.push(0)
	        }
	      }
	      if (identifier) {
	        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
	        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
	        if (this.prerelease[0] === identifier) {
	          if (isNaN(this.prerelease[1])) {
	            this.prerelease = [identifier, 0]
	          }
	        } else {
	          this.prerelease = [identifier, 0]
	        }
	      }
	      break
	
	    default:
	      throw new Error('invalid increment argument: ' + release)
	  }
	  this.format()
	  this.raw = this.version
	  return this
	}
	
	exports.inc = inc
	function inc (version, release, loose, identifier) {
	  if (typeof (loose) === 'string') {
	    identifier = loose
	    loose = undefined
	  }
	
	  try {
	    return new SemVer(version, loose).inc(release, identifier).version
	  } catch (er) {
	    return null
	  }
	}
	
	exports.diff = diff
	function diff (version1, version2) {
	  if (eq(version1, version2)) {
	    return null
	  } else {
	    var v1 = parse(version1)
	    var v2 = parse(version2)
	    var prefix = ''
	    if (v1.prerelease.length || v2.prerelease.length) {
	      prefix = 'pre'
	      var defaultResult = 'prerelease'
	    }
	    for (var key in v1) {
	      if (key === 'major' || key === 'minor' || key === 'patch') {
	        if (v1[key] !== v2[key]) {
	          return prefix + key
	        }
	      }
	    }
	    return defaultResult // may be undefined
	  }
	}
	
	exports.compareIdentifiers = compareIdentifiers
	
	var numeric = /^[0-9]+$/
	function compareIdentifiers (a, b) {
	  var anum = numeric.test(a)
	  var bnum = numeric.test(b)
	
	  if (anum && bnum) {
	    a = +a
	    b = +b
	  }
	
	  return a === b ? 0
	    : (anum && !bnum) ? -1
	    : (bnum && !anum) ? 1
	    : a < b ? -1
	    : 1
	}
	
	exports.rcompareIdentifiers = rcompareIdentifiers
	function rcompareIdentifiers (a, b) {
	  return compareIdentifiers(b, a)
	}
	
	exports.major = major
	function major (a, loose) {
	  return new SemVer(a, loose).major
	}
	
	exports.minor = minor
	function minor (a, loose) {
	  return new SemVer(a, loose).minor
	}
	
	exports.patch = patch
	function patch (a, loose) {
	  return new SemVer(a, loose).patch
	}
	
	exports.compare = compare
	function compare (a, b, loose) {
	  return new SemVer(a, loose).compare(new SemVer(b, loose))
	}
	
	exports.compareLoose = compareLoose
	function compareLoose (a, b) {
	  return compare(a, b, true)
	}
	
	exports.rcompare = rcompare
	function rcompare (a, b, loose) {
	  return compare(b, a, loose)
	}
	
	exports.sort = sort
	function sort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.compare(a, b, loose)
	  })
	}
	
	exports.rsort = rsort
	function rsort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.rcompare(a, b, loose)
	  })
	}
	
	exports.gt = gt
	function gt (a, b, loose) {
	  return compare(a, b, loose) > 0
	}
	
	exports.lt = lt
	function lt (a, b, loose) {
	  return compare(a, b, loose) < 0
	}
	
	exports.eq = eq
	function eq (a, b, loose) {
	  return compare(a, b, loose) === 0
	}
	
	exports.neq = neq
	function neq (a, b, loose) {
	  return compare(a, b, loose) !== 0
	}
	
	exports.gte = gte
	function gte (a, b, loose) {
	  return compare(a, b, loose) >= 0
	}
	
	exports.lte = lte
	function lte (a, b, loose) {
	  return compare(a, b, loose) <= 0
	}
	
	exports.cmp = cmp
	function cmp (a, op, b, loose) {
	  switch (op) {
	    case '===':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a === b
	
	    case '!==':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a !== b
	
	    case '':
	    case '=':
	    case '==':
	      return eq(a, b, loose)
	
	    case '!=':
	      return neq(a, b, loose)
	
	    case '>':
	      return gt(a, b, loose)
	
	    case '>=':
	      return gte(a, b, loose)
	
	    case '<':
	      return lt(a, b, loose)
	
	    case '<=':
	      return lte(a, b, loose)
	
	    default:
	      throw new TypeError('Invalid operator: ' + op)
	  }
	}
	
	exports.Comparator = Comparator
	function Comparator (comp, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (comp instanceof Comparator) {
	    if (comp.loose === !!options.loose) {
	      return comp
	    } else {
	      comp = comp.value
	    }
	  }
	
	  if (!(this instanceof Comparator)) {
	    return new Comparator(comp, options)
	  }
	
	  debug('comparator', comp, options)
	  this.options = options
	  this.loose = !!options.loose
	  this.parse(comp)
	
	  if (this.semver === ANY) {
	    this.value = ''
	  } else {
	    this.value = this.operator + this.semver.version
	  }
	
	  debug('comp', this)
	}
	
	var ANY = {}
	Comparator.prototype.parse = function (comp) {
	  var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
	  var m = comp.match(r)
	
	  if (!m) {
	    throw new TypeError('Invalid comparator: ' + comp)
	  }
	
	  this.operator = m[1]
	  if (this.operator === '=') {
	    this.operator = ''
	  }
	
	  // if it literally is just '>' or '' then allow anything.
	  if (!m[2]) {
	    this.semver = ANY
	  } else {
	    this.semver = new SemVer(m[2], this.options.loose)
	  }
	}
	
	Comparator.prototype.toString = function () {
	  return this.value
	}
	
	Comparator.prototype.test = function (version) {
	  debug('Comparator.test', version, this.options.loose)
	
	  if (this.semver === ANY) {
	    return true
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  return cmp(version, this.operator, this.semver, this.options)
	}
	
	Comparator.prototype.intersects = function (comp, options) {
	  if (!(comp instanceof Comparator)) {
	    throw new TypeError('a Comparator is required')
	  }
	
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  var rangeTmp
	
	  if (this.operator === '') {
	    rangeTmp = new Range(comp.value, options)
	    return satisfies(this.value, rangeTmp, options)
	  } else if (comp.operator === '') {
	    rangeTmp = new Range(this.value, options)
	    return satisfies(comp.semver, rangeTmp, options)
	  }
	
	  var sameDirectionIncreasing =
	    (this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '>=' || comp.operator === '>')
	  var sameDirectionDecreasing =
	    (this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '<=' || comp.operator === '<')
	  var sameSemVer = this.semver.version === comp.semver.version
	  var differentDirectionsInclusive =
	    (this.operator === '>=' || this.operator === '<=') &&
	    (comp.operator === '>=' || comp.operator === '<=')
	  var oppositeDirectionsLessThan =
	    cmp(this.semver, '<', comp.semver, options) &&
	    ((this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '<=' || comp.operator === '<'))
	  var oppositeDirectionsGreaterThan =
	    cmp(this.semver, '>', comp.semver, options) &&
	    ((this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '>=' || comp.operator === '>'))
	
	  return sameDirectionIncreasing || sameDirectionDecreasing ||
	    (sameSemVer && differentDirectionsInclusive) ||
	    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan
	}
	
	exports.Range = Range
	function Range (range, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (range instanceof Range) {
	    if (range.loose === !!options.loose &&
	        range.includePrerelease === !!options.includePrerelease) {
	      return range
	    } else {
	      return new Range(range.raw, options)
	    }
	  }
	
	  if (range instanceof Comparator) {
	    return new Range(range.value, options)
	  }
	
	  if (!(this instanceof Range)) {
	    return new Range(range, options)
	  }
	
	  this.options = options
	  this.loose = !!options.loose
	  this.includePrerelease = !!options.includePrerelease
	
	  // First, split based on boolean or ||
	  this.raw = range
	  this.set = range.split(/\s*\|\|\s*/).map(function (range) {
	    return this.parseRange(range.trim())
	  }, this).filter(function (c) {
	    // throw out any that are not relevant for whatever reason
	    return c.length
	  })
	
	  if (!this.set.length) {
	    throw new TypeError('Invalid SemVer Range: ' + range)
	  }
	
	  this.format()
	}
	
	Range.prototype.format = function () {
	  this.range = this.set.map(function (comps) {
	    return comps.join(' ').trim()
	  }).join('||').trim()
	  return this.range
	}
	
	Range.prototype.toString = function () {
	  return this.range
	}
	
	Range.prototype.parseRange = function (range) {
	  var loose = this.options.loose
	  range = range.trim()
	  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
	  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE]
	  range = range.replace(hr, hyphenReplace)
	  debug('hyphen replace', range)
	  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
	  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace)
	  debug('comparator trim', range, re[COMPARATORTRIM])
	
	  // `~ 1.2.3` => `~1.2.3`
	  range = range.replace(re[TILDETRIM], tildeTrimReplace)
	
	  // `^ 1.2.3` => `^1.2.3`
	  range = range.replace(re[CARETTRIM], caretTrimReplace)
	
	  // normalize spaces
	  range = range.split(/\s+/).join(' ')
	
	  // At this point, the range is completely trimmed and
	  // ready to be split into comparators.
	
	  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
	  var set = range.split(' ').map(function (comp) {
	    return parseComparator(comp, this.options)
	  }, this).join(' ').split(/\s+/)
	  if (this.options.loose) {
	    // in loose mode, throw out any that are not valid comparators
	    set = set.filter(function (comp) {
	      return !!comp.match(compRe)
	    })
	  }
	  set = set.map(function (comp) {
	    return new Comparator(comp, this.options)
	  }, this)
	
	  return set
	}
	
	Range.prototype.intersects = function (range, options) {
	  if (!(range instanceof Range)) {
	    throw new TypeError('a Range is required')
	  }
	
	  return this.set.some(function (thisComparators) {
	    return thisComparators.every(function (thisComparator) {
	      return range.set.some(function (rangeComparators) {
	        return rangeComparators.every(function (rangeComparator) {
	          return thisComparator.intersects(rangeComparator, options)
	        })
	      })
	    })
	  })
	}
	
	// Mostly just for testing and legacy API reasons
	exports.toComparators = toComparators
	function toComparators (range, options) {
	  return new Range(range, options).set.map(function (comp) {
	    return comp.map(function (c) {
	      return c.value
	    }).join(' ').trim().split(' ')
	  })
	}
	
	// comprised of xranges, tildes, stars, and gtlt's at this point.
	// already replaced the hyphen ranges
	// turn into a set of JUST comparators.
	function parseComparator (comp, options) {
	  debug('comp', comp, options)
	  comp = replaceCarets(comp, options)
	  debug('caret', comp)
	  comp = replaceTildes(comp, options)
	  debug('tildes', comp)
	  comp = replaceXRanges(comp, options)
	  debug('xrange', comp)
	  comp = replaceStars(comp, options)
	  debug('stars', comp)
	  return comp
	}
	
	function isX (id) {
	  return !id || id.toLowerCase() === 'x' || id === '*'
	}
	
	// ~, ~> --> * (any, kinda silly)
	// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
	// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
	// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
	// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
	// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
	function replaceTildes (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceTilde(comp, options)
	  }).join(' ')
	}
	
	function replaceTilde (comp, options) {
	  var r = options.loose ? re[TILDELOOSE] : re[TILDE]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('tilde', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      // ~1.2 == >=1.2.0 <1.3.0
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    } else if (pr) {
	      debug('replaceTilde pr', pr)
	      ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    } else {
	      // ~1.2.3 == >=1.2.3 <1.3.0
	      ret = '>=' + M + '.' + m + '.' + p +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('tilde return', ret)
	    return ret
	  })
	}
	
	// ^ --> * (any, kinda silly)
	// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
	// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
	// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
	// ^1.2.3 --> >=1.2.3 <2.0.0
	// ^1.2.0 --> >=1.2.0 <2.0.0
	function replaceCarets (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceCaret(comp, options)
	  }).join(' ')
	}
	
	function replaceCaret (comp, options) {
	  debug('caret', comp, options)
	  var r = options.loose ? re[CARETLOOSE] : re[CARET]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('caret', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      if (M === '0') {
	        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	      } else {
	        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0'
	      }
	    } else if (pr) {
	      debug('replaceCaret pr', pr)
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    } else {
	      debug('no pr')
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    }
	
	    debug('caret return', ret)
	    return ret
	  })
	}
	
	function replaceXRanges (comp, options) {
	  debug('replaceXRanges', comp, options)
	  return comp.split(/\s+/).map(function (comp) {
	    return replaceXRange(comp, options)
	  }).join(' ')
	}
	
	function replaceXRange (comp, options) {
	  comp = comp.trim()
	  var r = options.loose ? re[XRANGELOOSE] : re[XRANGE]
	  return comp.replace(r, function (ret, gtlt, M, m, p, pr) {
	    debug('xRange', comp, ret, gtlt, M, m, p, pr)
	    var xM = isX(M)
	    var xm = xM || isX(m)
	    var xp = xm || isX(p)
	    var anyX = xp
	
	    if (gtlt === '=' && anyX) {
	      gtlt = ''
	    }
	
	    if (xM) {
	      if (gtlt === '>' || gtlt === '<') {
	        // nothing is allowed
	        ret = '<0.0.0'
	      } else {
	        // nothing is forbidden
	        ret = '*'
	      }
	    } else if (gtlt && anyX) {
	      // we know patch is an x, because we have any x at all.
	      // replace X with 0
	      if (xm) {
	        m = 0
	      }
	      p = 0
	
	      if (gtlt === '>') {
	        // >1 => >=2.0.0
	        // >1.2 => >=1.3.0
	        // >1.2.3 => >= 1.2.4
	        gtlt = '>='
	        if (xm) {
	          M = +M + 1
	          m = 0
	          p = 0
	        } else {
	          m = +m + 1
	          p = 0
	        }
	      } else if (gtlt === '<=') {
	        // <=0.7.x is actually <0.8.0, since any 0.7.x should
	        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
	        gtlt = '<'
	        if (xm) {
	          M = +M + 1
	        } else {
	          m = +m + 1
	        }
	      }
	
	      ret = gtlt + M + '.' + m + '.' + p
	    } else if (xm) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (xp) {
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('xRange return', ret)
	
	    return ret
	  })
	}
	
	// Because * is AND-ed with everything else in the comparator,
	// and '' means "any version", just remove the *s entirely.
	function replaceStars (comp, options) {
	  debug('replaceStars', comp, options)
	  // Looseness is ignored here.  star is always as loose as it gets!
	  return comp.trim().replace(re[STAR], '')
	}
	
	// This function is passed to string.replace(re[HYPHENRANGE])
	// M, m, patch, prerelease, build
	// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
	// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
	// 1.2 - 3.4 => >=1.2.0 <3.5.0
	function hyphenReplace ($0,
	  from, fM, fm, fp, fpr, fb,
	  to, tM, tm, tp, tpr, tb) {
	  if (isX(fM)) {
	    from = ''
	  } else if (isX(fm)) {
	    from = '>=' + fM + '.0.0'
	  } else if (isX(fp)) {
	    from = '>=' + fM + '.' + fm + '.0'
	  } else {
	    from = '>=' + from
	  }
	
	  if (isX(tM)) {
	    to = ''
	  } else if (isX(tm)) {
	    to = '<' + (+tM + 1) + '.0.0'
	  } else if (isX(tp)) {
	    to = '<' + tM + '.' + (+tm + 1) + '.0'
	  } else if (tpr) {
	    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr
	  } else {
	    to = '<=' + to
	  }
	
	  return (from + ' ' + to).trim()
	}
	
	// if ANY of the sets match ALL of its comparators, then pass
	Range.prototype.test = function (version) {
	  if (!version) {
	    return false
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  for (var i = 0; i < this.set.length; i++) {
	    if (testSet(this.set[i], version, this.options)) {
	      return true
	    }
	  }
	  return false
	}
	
	function testSet (set, version, options) {
	  for (var i = 0; i < set.length; i++) {
	    if (!set[i].test(version)) {
	      return false
	    }
	  }
	
	  if (version.prerelease.length && !options.includePrerelease) {
	    // Find the set of versions that are allowed to have prereleases
	    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
	    // That should allow `1.2.3-pr.2` to pass.
	    // However, `1.2.4-alpha.notready` should NOT be allowed,
	    // even though it's within the range set by the comparators.
	    for (i = 0; i < set.length; i++) {
	      debug(set[i].semver)
	      if (set[i].semver === ANY) {
	        continue
	      }
	
	      if (set[i].semver.prerelease.length > 0) {
	        var allowed = set[i].semver
	        if (allowed.major === version.major &&
	            allowed.minor === version.minor &&
	            allowed.patch === version.patch) {
	          return true
	        }
	      }
	    }
	
	    // Version has a -pre, but it's not one of the ones we like.
	    return false
	  }
	
	  return true
	}
	
	exports.satisfies = satisfies
	function satisfies (version, range, options) {
	  try {
	    range = new Range(range, options)
	  } catch (er) {
	    return false
	  }
	  return range.test(version)
	}
	
	exports.maxSatisfying = maxSatisfying
	function maxSatisfying (versions, range, options) {
	  var max = null
	  var maxSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!max || maxSV.compare(v) === -1) {
	        // compare(max, v, true)
	        max = v
	        maxSV = new SemVer(max, options)
	      }
	    }
	  })
	  return max
	}
	
	exports.minSatisfying = minSatisfying
	function minSatisfying (versions, range, options) {
	  var min = null
	  var minSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!min || minSV.compare(v) === 1) {
	        // compare(min, v, true)
	        min = v
	        minSV = new SemVer(min, options)
	      }
	    }
	  })
	  return min
	}
	
	exports.minVersion = minVersion
	function minVersion (range, loose) {
	  range = new Range(range, loose)
	
	  var minver = new SemVer('0.0.0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = new SemVer('0.0.0-0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = null
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    comparators.forEach(function (comparator) {
	      // Clone to avoid manipulating the comparator's semver object.
	      var compver = new SemVer(comparator.semver.version)
	      switch (comparator.operator) {
	        case '>':
	          if (compver.prerelease.length === 0) {
	            compver.patch++
	          } else {
	            compver.prerelease.push(0)
	          }
	          compver.raw = compver.format()
	          /* fallthrough */
	        case '':
	        case '>=':
	          if (!minver || gt(minver, compver)) {
	            minver = compver
	          }
	          break
	        case '<':
	        case '<=':
	          /* Ignore maximum versions */
	          break
	        /* istanbul ignore next */
	        default:
	          throw new Error('Unexpected operation: ' + comparator.operator)
	      }
	    })
	  }
	
	  if (minver && range.test(minver)) {
	    return minver
	  }
	
	  return null
	}
	
	exports.validRange = validRange
	function validRange (range, options) {
	  try {
	    // Return '*' instead of '' so that truthiness works.
	    // This will throw if it's invalid anyway
	    return new Range(range, options).range || '*'
	  } catch (er) {
	    return null
	  }
	}
	
	// Determine if version is less than all the versions possible in the range
	exports.ltr = ltr
	function ltr (version, range, options) {
	  return outside(version, range, '<', options)
	}
	
	// Determine if version is greater than all the versions possible in the range.
	exports.gtr = gtr
	function gtr (version, range, options) {
	  return outside(version, range, '>', options)
	}
	
	exports.outside = outside
	function outside (version, range, hilo, options) {
	  version = new SemVer(version, options)
	  range = new Range(range, options)
	
	  var gtfn, ltefn, ltfn, comp, ecomp
	  switch (hilo) {
	    case '>':
	      gtfn = gt
	      ltefn = lte
	      ltfn = lt
	      comp = '>'
	      ecomp = '>='
	      break
	    case '<':
	      gtfn = lt
	      ltefn = gte
	      ltfn = gt
	      comp = '<'
	      ecomp = '<='
	      break
	    default:
	      throw new TypeError('Must provide a hilo val of "<" or ">"')
	  }
	
	  // If it satisifes the range it is not outside
	  if (satisfies(version, range, options)) {
	    return false
	  }
	
	  // From now on, variable terms are as if we're in "gtr" mode.
	  // but note that everything is flipped for the "ltr" function.
	
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    var high = null
	    var low = null
	
	    comparators.forEach(function (comparator) {
	      if (comparator.semver === ANY) {
	        comparator = new Comparator('>=0.0.0')
	      }
	      high = high || comparator
	      low = low || comparator
	      if (gtfn(comparator.semver, high.semver, options)) {
	        high = comparator
	      } else if (ltfn(comparator.semver, low.semver, options)) {
	        low = comparator
	      }
	    })
	
	    // If the edge version comparator has a operator then our version
	    // isn't outside it
	    if (high.operator === comp || high.operator === ecomp) {
	      return false
	    }
	
	    // If the lowest version comparator has an operator and our version
	    // is less than it then it isn't higher than the range
	    if ((!low.operator || low.operator === comp) &&
	        ltefn(version, low.semver)) {
	      return false
	    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
	      return false
	    }
	  }
	  return true
	}
	
	exports.prerelease = prerelease
	function prerelease (version, options) {
	  var parsed = parse(version, options)
	  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
	}
	
	exports.intersects = intersects
	function intersects (r1, r2, options) {
	  r1 = new Range(r1, options)
	  r2 = new Range(r2, options)
	  return r1.intersects(r2)
	}
	
	exports.coerce = coerce
	function coerce (version) {
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  var match = version.match(re[COERCE])
	
	  if (match == null) {
	    return null
	  }
	
	  return parse(match[1] +
	    '.' + (match[2] || '0') +
	    '.' + (match[3] || '0'))
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Modal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initModal;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(17);
	
	var Modal = exports.Modal = function () {
	
	  /**
	   * @param  {Dom}    modelContents     contents of the modal to show
	   * @param  {Dom}    clickRegion  button or other element to show modal
	   */
	  function Modal(modelContents, clickRegion) {
	    _classCallCheck(this, Modal);
	
	    this.modalContents = modelContents;
	    this.clickRegion = clickRegion;
	    this.isOpen = false;
	    this.magicNumberForEscapeKey = 27;
	    this.magicNumberForTabIndex = -1;
	
	    // Bind the context with the events
	    this.open = this.open.bind(this);
	    this.negative = this.negative.bind(this);
	    this.positive = this.positive.bind(this);
	    this.checkEscapeKey = this.checkEscapeKey.bind(this);
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    // Initialize modal
	    this.init();
	  }
	
	  _createClass(Modal, [{
	    key: 'init',
	    value: function init() {
	      this.bindButtons();
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.clickRegion[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var click = _step.value;
	
	          _get__('addEvent')(click, 'click', this.open);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'bindButtons',
	    value: function bindButtons() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.modalContents.querySelectorAll('.js-modal-close')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var closeButton = _step2.value;
	
	          _get__('addEvent')(closeButton, 'click', this.negative);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = this.modalContents.querySelectorAll('.js-modal-positive')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var positiveButton = _step3.value;
	
	          _get__('addEvent')(positiveButton, 'click', this.positive);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      this.createBackdrop();
	      this.modalContents.classList.add('modal--is-open');
	      document.body.setAttribute('aria-hidden', 'true');
	      _get__('addEvent')(document, 'keydown', this.checkEscapeKey);
	      _get__('triggerEvent')(this.modalContents, 'show.commonui.modal');
	      this.isOpen = true;
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.removeBackdrop();
	      this.modalContents.classList.remove('modal--is-open');
	      document.body.removeAttribute('aria-hidden', 'true');
	      document.onkeydown = null;
	      _get__('triggerEvent')(this.modalContents, 'hide.commonui.modal');
	      this.isOpen = false;
	    }
	  }, {
	    key: 'createBackdrop',
	    value: function createBackdrop() {
	      // Create the modal backdrop container
	      this.modalBackdrop = document.createElement('div');
	      this.modalBackdrop.classList.add('modal-backdrop');
	      this.modalBackdrop.classList.add('modal-backdrop--open');
	      this.modalBackdrop.setAttribute('tabindex', this.magicNumberForTabIndex);
	      document.body.appendChild(this.modalBackdrop);
	      this.modalBackdrop.focus();
	    }
	  }, {
	    key: 'removeBackdrop',
	    value: function removeBackdrop() {
	      if (this.isOpen) {
	        this.modalBackdrop.outerHTML = '';
	      }
	    }
	  }, {
	    key: 'positive',
	    value: function positive() {
	      _get__('triggerEvent')(this.modalContents, 'positive.commonui.modal');
	      this.close();
	    }
	  }, {
	    key: 'negative',
	    value: function negative() {
	      _get__('triggerEvent')(this.modalContents, 'negative.commonui.modal');
	      this.close();
	    }
	  }, {
	    key: 'checkEscapeKey',
	    value: function checkEscapeKey(evt) {
	      if (evt && evt.keyCode === this.magicNumberForEscapeKey) {
	        this.negative();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.clickRegion[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var click = _step4.value;
	
	          _get__('removeEvent')(click, 'click', this.open);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.modalContents) {
	        console.warn('CommonUI - Modal - No modal contents found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Modal;
	}();
	
	/**
	 * creates a new modal instance
	 * @param  {Object} config
	 */
	
	
	function initModal() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-modal' : _config$selector,
	      _config$clickElementS = config.clickElementSelector,
	      clickElementSelector = _config$clickElementS === undefined ? '.js-modal__button' : _config$clickElementS;
	
	  var modal = null;
	  if (typeof selector === 'string') {
	    modal = new (_get__('Modal'))(document.querySelector(selector), document.querySelectorAll(clickElementSelector));
	  }
	  return modal;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Modal':
	      return Modal;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initModal === 'undefined' ? 'undefined' : _typeof(initModal);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initModal, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initModal)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// Polyfill for creating CustomEvents on IE9/10/11
	
	// code pulled from:
	// https://github.com/d4tocchini/customevent-polyfill
	// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
	
	try {
	  new window.CustomEvent("test");
	} catch(e) {
	 var CustomEvent = function(event, params) {
	      var evt;
	      params = params || {
	          bubbles: false,
	          cancelable: false,
	          detail: undefined
	      };
	
	      evt = document.createEvent("CustomEvent");
	      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	      return evt;
	  };
	
	  CustomEvent.prototype = window.Event.prototype;
	  window.CustomEvent = CustomEvent; // expose definition to window
	}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Nav = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	
	exports.default = initNav;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Nav = exports.Nav = function () {
	
	  /**
	   * @param  {Dom}    nav             Navigation DOM element
	   */
	  function Nav(nav) {
	    _classCallCheck(this, Nav);
	
	    this.nav = nav;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.isGlobal = nav.classList.contains('nav--global');
	    this.isTouchSupported = 'ontouchstart' in window;
	    this.isPointerSupported = 'pointerdown' in window;
	    this.clickEvent = 'click';
	
	    // this.navToggle = navToggle;
	    this.navInner = nav.querySelector('.nav__inner');
	    this.navPrimary = nav.querySelector('.nav__items--primary');
	    this.navPrimaryItems = this.navPrimary ? this.navPrimary.querySelectorAll('.nav__item--primary') : null;
	    this.navActions = nav.querySelector('.nav__actions');
	
	    // Initialize navigation
	    this.init();
	  }
	
	  _createClass(Nav, [{
	    key: 'init',
	    value: function init() {
	
	      // Add the nav actions element if it doesn't already exist
	      if (!this.navActions) {
	        var navActions = document.createElement('ul');
	        _get__('addClasses')(navActions, ['nav__actions']);
	        this.navInner.appendChild(navActions);
	        this.navActions = navActions;
	      }
	
	      var mobileNavIconClass = this.isGlobal ? 'fa-bars' : 'fa-chevron-down';
	
	      var newNavAction = document.createElement('li');
	
	      this.navToggle = document.createElement('button');
	
	      _get__('addClasses')(newNavAction, ['nav__action', 'hide--md-and-up']);
	      _get__('addClasses')(this.navToggle, ['nav__action-btn', 'js-nav-toggle']);
	      this.navToggle.innerHTML = '<i class="fa ' + mobileNavIconClass + '"></i>';
	      newNavAction.appendChild(this.navToggle);
	      this.navActions.appendChild(newNavAction);
	
	      // Check if a primary navigation element exists
	      if (this.navPrimaryItems) {
	
	        // Bind the click event of the navigation toggle to the openMenu() method
	        _get__('addEvent')(this.navToggle, this.clickEvent, this.openMenu.bind(this));
	
	        // Loop through each primary navigation item
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = this.navPrimaryItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var navPrimaryItem = _step.value;
	
	
	            var navPrimaryItemLink = navPrimaryItem.querySelector('a');
	            var navSecondary = navPrimaryItem.querySelector('.nav__items--secondary');
	
	            // Check if this primary navigation item also contains secondary level navigation items
	            if (navSecondary !== null) {
	
	              var navSecondaryItems = navSecondary.querySelectorAll('.nav__item--secondary');
	
	              // Determine the height of the sub nav and set the max-height as an inline style
	              // as we need a fixed height for the CSS transition to work
	              // let subNavHeight = subNav.offsetHeight;
	
	              var navSecondaryHeight = window.innerHeight / 100 * 75; // 75% of viewport width
	              var navSecondaryMobileHeight = navSecondaryItems.length * 57; // TODO: Find a better way to determine the height of the sub nav
	
	              navSecondary.setAttribute('data-height', navSecondaryHeight);
	              navSecondary.setAttribute('data-mobile-height', navSecondaryMobileHeight);
	
	              // Apply a "has-children" class to the primary navigation element if it doesn't already exist
	              if (!navPrimaryItem.classList.contains('has-children')) {
	                _get__('addClasses')(navPrimaryItem, ['has-children']);
	              }
	
	              // Bind the click event of this primary navigation link to toggle the secondary navigation
	              _get__('addEvent')(navPrimaryItemLink, this.clickEvent, this.toggleSubMenu.bind(this, navPrimaryItem));
	            } else {
	
	              // This is a top-level link that has no sub-nav, so bind different events
	              _get__('addEvent')(navPrimaryItemLink, this.clickEvent, this.setPrimaryNavItemAsActive.bind(this, navPrimaryItem));
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }
	
	    /**
	     * Removes the 'is-active' state from each navigation item at the specified level, i.e. primary or secondary.
	     * @param level
	     */
	
	  }, {
	    key: 'deactivateNavItems',
	    value: function deactivateNavItems(level) {
	      var activeNavItems = this.nav.querySelectorAll('.nav__items--' + level + ' > .is-active');
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = activeNavItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var activeNavItem = _step2.value;
	
	          _get__('removeClasses')(activeNavItem, ['is-active']);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	
	    /**
	     * Deactivates all currently active primary and secondary level navigation elements.
	     * Marks the specified primary navigation item as active.
	     * Closes the menu.
	     * @param item
	     */
	
	  }, {
	    key: 'setPrimaryNavItemAsActive',
	    value: function setPrimaryNavItemAsActive(item) {
	
	      // Mark any currently active elements as inactive by removing the 'is-active' state
	      this.deactivateNavItems('primary');
	      this.deactivateNavItems('secondary');
	
	      // Mark the current item as active
	      if (!item.classList.contains('is-active')) {
	        _get__('addClasses')(item, ['is-active']);
	      }
	
	      // Finally, close the menu
	      this.closeMenu();
	    }
	
	    /**
	     * Utility method for determining if an element is visible in the DOM.
	     * Taken directly from the jQuery source.
	     * @param elem
	     * @returns {boolean}
	     * @see https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js
	     */
	
	  }, {
	    key: 'isVisible',
	    value: function isVisible(elem) {
	      return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
	    }
	
	    /**
	     * Unbinds all click events at the primary and secondary level navigation elements.
	     */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	
	      _get__('removeEvent')(this.navToggle, this.clickEvent, this.openMenu);
	
	      // Unbind the click events for all secondary navigation items
	      var primaryNavItemsWithChildren = this.nav.querySelectorAll('.nav__items--primary.has-children');
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = primaryNavItemsWithChildren[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var primaryNavItem = _step3.value;
	
	          var primaryNavItemLink = primaryNavItem.querySelector('a');
	          _get__('removeEvent')(primaryNavItemLink, this.clickEvent, this.toggleSubMenu.bind(this, primaryNavItem));
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'toggleSubMenu',
	    value: function toggleSubMenu(primaryNavItem, e) {
	
	      var isOpen = primaryNavItem.classList.contains('is-open');
	      var secondaryNav = primaryNavItem.querySelector('.nav__items--secondary');
	      var isMobileView = this.isVisible(this.navToggle);
	
	      if (isOpen) {
	
	        secondaryNav.style.maxHeight = '0px';
	        _get__('removeClasses')(primaryNavItem, ['is-open']);
	      } else {
	
	        var navSecondaryHeight = secondaryNav.getAttribute(isMobileView ? 'data-mobile-height' : 'data-height');
	        secondaryNav.style.maxHeight = navSecondaryHeight + 'px';
	
	        _get__('addClasses')(primaryNavItem, ['is-open']);
	
	        // Bind click events to each link to close the nav if a link is clicked
	        var secondaryNavLinks = secondaryNav.querySelectorAll('a');
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = secondaryNavLinks[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var secondaryNavLink = _step4.value;
	
	            _get__('addEvent')(secondaryNavLink, this.clickEvent, this.secondaryNavItemLinkClicked.bind(this, primaryNavItem, secondaryNav), false);
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'secondaryNavItemLinkClicked',
	    value: function secondaryNavItemLinkClicked(primaryNavItem, secondaryNav) {
	      _get__('removeClasses')(secondaryNav, ['is-open']);
	      this.closeMenu();
	    }
	  }, {
	    key: 'openMenu',
	    value: function openMenu() {
	
	      if (!this.isGlobal) {
	        var toggleIcon = this.navToggle.querySelector('i');
	        if (toggleIcon.classList.contains('flip')) {
	          _get__('removeClasses')(toggleIcon, ['flip']);
	        } else {
	          _get__('addClasses')(toggleIcon, ['flip']);
	        }
	      }
	
	      if (this.nav.classList.contains('is-open')) {
	        _get__('removeClasses')(this.nav, ['is-open']);
	        _get__('removeClasses')(this.navPrimary, ['is-open']);
	      } else {
	        _get__('addClasses')(this.nav, ['is-open']);
	        _get__('addClasses')(this.navPrimary, ['is-open']);
	      }
	
	      var isMobileView = this.isVisible(this.navToggle);
	
	      if (isMobileView && this.isGlobal) {
	
	        this.overlay = document.createElement('div');
	        _get__('addClasses')(this.overlay, ['overlay', 'fade', 'js-overlay']);
	        this.navPrimary.parentNode.insertBefore(this.overlay, this.navPrimary);
	
	        this.navSectionHeader = document.createElement('li');
	        _get__('addClasses')(this.navSectionHeader, ['nav__item--primary', 'nav__section--header', 'is-sticky']);
	        this.navSectionHeader.innerText = 'Menu';
	
	        this.navCloseBtn = document.createElement('button');
	        _get__('addClasses')(this.navCloseBtn, ['btn', 'btn--close', 'fade', 'js-close-menu']);
	        this.navCloseBtn.innerHTML = '<i class="icon-cme-card-close"></i>';
	        this.navSectionHeader.appendChild(this.navCloseBtn);
	
	        this.navPrimary.insertBefore(this.navSectionHeader, this.navPrimary.firstChild);
	
	        setTimeout(function () {
	          _get__('addClasses')(this.overlay, ['fade--in']);
	          _get__('addClasses')(this.navCloseBtn, ['fade--in']);
	        }.bind(this), 100);
	      }
	
	      _get__('addEvent')(this.navCloseBtn, this.clickEvent, this.closeMenu.bind(this));
	    }
	  }, {
	    key: 'closeMenu',
	    value: function closeMenu() {
	
	      var isMobileView = this.isVisible(this.navToggle);
	
	      _get__('removeClasses')(this.nav, ['is-open']);
	      _get__('removeClasses')(this.navPrimary, ['is-open']);
	
	      if (isMobileView) {
	
	        if (this.isGlobal) {
	
	          _get__('removeClasses')(this.overlay, ['fade--in']);
	
	          setTimeout(function () {
	            // ChildNode.remove() is not supported in Internet Explorer,
	            // so we have to resort to the longhand version of ParentNode.removeChild() instead
	            this.overlay.parentNode.removeChild(this.overlay);
	            this.navSectionHeader.parentNode.removeChild(this.navSectionHeader);
	          }.bind(this), 300);
	        } else {
	
	          var toggleIcon = this.navToggle.querySelector('i');
	          if (toggleIcon !== null && toggleIcon.classList.contains('flip')) {
	            _get__('removeClasses')(toggleIcon, ['flip']);
	          }
	        }
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.nav) {
	        console.warn('CommonUI - Nav - There\'s no nav found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Nav;
	}();
	
	/**
	 * Creates a new nav instance
	 * @param  {Object} config
	 */
	
	
	function initNav() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-nav' : _config$selector;
	
	  var navs = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	      for (var _iterator5 = document.querySelectorAll(selector)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	        var nav = _step5.value;
	
	        navs = new (_get__('Nav'))(nav);
	      }
	    } catch (err) {
	      _didIteratorError5 = true;
	      _iteratorError5 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	          _iterator5.return();
	        }
	      } finally {
	        if (_didIteratorError5) {
	          throw _iteratorError5;
	        }
	      }
	    }
	  }
	  return navs;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Nav':
	      return Nav;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initNav === 'undefined' ? 'undefined' : _typeof(initNav);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initNav, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initNav)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Search = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initSearch;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KEY_ENTER = 13;
	var KEY_ESCAPE = 27;
	
	var Search = exports.Search = function () {
	
	  /**
	   * @param  {Dom}    search             container to hold search component
	   * @param  {String} searchButton       search button element
	   */
	
	  function Search(search, isOpen, allowClose, alwaysOpenDownInNav) {
	    _classCallCheck(this, Search);
	
	    this.search = search;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    this.searchToggle = search.querySelector('.search-toggle');
	    this.searchToggleIcon = search.querySelector('.search-toggle > i');
	    this.searchInput = search.querySelector('.search-input');
	    this.searchInputBox = search.querySelector('.search-input > input');
	    this.searchButton = search.querySelector('.search-input i');
	    this.isOpen = isOpen;
	    this.allowClose = allowClose;
	    this.alwaysOpenDownInNav = alwaysOpenDownInNav;
	    // Initialize search component
	    this.init();
	  }
	
	  _createClass(Search, [{
	    key: 'init',
	    value: function init() {
	      if (this.searchToggle && this.allowClose) {
	        this.search.classList.add('search--allow-close');
	      } else if (this.isOpen) {
	        this.searchToggle.classList.add('hide');
	      }
	      if (this.isOpen) {
	        this.search.classList.add('search--open');
	        this.searchToggleIcon.classList.remove('fa-search');
	        this.searchToggleIcon.classList.add('fa-close');
	      }
	      if (this.alwaysOpenDownInNav) {
	        this.search.classList.add('search--nav-down');
	      }
	      if (this.search.parentNode.classList.contains('nav__action')) {
	        this.search.parentNode.style.position = 'static';
	      }
	      _get__('addEvent')(this.searchToggle, 'click', this.toggle.bind(this));
	      _get__('addEvent')(this.searchInputBox, 'focus', this.selectText.bind(this));
	      _get__('addEvent')(this.searchInputBox, 'keydown', this.keyPress.bind(this));
	      _get__('addEvent')(this.searchButton, 'click', this.doSearch.bind(this));
	    }
	  }, {
	    key: 'selectText',
	    value: function selectText() {
	      this.searchInputBox.select();
	    }
	  }, {
	    key: 'keyPress',
	    value: function keyPress(event) {
	      if (event.which === _get__('KEY_ENTER')) {
	        this.doSearch();
	      }
	      if (event.which === _get__('KEY_ESCAPE') && this.allowClose) {
	        this.toggle();
	      }
	    }
	  }, {
	    key: 'doSearch',
	    value: function doSearch() {
	      _get__('triggerEvent')(this.search, 'do.commonui.search');
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      if (this.isOpen === false) {
	        this.search.classList.add('search--open');
	        if (this.allowClose === false) {
	          this.searchToggle.classList.add('hide');
	        } else {
	          this.searchToggleIcon.classList.remove('fa-search');
	          this.searchToggleIcon.classList.add('fa-close');
	        }
	        this.searchInputBox.focus();
	        this.isOpen = true;
	        _get__('triggerEvent')(this.search, 'open.commonui.search');
	      } else {
	        this.search.classList.remove('search--open');
	        this.searchToggleIcon.classList.remove('fa-close');
	        this.searchToggleIcon.classList.add('fa-search');
	        this.isOpen = false;
	        _get__('triggerEvent')(this.search, 'close.commonui.search');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.searchButton) {
	        _get__('removeEvent')(this.searchButton, 'click', this.toggle.bind(this));
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.search) {
	        console.warn('CommonUI - Search - There\'s no search component found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Search;
	}();
	
	/**
	 * Creates a new instance
	 * @param  {Object} config
	 */
	
	
	function initSearch() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-search' : _config$selector,
	      _config$openOnLoad = config.openOnLoad,
	      openOnLoad = _config$openOnLoad === undefined ? false : _config$openOnLoad,
	      _config$allowClose = config.allowClose,
	      allowClose = _config$allowClose === undefined ? true : _config$allowClose,
	      _config$alwaysOpenDow = config.alwaysOpenDownInNav,
	      alwaysOpenDownInNav = _config$alwaysOpenDow === undefined ? false : _config$alwaysOpenDow;
	
	  var searches = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var search = _step.value;
	
	        searches = new (_get__('Search'))(search, openOnLoad, allowClose, alwaysOpenDownInNav);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return searches;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'KEY_ENTER':
	      return KEY_ENTER;
	
	    case 'KEY_ESCAPE':
	      return KEY_ESCAPE;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Search':
	      return Search;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initSearch === 'undefined' ? 'undefined' : _typeof(initSearch);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initSearch, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initSearch)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Table = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initTable;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	var _ButtonGroup = __webpack_require__(21);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _formatInlineEdit = __webpack_require__(22);
	
	var _formatInlineEdit2 = _interopRequireDefault(_formatInlineEdit);
	
	var _isMobile = __webpack_require__(36);
	
	var _isMobile2 = _interopRequireDefault(_isMobile);
	
	var _delete = __webpack_require__(37);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var detailTableTypeList = {
	  detailedView: 'detailedView',
	  expandedRow: 'expandedRow',
	  stackedRow: 'stackedRow'
	};
	var overlayActionClasses = {
	  open: 'overlay__table--open',
	  close: 'overlay__table--close',
	  cancel: 'overlay__table--cancel',
	  trigger: 'js-table-overlay-trigger',
	  applyReorder: 'apply--reorder',
	  resetDefault: 'reset-to-default',
	  selectAll: 'select-all'
	};
	
	var Table = exports.Table = function () {
	  /**
	   * @param  {Dom}    table             table reference
	   */
	  function Table(config) {
	    _classCallCheck(this, Table);
	
	    this.table = config.table;
	
	    // Detail View
	    this.detailViewType = config.detailViewType;
	    this.detailViewSelector = config.detailViewSelector;
	    this.detailViewDismissTrigger = document.querySelector(config.detailViewDismissSelector);
	    this.inlineAlert = this.table.querySelector('.js-alert-overlay');
	    this.overlayTriggers = document.querySelectorAll('.' + _get__('overlayActionClasses').trigger);
	    this.overlayElement = document.querySelector(config.overlayElement);
	    this.overlayCloses = document.querySelectorAll('.' + _get__('overlayActionClasses').close);
	    this.cancelButton = document.querySelector('.' + _get__('overlayActionClasses').cancel);
	    this.applyReorder = document.querySelectorAll('.' + config.trigger);
	    this.buttonTrigger = document.querySelector('.' + config.trigger);
	    this.resetDefault = document.querySelector('.' + _get__('overlayActionClasses').resetDefault);
	    this.checkboxes = document.querySelectorAll('.' + _get__('overlayActionClasses').selectAll);
	    this.deleteModal = document.querySelector('.delete-row-modal');
	    this.inlineEdits = this.table.querySelectorAll('.inline--edit');
	    this.deleteRows = this.table.querySelectorAll('.delete-row');
	    this.selector = config.trigger;
	    this.tableReorder = config.tableReorder;
	    this.buttonGroup = {};
	
	    if (config.overlayElement) {
	      this.overlayElementString = config.overlayElement.split('.').join('');
	    }
	
	    this.currentTableHeaderOrder = [];
	    this.newTableHeaderOrder = [];
	    this.newOrderObject = {};
	    this.newOrderArray = [];
	    this.disabledList = {};
	    this.unlockedItems = [];
	    this.reorderDefaultState = {};
	    this.allRowsSelected = true;
	
	    this.switched = false;
	    this.magicBreakpoint = 768;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.copy = this.table.cloneNode(true);
	    _get__('formatInlineEdit')(this.copy.querySelectorAll('.inline--edit'));
	    this.copyTwo = this.table.cloneNode(true);
	    this.copyOverlayElement = {};
	
	    // Initialize table
	    this.init();
	  }
	
	  _createClass(Table, [{
	    key: 'init',
	    value: function init() {
	      if (!this.table.classList.contains('table--responsive')) {
	        this.table.classList.add('full--scroll');
	      }
	      if (!this.detailViewType) {
	        this.updateTable();
	      }
	      this.addListeners();
	      this.populateReorder();
	      this.checkSelectedRows();
	      _get__('formatInlineEdit')(this.inlineEdits);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (!this.detailViewType) {
	        this.unsplitTable();
	      }
	      this.removeListeners();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.table) {
	        console.warn('CommonUI - Table - There\'s no table found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: 'updateTable',
	    value: function updateTable() {
	      if (window.innerWidth < this.magicBreakpoint && !this.switched) {
	        this.switched = true;
	        this.splitTable();
	      } else if (this.switched && window.innerWidth >= this.magicBreakpoint) {
	        this.switched = false;
	        this.unsplitTable();
	      }
	    }
	  }, {
	    key: 'splitTable',
	    value: function splitTable() {
	      if (!this.table.classList.contains('full--scroll')) {
	        _get__('wrap')(this.table, 'table--wrapper');
	        this.copy.classList.remove('table--responsive');
	        this.table.parentElement.appendChild(this.copy);
	        _get__('wrap')(this.copy, 'table--pinned');
	        _get__('wrap')(this.table, 'table--scrollable');
	        if (this.inlineAlert) {
	          _get__('addEvent')(this.table.parentElement, 'scroll', this.updateAlertPosition.bind(this));
	        }
	      }
	    }
	  }, {
	    key: 'unsplitTable',
	    value: function unsplitTable() {
	      if (!this.table.classList.contains('full--scroll')) {
	        _get__('unwrap')(this.table);
	        _get__('unwrap')(this.table);
	        this.copy.parentNode.parentNode.removeChild(this.copy.parentNode);
	      }
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _this = this;
	
	      switch (this.detailViewType) {
	        case _get__('detailTableTypeList').detailedView:
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = this.table.querySelectorAll('.js-table-detail-trigger')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var detailViewTrigger = _step.value;
	
	              _get__('addEvent')(detailViewTrigger, 'click', this.showDetailView.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _get__('addEvent')(this.detailViewDismissTrigger, 'click', this.hideDetailView.bind(this));
	          break;
	        case _get__('detailTableTypeList').expandedRow:
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = this.table.querySelectorAll('.js-table-detail-expand-trigger')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var expandedViewTrigger = _step2.value;
	
	              _get__('addEvent')(expandedViewTrigger, 'click', this.toggleExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          break;
	        case _get__('detailTableTypeList').stackedRow:
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = this.table.querySelectorAll('.js-table-detail-stacked-trigger')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var stackedExpandedViewTrigger = _step3.value;
	
	              _get__('addEvent')(stackedExpandedViewTrigger, 'click', this.toggleStackedExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          break;
	        default:
	          _get__('addEvent')(window, 'resize', this.updateTable.bind(this));
	          break;
	      }
	      this.overlayListeners();
	      _get__('addEvent')(this.table, 'apply.commonui.inline-edit', function () {
	        _this.copy = _this.table.cloneNode(true);
	      });
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.deleteRows[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var row = _step4.value;
	
	          _get__('addEvent')(row, 'click', this.confirmDeleteRow.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updateAlertPosition',
	    value: function updateAlertPosition() {
	      if (_get__('hasClass')(this.inlineAlert, 'is-minimised')) {
	        _get__('removeEvent')(this.table.parentElement, 'scroll', this.updateAlertPosition.bind(this));
	        return;
	      }
	      _get__('setStyles')(this.inlineAlert, { left: '-' + this.table.parentElement.scrollLeft + 'px' });
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      switch (this.detailViewType) {
	        case _get__('detailTableTypeList').detailedView:
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = this.table.querySelectorAll('.js-table-detail-trigger')[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var detailViewTrigger = _step5.value;
	
	              _get__('removeEvent')(detailViewTrigger, 'click', this.showDetailView.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	
	          _get__('removeEvent')(this.detailViewDismissTrigger, 'click', this.hideDetailView.bind(this));
	          break;
	        case _get__('detailTableTypeList').expandedRow:
	          var _iteratorNormalCompletion6 = true;
	          var _didIteratorError6 = false;
	          var _iteratorError6 = undefined;
	
	          try {
	            for (var _iterator6 = this.table.querySelectorAll('.js-table-detail-expand-trigger')[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	              var expandedViewTrigger = _step6.value;
	
	              _get__('removeEvent')(expandedViewTrigger, 'click', this.toggleExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                _iterator6.return();
	              }
	            } finally {
	              if (_didIteratorError6) {
	                throw _iteratorError6;
	              }
	            }
	          }
	
	          break;
	        case _get__('detailTableTypeList').stackedRow:
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = this.table.querySelectorAll('.js-table-detail-stacked-trigger')[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var stackedExpandedViewTrigger = _step7.value;
	
	              _get__('removeEvent')(stackedExpandedViewTrigger, 'click', this.toggleStackedExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	
	          break;
	        default:
	          _get__('removeEvent')(window, 'resize', this.updateTable.bind(this));
	          break;
	      }
	    }
	  }, {
	    key: 'overlayListeners',
	    value: function overlayListeners() {
	      var _iteratorNormalCompletion8 = true;
	      var _didIteratorError8 = false;
	      var _iteratorError8 = undefined;
	
	      try {
	        for (var _iterator8 = this.overlayTriggers[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	          var overlayTrigger = _step8.value;
	
	          _get__('addEvent')(overlayTrigger, 'click', this.open.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError8 = true;
	        _iteratorError8 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion8 && _iterator8.return) {
	            _iterator8.return();
	          }
	        } finally {
	          if (_didIteratorError8) {
	            throw _iteratorError8;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion9 = true;
	      var _didIteratorError9 = false;
	      var _iteratorError9 = undefined;
	
	      try {
	        for (var _iterator9 = this.overlayCloses[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	          var overlayClose = _step9.value;
	
	          _get__('addEvent')(overlayClose, 'click', this.close.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError9 = true;
	        _iteratorError9 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion9 && _iterator9.return) {
	            _iterator9.return();
	          }
	        } finally {
	          if (_didIteratorError9) {
	            throw _iteratorError9;
	          }
	        }
	      }
	
	      _get__('addEvent')(this.cancelButton, 'click', this.close.bind(this));
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = this.applyReorder[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var apply = _step10.value;
	
	          _get__('addEvent')(apply, 'click', this.reorderTable.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion11 = true;
	      var _didIteratorError11 = false;
	      var _iteratorError11 = undefined;
	
	      try {
	        for (var _iterator11 = this.checkboxes[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	          var checkbox = _step11.value;
	
	          _get__('addEvent')(checkbox, 'click', this.selectAll.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError11 = true;
	        _iteratorError11 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion11 && _iterator11.return) {
	            _iterator11.return();
	          }
	        } finally {
	          if (_didIteratorError11) {
	            throw _iteratorError11;
	          }
	        }
	      }
	
	      _get__('addEvent')(this.resetDefault, 'click', this.reset.bind(this));
	    }
	
	    // Detail View
	
	  }, {
	    key: 'showDetailView',
	    value: function showDetailView() {
	      if (this.detailViewType === _get__('detailTableTypeList').detailedView && this.table) {
	        var secondaryView = this.table.querySelector('.js-table-secondary-view');
	        secondaryView.style.top = this.table.scrollTop + 'px';
	        this.table.classList.add('is-active');
	      }
	    }
	  }, {
	    key: 'hideDetailView',
	    value: function hideDetailView() {
	      if (this.detailViewType === _get__('detailTableTypeList').detailedView && this.table) {
	        this.table.classList.remove('is-active');
	      }
	    }
	
	    // Expanded Row
	
	  }, {
	    key: 'toggleExpandedRow',
	    value: function toggleExpandedRow(event) {
	      var nextExpandedRow = event.currentTarget.parentNode.nextElementSibling;
	      if (nextExpandedRow.classList.contains('is-active')) {
	        event.currentTarget.classList.remove('is-active');
	        nextExpandedRow.classList.remove('is-active');
	      } else {
	        event.currentTarget.classList.add('is-active');
	        nextExpandedRow.classList.add('is-active');
	      }
	    }
	
	    // Stacked Expanded Row
	
	  }, {
	    key: 'toggleStackedExpandedRow',
	    value: function toggleStackedExpandedRow(event) {
	      var previousContentSection = event.currentTarget.parentNode.parentNode;
	      var expandedContainer = previousContentSection.querySelector('.js-stacked-content');
	      if (expandedContainer.classList.contains('is-active')) {
	        event.currentTarget.classList.remove('is-active');
	        expandedContainer.classList.remove('is-active');
	      } else {
	        event.currentTarget.classList.add('is-active');
	        expandedContainer.classList.add('is-active');
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(event) {
	      if (this.overlayElement && this.overlayElement.classList === event.target.parentElement.children[1].lastElementChild.classList) {
	        this.overlayElement.classList.add(_get__('overlayActionClasses').open);
	        event.target.nextElementSibling.scrollLeft = 0;
	        event.target.nextElementSibling.style.overflowX = 'hidden';
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close(event) {
	      if (event.target.classList.contains(_get__('overlayActionClasses').close) || event.target.classList.contains('apply--reorder')) {
	        event.target.parentElement.parentElement.parentElement.classList.remove(_get__('overlayActionClasses').open);
	        event.target.parentElement.parentElement.parentElement.parentElement.style.overflowX = 'scroll';
	      }
	      this.reset(event, true);
	    }
	  }, {
	    key: 'populateReorder',
	    value: function populateReorder() {
	      if (this.table.classList.contains(this.tableReorder)) {
	        var uList = document.createElement('ul');
	        uList.classList.add('btn-group', 'js-btn-group');
	        var _iteratorNormalCompletion12 = true;
	        var _didIteratorError12 = false;
	        var _iteratorError12 = undefined;
	
	        try {
	          for (var _iterator12 = this.copy.tHead.rows[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	            var row = _step12.value;
	
	            var index = 0;
	            var _iteratorNormalCompletion14 = true;
	            var _didIteratorError14 = false;
	            var _iteratorError14 = undefined;
	
	            try {
	              for (var _iterator14 = row.cells[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	                var cell = _step14.value;
	
	                this.currentTableHeaderOrder.push(cell.innerText);
	                this.newOrderObject[index] = cell.innerText;
	                var list = document.createElement('li');
	                list.classList.add('btn-group-item');
	                list.setAttribute('data-id', index);
	                if (cell.classList.contains('table__heading--disable')) {
	                  this.disabledList[index] = cell.innerText;
	                  list.setAttribute('disabled', true);
	                }
	
	                var input = document.createElement('input');
	                input.classList.add('btn-group-item__input');
	                input.setAttribute('type', 'checkbox');
	                input.setAttribute('id', cell.innerText);
	                list.appendChild(input);
	
	                if (input.parentElement.getAttribute('disabled')) {
	                  input.checked = true;
	                }
	
	                if (cell.classList.contains('table--reorder--show-row')) {
	                  input.checked = true;
	                }
	
	                var label = document.createElement('label');
	                label.classList.add('btn-group-item__label');
	                label.setAttribute('for', cell.innerText);
	                label.setAttribute('draggable', true);
	                label.innerHTML = cell.innerText;
	
	                var icon = document.createElement('i');
	                icon.classList.add('icon-cme-drag-drop');
	
	                label.appendChild(icon);
	                list.appendChild(label);
	                uList.appendChild(list);
	
	                index += 1;
	              }
	            } catch (err) {
	              _didIteratorError14 = true;
	              _iteratorError14 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion14 && _iterator14.return) {
	                  _iterator14.return();
	                }
	              } finally {
	                if (_didIteratorError14) {
	                  throw _iteratorError14;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError12 = true;
	          _iteratorError12 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion12 && _iterator12.return) {
	              _iterator12.return();
	            }
	          } finally {
	            if (_didIteratorError12) {
	              throw _iteratorError12;
	            }
	          }
	        }
	
	        this.buttonTrigger.setAttribute('disabled', true);
	        this.cancelButton.setAttribute('disabled', true);
	        this.resetDefault.setAttribute('disabled', true);
	        this.overlayElement.lastElementChild.children[1].appendChild(uList);
	        this.reorderDefaultState = uList.cloneNode(true);
	        this.copyOverlayElement = this.overlayElement.cloneNode(true);
	        this.defaultUnlockedItems = this.getUnlockedItems(this.reorderDefaultState);
	        this.unlockedItems = this.getUnlockedItems(uList);
	
	        _get__('initButtonGroup')(uList);
	
	        this.buttonGroup = uList;
	
	        var _iteratorNormalCompletion13 = true;
	        var _didIteratorError13 = false;
	        var _iteratorError13 = undefined;
	
	        try {
	          for (var _iterator13 = this.buttonGroup.children[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	            var button = _step13.value;
	
	            _get__('addEvent')(button, 'change', this.checkSelectedRows.bind(this));
	            _get__('addEvent')(button, 'click', this.enableApply.bind(this));
	          }
	        } catch (err) {
	          _didIteratorError13 = true;
	          _iteratorError13 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion13 && _iterator13.return) {
	              _iterator13.return();
	            }
	          } finally {
	            if (_didIteratorError13) {
	              throw _iteratorError13;
	            }
	          }
	        }
	
	        _get__('addEvent')(uList, 'drop.commonui.buttonGroup', this.enableApply.bind(this));
	      }
	    }
	  }, {
	    key: 'getUnlockedItems',
	    value: function getUnlockedItems(list) {
	      var unlockedItems = [];
	      var _iteratorNormalCompletion15 = true;
	      var _didIteratorError15 = false;
	      var _iteratorError15 = undefined;
	
	      try {
	        for (var _iterator15 = list.children[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	          var listItem = _step15.value;
	
	          if (!listItem.getAttribute('disabled')) {
	            unlockedItems.push(listItem.lastElementChild.innerHTML);
	          }
	        }
	      } catch (err) {
	        _didIteratorError15 = true;
	        _iteratorError15 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion15 && _iterator15.return) {
	            _iterator15.return();
	          }
	        } finally {
	          if (_didIteratorError15) {
	            throw _iteratorError15;
	          }
	        }
	      }
	
	      return unlockedItems;
	    }
	  }, {
	    key: 'createNewTableHeaderOrder',
	    value: function createNewTableHeaderOrder(tableHeaderOrder) {
	      var newTableHeaderOrder = tableHeaderOrder;
	      for (var key in this.disabledList) {
	        for (var header in newTableHeaderOrder) {
	          if (this.disabledList[key] === newTableHeaderOrder[header]) {
	            newTableHeaderOrder.splice(header, 1);
	            break;
	          }
	        }
	      }
	
	      for (var _key in this.disabledList) {
	        newTableHeaderOrder.splice(_key, 0, this.disabledList[_key]);
	      }
	
	      return newTableHeaderOrder;
	    }
	  }, {
	    key: 'reorderTableHeaders',
	    value: function reorderTableHeaders() {
	      var newOrderArray = [];
	      var _iteratorNormalCompletion16 = true;
	      var _didIteratorError16 = false;
	      var _iteratorError16 = undefined;
	
	      try {
	        for (var _iterator16 = this.table.tHead.rows[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	          var row = _step16.value;
	
	          var index = 0;
	          var _iteratorNormalCompletion17 = true;
	          var _didIteratorError17 = false;
	          var _iteratorError17 = undefined;
	
	          try {
	            for (var _iterator17 = row.cells[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	              var cell = _step17.value;
	
	              cell.innerHTML = this.newTableHeaderOrder[index];
	              for (var key in this.newOrderObject) {
	                if (cell.innerText === this.newOrderObject[key]) {
	                  newOrderArray.push(parseInt(key, 10));
	                }
	              }
	              index += 1;
	            }
	          } catch (err) {
	            _didIteratorError17 = true;
	            _iteratorError17 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion17 && _iterator17.return) {
	                _iterator17.return();
	              }
	            } finally {
	              if (_didIteratorError17) {
	                throw _iteratorError17;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError16 = true;
	        _iteratorError16 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion16 && _iterator16.return) {
	            _iterator16.return();
	          }
	        } finally {
	          if (_didIteratorError16) {
	            throw _iteratorError16;
	          }
	        }
	      }
	
	      return newOrderArray;
	    }
	  }, {
	    key: 'reorderTable',
	    value: function reorderTable(event) {
	      if (event.target.classList.contains(this.selector) && this.table.classList.contains(this.tableReorder)) {
	        var _iteratorNormalCompletion18 = true;
	        var _didIteratorError18 = false;
	        var _iteratorError18 = undefined;
	
	        try {
	          for (var _iterator18 = this.overlayElement.lastElementChild.children[1].children[1].children[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	            var tableHeading = _step18.value;
	
	            this.newTableHeaderOrder.push(tableHeading.lastElementChild.innerText);
	          }
	        } catch (err) {
	          _didIteratorError18 = true;
	          _iteratorError18 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion18 && _iterator18.return) {
	              _iterator18.return();
	            }
	          } finally {
	            if (_didIteratorError18) {
	              throw _iteratorError18;
	            }
	          }
	        }
	
	        this.unlockedItems = this.getUnlockedItems(this.overlayElement.lastElementChild.children[1].children[1]);
	        this.newTableHeaderOrder = this.createNewTableHeaderOrder(this.newTableHeaderOrder);
	        this.newOrderArray = this.reorderTableHeaders();
	
	        var rowIndex = 0;
	        var _iteratorNormalCompletion19 = true;
	        var _didIteratorError19 = false;
	        var _iteratorError19 = undefined;
	
	        try {
	          for (var _iterator19 = this.table.rows[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
	            var row = _step19.value;
	
	            var cellIndex = 0;
	            if (!row.classList.contains('table--detail__row--expanded') && !row.classList.contains('table--detail__row--stacked')) {
	              var _iteratorNormalCompletion20 = true;
	              var _didIteratorError20 = false;
	              var _iteratorError20 = undefined;
	
	              try {
	                for (var _iterator20 = row.cells[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
	                  var cell = _step20.value;
	
	                  cell.innerHTML = this.copyTwo.rows[rowIndex].cells[this.newOrderArray[cellIndex]].innerHTML;
	                  cellIndex += 1;
	                }
	              } catch (err) {
	                _didIteratorError20 = true;
	                _iteratorError20 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion20 && _iterator20.return) {
	                    _iterator20.return();
	                  }
	                } finally {
	                  if (_didIteratorError20) {
	                    throw _iteratorError20;
	                  }
	                }
	              }
	            }
	            rowIndex += 1;
	          }
	        } catch (err) {
	          _didIteratorError19 = true;
	          _iteratorError19 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion19 && _iterator19.return) {
	              _iterator19.return();
	            }
	          } finally {
	            if (_didIteratorError19) {
	              throw _iteratorError19;
	            }
	          }
	        }
	
	        if (this.switched) {
	          this.unsplitTable();
	        }
	        this.copy = this.table.cloneNode(true);
	        if (this.switched) {
	          this.splitTable();
	        }
	
	        this.newTableHeaderOrder = [];
	        this.newOrderArray = [];
	
	        _get__('triggerEvent')(this.table, 'apply.commonui.reorderTable', {
	          detail: {
	            savedTable: this.table
	          }
	        });
	
	        if (_get__('isMobile')()) {
	          this.close(event);
	        }
	        this.buttonTrigger.setAttribute('disabled', true);
	        this.cancelButton.setAttribute('disabled', true);
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset(event, savedState) {
	      if (event.target.offsetParent.parentElement.parentElement.classList.contains(this.overlayElementString) && this.table.classList.contains(this.tableReorder)) {
	        var index = 0;
	        var _iteratorNormalCompletion21 = true;
	        var _didIteratorError21 = false;
	        var _iteratorError21 = undefined;
	
	        try {
	          for (var _iterator21 = this.overlayElement.lastElementChild.children[1].lastElementChild.children[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
	            var child = _step21.value;
	
	            if (!child.getAttribute('disabled')) {
	              if (savedState) {
	                child.lastElementChild.innerHTML = this.unlockedItems[index];
	                this.buttonTrigger.setAttribute('disabled', true);
	                this.cancelButton.setAttribute('disabled', true);
	              } else {
	                child.lastElementChild.innerHTML = this.defaultUnlockedItems[index];
	                this.enableApply();
	              }
	              index += 1;
	            }
	          }
	        } catch (err) {
	          _didIteratorError21 = true;
	          _iteratorError21 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion21 && _iterator21.return) {
	              _iterator21.return();
	            }
	          } finally {
	            if (_didIteratorError21) {
	              throw _iteratorError21;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'checkSelectedRows',
	    value: function checkSelectedRows() {
	      if (this.table.classList.contains(this.tableReorder)) {
	        var selectIcon = this.overlayElement.querySelector('.fa.select-all');
	        var _iteratorNormalCompletion22 = true;
	        var _didIteratorError22 = false;
	        var _iteratorError22 = undefined;
	
	        try {
	          for (var _iterator22 = this.buttonGroup.children[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
	            var child = _step22.value;
	
	            if (!child.firstElementChild.checked) {
	              this.allRowsSelected = false;
	            }
	          }
	        } catch (err) {
	          _didIteratorError22 = true;
	          _iteratorError22 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion22 && _iterator22.return) {
	              _iterator22.return();
	            }
	          } finally {
	            if (_didIteratorError22) {
	              throw _iteratorError22;
	            }
	          }
	        }
	
	        if (this.allRowsSelected) {
	          selectIcon.classList.remove('fa-square-o');
	          selectIcon.classList.add('fa-check-square-o');
	        } else {
	          selectIcon.classList.add('fa-square-o');
	          selectIcon.classList.remove('fa-check-square-o');
	        }
	        this.allRowsSelected = true;
	      }
	    }
	  }, {
	    key: 'enableApply',
	    value: function enableApply() {
	      if (this.table.classList.contains(this.tableReorder)) {
	        this.buttonTrigger.removeAttribute('disabled');
	        this.cancelButton.removeAttribute('disabled');
	        this.resetDefault.removeAttribute('disabled');
	      }
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll(event) {
	      if (event.target.offsetParent.parentElement.parentElement.classList.contains(this.overlayElementString) && this.table.classList.contains(this.tableReorder)) {
	        var selectIcon = this.overlayElement.querySelector('.fa.select-all');
	        var _iteratorNormalCompletion23 = true;
	        var _didIteratorError23 = false;
	        var _iteratorError23 = undefined;
	
	        try {
	          for (var _iterator23 = this.overlayElement.lastElementChild.children[1].lastElementChild.children[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
	            var child = _step23.value;
	
	            if (!child.firstElementChild.checked) {
	              this.allRowsSelected = false;
	            }
	          }
	        } catch (err) {
	          _didIteratorError23 = true;
	          _iteratorError23 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion23 && _iterator23.return) {
	              _iterator23.return();
	            }
	          } finally {
	            if (_didIteratorError23) {
	              throw _iteratorError23;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion24 = true;
	        var _didIteratorError24 = false;
	        var _iteratorError24 = undefined;
	
	        try {
	          for (var _iterator24 = this.overlayElement.lastElementChild.children[1].lastElementChild.children[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
	            var _child = _step24.value;
	
	            if (!_child.getAttribute('disabled') && !this.allRowsSelected) {
	              _child.firstElementChild.checked = true;
	              selectIcon.classList.remove('fa-square-o');
	              selectIcon.classList.add('fa-check-square-o');
	            } else if (!_child.getAttribute('disabled') && this.allRowsSelected) {
	              _child.firstElementChild.checked = false;
	              selectIcon.classList.remove('fa-check-square-o');
	              selectIcon.classList.add('fa-square-o');
	            }
	          }
	        } catch (err) {
	          _didIteratorError24 = true;
	          _iteratorError24 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion24 && _iterator24.return) {
	              _iterator24.return();
	            }
	          } finally {
	            if (_didIteratorError24) {
	              throw _iteratorError24;
	            }
	          }
	        }
	
	        this.allRowsSelected = !this.allRowsSelected;
	      }
	    }
	  }, {
	    key: 'confirmDeleteRow',
	    value: function confirmDeleteRow(event) {
	      var deleteEvent = event;
	      this.deleteModal.addEventListener('positive.commonui.modal', function () {
	        _get__('deleteRow')(deleteEvent);
	      });
	      this.deleteModal.addEventListener('negative.commonui.modal', function () {
	        deleteEvent = null;
	      });
	    }
	  }]);
	
	  return Table;
	}();
	
	/**
	 * Creates a new responsive table instance
	 * @param  {Object} config
	 */
	
	function initTable() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    selector: '.js-table--responsive',
	    detailViewType: null,
	    detailViewSelector: '.js-table-secondary-view',
	    detailViewDismissSelector: '.js-table-secondary-view--dismiss',
	    tableReorder: null,
	    overlayElement: null,
	    trigger: null
	  };
	  var selector = config.selector,
	      detailViewType = config.detailViewType,
	      detailViewSelector = config.detailViewSelector,
	      detailViewDismissSelector = config.detailViewDismissSelector,
	      tableReorder = config.tableReorder,
	      overlayElement = config.overlayElement,
	      trigger = config.trigger;
	
	  var tables = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion25 = true;
	    var _didIteratorError25 = false;
	    var _iteratorError25 = undefined;
	
	    try {
	      for (var _iterator25 = document.querySelectorAll(selector)[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
	        var table = _step25.value;
	
	        tables = new (_get__('Table'))({
	          table: table, detailViewType: detailViewType, detailViewSelector: detailViewSelector, detailViewDismissSelector: detailViewDismissSelector, tableReorder: tableReorder, overlayElement: overlayElement, trigger: trigger
	        });
	      }
	    } catch (err) {
	      _didIteratorError25 = true;
	      _iteratorError25 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion25 && _iterator25.return) {
	          _iterator25.return();
	        }
	      } finally {
	        if (_didIteratorError25) {
	          throw _iteratorError25;
	        }
	      }
	    }
	  }
	  return tables;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'overlayActionClasses':
	      return overlayActionClasses;
	
	    case 'formatInlineEdit':
	      return _formatInlineEdit2.default;
	
	    case 'wrap':
	      return _html.wrap;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'unwrap':
	      return _html.unwrap;
	
	    case 'detailTableTypeList':
	      return detailTableTypeList;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'initButtonGroup':
	      return _ButtonGroup2.default;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'isMobile':
	      return _isMobile2.default;
	
	    case 'deleteRow':
	      return _delete2.default;
	
	    case 'Table':
	      return Table;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initTable === 'undefined' ? 'undefined' : _typeof(initTable);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initTable, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initTable)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.ButtonGroup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initButtonGroup;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ButtonGroup = exports.ButtonGroup = function () {
	  function ButtonGroup(buttonGroup) {
	    _classCallCheck(this, ButtonGroup);
	
	    this.buttonGroup = buttonGroup;
	    this.magicNumberForResizeThrottling = 10;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    this.init();
	  }
	
	  _createClass(ButtonGroup, [{
	    key: 'init',
	    value: function init() {
	      if (this.buttonGroup) {
	        var buttonGroupItems = this.buttonGroup.children;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = buttonGroupItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var buttonGroupItem = _step.value;
	
	            var input = buttonGroupItem.getElementsByClassName('btn-group-item__input')[0];
	            _get__('addEvent')(input, 'click', this.apply.bind(this));
	
	            var labels = buttonGroupItem.getElementsByClassName('btn-group-item__label');
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = labels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var label = _step2.value;
	
	                if (label.getAttribute('draggable')) {
	                  _get__('addEvent')(label, 'dragstart', this.onDrag.bind(this));
	                  _get__('addEvent')(label, 'dragenter', this.onDragEnter.bind(this));
	                  _get__('addEvent')(label, 'dragover', this.onDragOver.bind(this));
	                  _get__('addEvent')(label, 'dragleave', this.onDragLeave.bind(this));
	                  _get__('addEvent')(label, 'drop', this.onDragDrop.bind(this));
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	          }
	
	          // Snapshot the initial dimensions of the button group so that we can refer to them later
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.responsiveMode = false;
	        this.initialWidth = _get__('getElementWidth')(this.buttonGroup);
	        this.checkForResponsive();
	
	        this.windowResizeListener = this.onWindowResize.bind(this);
	        this.windowResize = new (_get__('Throttle'))(this.windowResizeListener, this.magicNumberForResizeThrottling);
	        _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	
	        this.disabledToTop();
	      }
	    }
	  }, {
	    key: 'onWindowResize',
	    value: function onWindowResize() {
	      this.checkForResponsive();
	    }
	  }, {
	    key: 'checkForResponsive',
	    value: function checkForResponsive() {
	      // Check if we need to convert to dropdown
	      var currentWindowWidth = window.innerWidth;
	      var currentWidth = _get__('getElementWidth')(this.buttonGroup);
	      var containerWidth = _get__('getElementWidth')(this.buttonGroup.parentNode);
	      if (!this.responsiveMode && containerWidth < currentWidth) {
	        this.enableResponsiveMode();
	        this.responsiveModeWindowWidth = currentWindowWidth;
	      } else if (this.responsiveMode && currentWindowWidth > this.responsiveModeWindowWidth) {
	        this.disableResponsiveMode();
	      }
	    }
	  }, {
	    key: 'apply',
	    value: function apply() {
	      _get__('triggerEvent')(this.buttonGroup, 'apply.commonui.buttonGroup');
	      this.checkForResponsive();
	    }
	  }, {
	    key: 'enableResponsiveMode',
	    value: function enableResponsiveMode() {
	      this.responsiveMode = true;
	      _get__('wrap')(this.buttonGroup, 'dropdown');
	
	      this.dropdown = this.buttonGroup.parentNode;
	
	      _get__('addClass')(this.buttonGroup, 'dropdown-menu');
	
	      // First check if an option is already selected, as we need to grab the text from that option
	      var selectedOption = this.buttonGroup.querySelector('input[type="radio"]:checked');
	      var buttonText = selectedOption ? selectedOption.parentNode.querySelector('label').innerText : 'Please select';
	      var buttonHtml = '<span class="js-btn-text push--right">' + buttonText + '</span> <i class="fa fa-caret"/>';
	      // Create the dropdown button
	      this.dropdownButton = document.createElement('button');
	      this.dropdownButton.innerHTML = buttonHtml;
	
	      _get__('addClasses')(this.dropdownButton, ['btn', 'btn-dropdown', 'js-dropdown-btn']);
	
	      // Check if we need to go full width
	      if (_get__('hasClass')(this.buttonGroup, 'btn-group--full-width')) {
	        _get__('addClass')(this.dropdown, 'width--100');
	      } else {
	        // Get the width of the button group
	        _get__('addClass')(this.dropdown, 'dropdown-open');
	        var buttonGroupWidth = _get__('getElementWidth')(this.buttonGroup);
	        _get__('removeClass')(this.dropdown, 'dropdown-open');
	        var buttonPadding = 40;
	        var buttonWidth = buttonGroupWidth + buttonPadding + 'px';
	        this.dropdownButton.style.width = buttonWidth;
	        this.buttonGroup.style.width = buttonWidth;
	      }
	
	      // Inject the dropdown button before the button group
	      this.buttonGroup.before(this.dropdownButton);
	
	      this.openDropdownListener = this.openDropdown.bind(this);
	      this.closeDropdownListener = this.closeDropdown.bind(this);
	      this.documentClickListener = this.onDocumentClick.bind(this);
	      this.selectOptionListener = this.selectOption.bind(this);
	
	      _get__('addEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	    }
	  }, {
	    key: 'disableResponsiveMode',
	    value: function disableResponsiveMode() {
	      this.responsiveMode = false;
	
	      // Unbind the "click" event on the dropdown button
	      _get__('removeEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	
	      // Remove the "dropdown-menu" class from the button group container
	      _get__('removeClass')(this.buttonGroup, 'dropdown-menu');
	
	      // Remove all inline styles from the button group as the width will have been set
	      _get__('clearStyles')(this.buttonGroup);
	
	      // Unwrap the button group to remove the "dropdown" container
	      _get__('unwrap')(this.buttonGroup);
	
	      // Remove the dropdown button
	      _get__('removeElement')(this.dropdownButton);
	    }
	  }, {
	    key: 'openDropdown',
	    value: function openDropdown(event) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      _get__('addClass')(this.dropdown, 'dropdown-open');
	
	      _get__('removeEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	
	      _get__('addEvent')(this.dropdownButton, 'click', this.closeDropdownListener);
	      _get__('addEvent')(document, 'click', this.documentClickListener);
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = this.buttonGroup.querySelectorAll('.btn-group-item__label')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var buttonGroupOption = _step3.value;
	
	          _get__('addEvent')(buttonGroupOption, 'click', this.selectOptionListener);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'closeDropdown',
	    value: function closeDropdown() {
	      this.dropdown.classList.remove('dropdown-open');
	      _get__('removeEvent')(document, 'click', this.documentClickListener);
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.buttonGroup.querySelectorAll('.btn-group-item__label')[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var buttonGroupOption = _step4.value;
	
	          _get__('removeEvent')(buttonGroupOption, 'click', this.selectOptionListener);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      _get__('removeEvent')(this.dropdownButton, 'click', this.closeDropdownListener);
	      _get__('addEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	    }
	  }, {
	    key: 'onDocumentClick',
	    value: function onDocumentClick(event) {
	      if (!this.dropdown.contains(event.target)) {
	        this.closeDropdown();
	      }
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(event) {
	      var label = event.target;
	      var btnText = this.dropdownButton.querySelector('.js-btn-text');
	      btnText.innerText = label.innerText;
	      this.closeDropdown();
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(event) {
	      this.parent = event.target.parentNode.parentNode;
	      this.child = event.target.parentNode;
	
	      event.dataTransfer.setData('Text', this.child);
	
	      event.dataTransfer.effectAllowed = 'move';
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(event) {
	      event.preventDefault();
	      event.dataTransfer.dropEffect = 'move';
	      event.target.classList.add('button--dragover');
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(event) {
	      event.preventDefault();
	      event.target.classList.remove('button--dragover');
	    }
	  }, {
	    key: 'onDragDrop',
	    value: function onDragDrop(event) {
	      event.preventDefault();
	      event.target.classList.remove('button--dragover');
	      _get__('triggerEvent')(event.target.parentNode.parentNode, 'drop.commonui.buttonGroup');
	
	      if (Number(this.child.getAttribute('data-id')) > Number(event.target.parentNode.getAttribute('data-id'))) {
	        this.parent.insertBefore(this.child, event.target.parentNode);
	      } else {
	        this.parent.insertBefore(this.child, event.target.parentNode.nextSibling);
	      }
	
	      var index = 0;
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = this.parent.children[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var child = _step5.value;
	
	          child.setAttribute('data-id', index.toString());
	          index += 1;
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      event.stopImmediatePropagation();
	    }
	  }, {
	    key: 'disabledToTop',
	    value: function disabledToTop() {
	      var buttonGroup = [].concat(_toConsumableArray(this.buttonGroup.children));
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = buttonGroup.reverse()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var listItem = _step6.value;
	
	          if (listItem.hasAttribute('disabled')) {
	            this.buttonGroup.insertBefore(listItem, this.buttonGroup.children[0]);
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.buttonGroup) {
	        console.warn('CommonUI - Button - There\'s no button group found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return ButtonGroup;
	}();
	
	/**
	 * Creates a new button instance
	 * @param  {Object} config
	 */
	
	
	function initButtonGroup() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-btn-group';
	
	  var selector = config;
	  var buttonGroup = null;
	  if (typeof selector === 'string' && selector === '.js-btn-group') {
	    var _iteratorNormalCompletion7 = true;
	    var _didIteratorError7 = false;
	    var _iteratorError7 = undefined;
	
	    try {
	      for (var _iterator7 = document.querySelectorAll(selector)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	        var elem = _step7.value;
	
	        buttonGroup = new (_get__('ButtonGroup'))(elem);
	      }
	    } catch (err) {
	      _didIteratorError7 = true;
	      _iteratorError7 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion7 && _iterator7.return) {
	          _iterator7.return();
	        }
	      } finally {
	        if (_didIteratorError7) {
	          throw _iteratorError7;
	        }
	      }
	    }
	  } else {
	    buttonGroup = new (_get__('ButtonGroup'))(selector);
	  }
	  return buttonGroup;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'getElementWidth':
	      return _html.getElementWidth;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'wrap':
	      return _html.wrap;
	
	    case 'addClass':
	      return _html.addClass;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'removeClass':
	      return _html.removeClass;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'clearStyles':
	      return _html.clearStyles;
	
	    case 'unwrap':
	      return _html.unwrap;
	
	    case 'removeElement':
	      return _html.removeElement;
	
	    case 'ButtonGroup':
	      return ButtonGroup;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initButtonGroup === 'undefined' ? 'undefined' : _typeof(initButtonGroup);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initButtonGroup, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initButtonGroup)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = formatInlineEdit;
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	var _events = __webpack_require__(8);
	
	var _createAnchorInlineElement = __webpack_require__(24);
	
	var _createAnchorInlineElement2 = _interopRequireDefault(_createAnchorInlineElement);
	
	var _createTextInlineElement = __webpack_require__(25);
	
	var _createTextInlineElement2 = _interopRequireDefault(_createTextInlineElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatInlineEdit(element) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = element[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var inlineEdit = _step.value;
	
	      /* CREATE INLINE EDIT FOR TEXT */
	
	      if (!inlineEdit.classList.contains('format-done') && inlineEdit.tagName !== 'A') {
	        _get__('createTextInlineElement')(inlineEdit);
	        var span = inlineEdit.querySelector('span');
	        var input = inlineEdit.querySelector('input');
	        if (inlineEdit.classList.contains('text--center')) {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	          input.classList.add('text--center');
	        } else if (inlineEdit.classList.contains('text--left')) {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	          input.classList.add('text--left');
	        } else if (inlineEdit.classList.contains('text--right')) {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-right', 'form-fields']);
	          input.classList.add('text--right');
	        } else {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	          input.classList.add('text--left');
	        }
	        if (inlineEdit.classList.contains('required')) {
	          input.classList.add('required');
	        }
	      }
	
	      /* CREATE INLINE EDIT FOR ANCHOR LINKS */
	
	      if (inlineEdit.tagName === 'A') {
	        (function () {
	          var linkConfig = {};
	
	          var linkParent = inlineEdit.parentElement;
	          linkParent.classList.add('inline--edit-link');
	          linkParent.classList.add('inline--edit');
	
	          // create edit icon
	          var spanIcon = document.createElement('div');
	          spanIcon.classList.add('inline--edit-icon');
	          var icon = document.createElement('i');
	          icon.classList.add('icon-cme-pencil');
	          var iconDisabled = document.createElement('i');
	          iconDisabled.classList.add('icon-cme-pencil');
	          iconDisabled.classList.add('display--none');
	          spanIcon.appendChild(icon);
	          spanIcon.appendChild(iconDisabled);
	
	          // reorg anchor element
	          var spanAnchor = document.createElement('div');
	          spanAnchor.classList.add('inline--edit-anchor');
	          var anchor = inlineEdit;
	          spanAnchor.appendChild(anchor);
	
	          // Append edit icon to parent
	          linkParent.appendChild(spanAnchor);
	          linkParent.appendChild(spanIcon);
	
	          // Add event listener for icon onclick
	          _get__('addEvent')(icon, 'click', function () {
	            icon.classList.add('display--none');
	            iconDisabled.classList.remove('display--none');
	            // Removes anchor element
	            linkConfig = _get__('createAnchorInlineElement')(spanAnchor);
	            linkConfig.icons = {
	              icon: icon,
	              iconDisabled: iconDisabled
	            };
	
	            // Create input element for inline edit
	            _get__('createTextInlineElement')(spanAnchor, linkParent, linkConfig);
	
	            // Add required classes to span and input elements
	            var span = spanAnchor.querySelector('span');
	            var input = spanAnchor.querySelector('input');
	            if (linkParent.classList.contains('text--center')) {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	              input.classList.add('text--center');
	            } else if (linkParent.classList.contains('text--left')) {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	              input.classList.add('text--left');
	            } else if (linkParent.classList.contains('text--right')) {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-right', 'form-fields']);
	              input.classList.add('text--right');
	            } else {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	              input.classList.add('text--left');
	            }
	
	            input.focus();
	            input.select();
	          });
	        })();
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return element;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'createTextInlineElement':
	      return _createTextInlineElement2.default;
	
	    case 'addClasses':
	      return _addClasses2.default;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'createAnchorInlineElement':
	      return _createAnchorInlineElement2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof formatInlineEdit === 'undefined' ? 'undefined' : _typeof(formatInlineEdit);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(formatInlineEdit, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(formatInlineEdit)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createInlineEditElement;
	function createInlineEditElement(element, classes) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var singleClass = _step.value;
	
	      element.classList.add(singleClass);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return element;
	}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAnchorInlineElement;
	/* REMOVE ANCHOR ELEMENT AND REPLACE WITH TEXT */
	
	function createAnchorInlineElement(element) {
	  // Remove anchor element
	  var href = element.firstElementChild.getAttribute('href');
	  var linkText = element.firstElementChild.innerHTML;
	  var classList = element.firstElementChild.classList;
	  var parentElement = element.parentElement;
	  element.removeChild(element.firstElementChild);
	
	  var icon = parentElement.firstElementChild;
	  // Set text of parent element
	  element.innerHTML = linkText;
	
	  return {
	    href: href,
	    linkText: linkText,
	    classList: classList,
	    icon: icon
	  };
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createTextInlineElement;
	
	var _createInlineElement = __webpack_require__(26);
	
	var _createInlineElement2 = _interopRequireDefault(_createInlineElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTextInlineElement(inlineEdit) {
	  var inlineEditAnchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var linkConfig = arguments[2];
	
	  var inlineEditValue = inlineEdit.innerHTML;
	  if (inlineEditAnchor) {
	    inlineEdit.innerHTML = '';
	    inlineEditAnchor.classList.add('format-done');
	    inlineEditAnchor.classList.add('inline--edit__anchor');
	    inlineEdit.appendChild(_get__('createInlineElement')(inlineEditValue, linkConfig));
	  } else {
	    inlineEdit.classList.add('format-done');
	    inlineEdit.innerHTML = '';
	    inlineEdit.appendChild(_get__('createInlineElement')(inlineEditValue));
	  }
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'createInlineElement':
	      return _createInlineElement2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createTextInlineElement === 'undefined' ? 'undefined' : _typeof(createTextInlineElement);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createTextInlineElement, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createTextInlineElement)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createInlineEditElement;
	
	var _events = __webpack_require__(8);
	
	var _index = __webpack_require__(27);
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	var _createAnchorElement = __webpack_require__(34);
	
	var _createAnchorElement2 = _interopRequireDefault(_createAnchorElement);
	
	var _removeInputElement = __webpack_require__(35);
	
	var _removeInputElement2 = _interopRequireDefault(_removeInputElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* CREATES INPUT ELEMENT FOR INLINE EDITING */
	
	function createInlineEditElement(element, linkConfig) {
	  var initialValue = element;
	
	  // Create span to wrap input element
	  var span = document.createElement('span');
	
	  // Create input element
	  var input = document.createElement('input');
	  input.type = 'text';
	  input.name = element;
	  input.value = element;
	  input.autocomplete = 'off';
	
	  if (linkConfig && linkConfig.classList.contains('required')) {
	    input.classList.add('required');
	  }
	
	  var magicBreakpoint = 768;
	  _get__('addEvent')(window, 'resize', function () {
	    if (window.innerWidth < magicBreakpoint) {
	      input.disabled = true;
	    } else {
	      input.disabled = false;
	    }
	  });
	
	  // Create icon elements
	  var iconWrapper = document.createElement('div');
	  iconWrapper.classList.add('icon__wrapper');
	  var iconPencil = document.createElement('i');
	  iconPencil.classList.add('icon-cme-pencil');
	  iconWrapper.appendChild(iconPencil);
	
	  // Create actions element
	  var actions = document.createElement('div');
	  _get__('addClasses')(actions, ['actions', 'display--none']);
	
	  // Create cancel button element
	  var btnCancel = document.createElement('button');
	  btnCancel.classList.add('btn', 'btn--secondary', 'btn--cancel');
	  var iconRemove = document.createElement('i');
	  _get__('addClasses')(iconRemove, ['fa', 'fa-remove']);
	  btnCancel.appendChild(iconRemove);
	
	  // Create confirm button element
	  var btnConfirm = document.createElement('button');
	  _get__('addClasses')(btnConfirm, ['btn', 'btn--positive', 'btn--confirm']);
	  var iconCheck = document.createElement('i');
	  _get__('addClasses')(iconCheck, ['fa', 'fa-check']);
	  btnConfirm.appendChild(iconCheck);
	
	  // Append buttons to actions container
	  actions.appendChild(btnCancel);
	  actions.appendChild(btnConfirm);
	
	  // Append elements to span wrapper
	  span.appendChild(input);
	  span.appendChild(iconWrapper);
	  span.appendChild(actions);
	
	  var anchor = {};
	  var anchorInput = {};
	  // Add mousedown event listener for cancel button
	  _get__('addEvent')(btnCancel, 'mousedown', function (event) {
	    if (linkConfig) {
	      anchorInput = _get__('removeInputElement')(span);
	
	      linkConfig.linkText = initialValue;
	      linkConfig.icons.icon.classList.remove('display--none');
	      linkConfig.icons.iconDisabled.classList.add('display--none');
	
	      anchor = _get__('createAnchorElement')(linkConfig);
	      anchorInput.parent.appendChild(anchor);
	    } else {
	      _get__('btnCancelEvent')(input, initialValue, actions, event, btnConfirm);
	    }
	  });
	
	  // Add mousedown event listener for confirm button
	  _get__('addEvent')(btnConfirm, 'mousedown', function (event) {
	    if (linkConfig) {
	      if (input.value !== '' || !input.classList.contains('has-error')) {
	        var table = input.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
	        anchorInput = _get__('removeInputElement')(span);
	
	        linkConfig.linkText = anchorInput.inputValue;
	        linkConfig.icons.icon.classList.remove('display--none');
	        linkConfig.icons.iconDisabled.classList.add('display--none');
	
	        anchor = _get__('createAnchorElement')(linkConfig);
	        anchorInput.parent.appendChild(anchor);
	        _get__('triggerEvent')(table, 'apply.commonui.inline-edit');
	      }
	      _get__('btnConfirmEvent')(input, actions, event, btnConfirm);
	    } else {
	      if (input.value !== '' || !input.classList.contains('has-error')) {
	        initialValue = input.value;
	      }
	      var _table = input.parentElement.parentElement.parentElement.parentElement.parentElement;
	      _get__('btnConfirmEvent')(input, actions, event, btnConfirm);
	      _get__('triggerEvent')(_table, 'apply.commonui.inline-edit');
	    }
	  });
	
	  // Add focusin event listener for input
	  _get__('addEvent')(input, 'focusin', function () {
	    _get__('inputFocusEvent')(actions);
	  });
	
	  // Add onclick event listener for input
	  _get__('addEvent')(input, 'click', function () {
	    input.select();
	  });
	
	  // Add focusout event listener for input
	  _get__('addEvent')(input, 'focusout', function (event) {
	    if (linkConfig) {
	      event.preventDefault();
	    } else if (input.classList.contains('invalid')) {
	      event.preventDefault();
	
	      input.classList.remove('invalid');
	      input.focus();
	    } else {
	      _get__('inputFocusOutEvent')(input, actions, event, btnConfirm);
	      input.value = initialValue;
	    }
	  });
	
	  // Add oninput event listener for input
	  _get__('addEvent')(input, 'input', function () {
	    _get__('inputEvent')(input, btnConfirm);
	  });
	
	  return span;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'addClasses':
	      return _addClasses2.default;
	
	    case 'removeInputElement':
	      return _removeInputElement2.default;
	
	    case 'createAnchorElement':
	      return _createAnchorElement2.default;
	
	    case 'btnCancelEvent':
	      return _index.btnCancelEvent;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'btnConfirmEvent':
	      return _index.btnConfirmEvent;
	
	    case 'inputFocusEvent':
	      return _index.inputFocusEvent;
	
	    case 'inputFocusOutEvent':
	      return _index.inputFocusOutEvent;
	
	    case 'inputEvent':
	      return _index.inputEvent;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createInlineEditElement === 'undefined' ? 'undefined' : _typeof(createInlineEditElement);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createInlineEditElement, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createInlineEditElement)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inputEvent = exports.inputFocusOutEvent = exports.inputFocusEvent = exports.btnConfirmEvent = exports.btnCancelEvent = undefined;
	
	var _btnCancelEvent = __webpack_require__(28);
	
	var _btnCancelEvent2 = _interopRequireDefault(_btnCancelEvent);
	
	var _btnConfirmEvent = __webpack_require__(29);
	
	var _btnConfirmEvent2 = _interopRequireDefault(_btnConfirmEvent);
	
	var _inputFocusEvent = __webpack_require__(31);
	
	var _inputFocusEvent2 = _interopRequireDefault(_inputFocusEvent);
	
	var _inputFocusOutEvent = __webpack_require__(32);
	
	var _inputFocusOutEvent2 = _interopRequireDefault(_inputFocusOutEvent);
	
	var _inputEvent = __webpack_require__(33);
	
	var _inputEvent2 = _interopRequireDefault(_inputEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.btnCancelEvent = _btnCancelEvent2.default;
	exports.btnConfirmEvent = _btnConfirmEvent2.default;
	exports.inputFocusEvent = _inputFocusEvent2.default;
	exports.inputFocusOutEvent = _inputFocusOutEvent2.default;
	exports.inputEvent = _inputEvent2.default;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = btnCancelEvent;
	function btnCancelEvent(input, initialValue, actions, event, btnConfirm) {
	  input.value = initialValue;
	  if (input.classList.contains('has-error')) {
	    input.classList.remove('has-error');
	  }
	  actions.classList.add('display--none');
	  btnConfirm.classList.remove('display--none');
	
	  var toolTip = event.target.parentElement.parentElement.parentElement.querySelector('.tooltip--inline-edit');
	  var parentElement = event.target.parentElement.parentElement.classList.contains('inline-edit') ? event.target.parentElement.parentElement : event.target.parentElement.parentElement.parentElement;
	  if (toolTip) {
	    parentElement.removeChild(toolTip);
	  }
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = btnConfirmEvent;
	
	var _createToolTip = __webpack_require__(30);
	
	var _createToolTip2 = _interopRequireDefault(_createToolTip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function btnConfirmEvent(input, actions, event, btnConfirm) {
	  var initToolTip = _get__('createToolTip')();
	  if (input.classList.contains('has-error') && input.value !== '') {
	    input.classList.remove('has-error');
	  }
	
	  if (input.value === '' && input.classList.contains('required')) {
	    btnConfirm.classList.add('display--none');
	    input.focus();
	    input.classList.add('has-error');
	    input.classList.add('invalid');
	    initToolTip.style.bottom = input.offsetHeight + 'px';
	    input.parentElement.appendChild(initToolTip);
	  }
	
	  if (!input.classList.contains('has-error')) {
	    input.value = input.value;
	    input.name = input.value;
	
	    actions.classList.add('display--none');
	
	    var toolTip = event.target.parentElement.parentElement.parentElement.querySelector('.tooltip--inline-edit');
	    var parentElement = event.target.parentElement.parentElement.classList.contains('inline-edit') ? event.target.parentElement.parentElement : event.target.parentElement.parentElement.parentElement;
	    if (toolTip) {
	      parentElement.removeChild(toolTip);
	    }
	  }
	
	  return input;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'createToolTip':
	      return _createToolTip2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof btnConfirmEvent === 'undefined' ? 'undefined' : _typeof(btnConfirmEvent);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(btnConfirmEvent, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(btnConfirmEvent)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createToolTip;
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createToolTip() {
	  var toolTip = document.createElement('div');
	  _get__('addClasses')(toolTip, ['tooltip--inline-edit', 'tooltip--show']);
	
	  var toolTipInner = document.createElement('div');
	  toolTipInner.classList.add('tooltip-inner');
	  toolTipInner.innerHTML = 'This cell must not be empty.';
	
	  var toolTipArrow = document.createElement('div');
	  toolTipArrow.classList.add('tooltip__arrow');
	
	  toolTip.appendChild(toolTipInner);
	  toolTip.appendChild(toolTipArrow);
	
	  return toolTip;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _addClasses2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createToolTip === 'undefined' ? 'undefined' : _typeof(createToolTip);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createToolTip, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createToolTip)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inputFocusEvent;
	function inputFocusEvent(actions) {
	  actions.classList.remove('display--none');
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inputFocusOutEvent;
	function inputFocusOutEvent(input, actions, event, btnConfirm) {
	  if (input.classList.contains('has-error')) {
	    input.classList.remove('has-error');
	  }
	  actions.classList.add('display--none');
	  btnConfirm.classList.remove('display--none');
	
	  var toolTip = event.target.parentElement.querySelector('.tooltip--inline-edit');
	  if (toolTip) {
	    event.target.parentElement.removeChild(toolTip);
	  }
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inputEvent;
	function inputEvent(input, btnConfirm) {
	  if (input.value === '' && input.classList.contains('required')) {
	    input.classList.add('has-error');
	  } else {
	    btnConfirm.classList.remove('display--none');
	  }
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createAnchorElement;
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAnchorElement(linkConfig) {
	  var anchor = document.createElement('a');
	  anchor.setAttribute('href', linkConfig.href);
	  anchor.innerHTML = linkConfig.linkText;
	  _get__('addClasses')(anchor, linkConfig.classList);
	
	  return anchor;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _addClasses2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createAnchorElement === 'undefined' ? 'undefined' : _typeof(createAnchorElement);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createAnchorElement, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createAnchorElement)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeInputElement;
	function removeInputElement(element) {
	  var parent = element.parentElement;
	  var inputValue = element.firstElementChild.value;
	  parent.removeChild(element);
	  parent.parentElement.classList.remove('format-done');
	
	  return {
	    parent: parent,
	    inputValue: inputValue
	  };
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobile;
	function isMobile() {
	  var mobileBreakpoint = 768;
	  if (window.innerWidth < mobileBreakpoint) {
	    return true;
	  }
	  return false;
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deleteRow;
	function deleteRow(event) {
	  if (event.target.parentElement.parentElement.parentElement.parentElement.classList.contains('table--detail__expanded')) {
	    event.target.parentElement.parentElement.parentElement.parentElement.deleteRow(event.target.parentElement.parentElement.rowIndex + 1);
	  }
	
	  return event.target.parentElement.parentElement.parentElement.parentElement.deleteRow(event.target.parentElement.parentElement.rowIndex);
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Tabs = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initTabs;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tab = function () {
	  /**
	   * @param  {Tabs}     tabs        Instance of Tabs which contains this tab
	   * @param  {Dom}      toggle      toggle button
	   * @param  {Dom}      tab         block to hide or show
	   * @param  {Dom}      toggleGroup group of toggles
	   * @param  {Object}   config      Config object defining whether the tab should be
	   *                                scrollable and/or closeable.
	   */
	  function Tab(tabs, toggle, tab, toggleGroup) {
	    var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	    _classCallCheck(this, Tab);
	
	    var _config$scrollable = config.scrollable,
	        scrollable = _config$scrollable === undefined ? true : _config$scrollable,
	        _config$closeable = config.closeable,
	        closeable = _config$closeable === undefined ? false : _config$closeable;
	
	    this.tabs = tabs;
	    this.toggle = toggle;
	    this.tab = tab;
	    this.toggleGroup = toggleGroup;
	    this.scrollable = scrollable;
	    this.closeable = closeable;
	    this.scrollableOn = false;
	    if (this.toggle.classList.contains(this.tabs.activeToggleClassName)) {
	      this.open();
	    } else {
	      this.close();
	    }
	    this.init();
	  }
	
	  _createClass(Tab, [{
	    key: 'init',
	    value: function init() {
	      _get__('addEvent')(this.toggle, 'click', this.open.bind(this));
	      // Check if the tab is closeable
	      if (this.closeable) {
	        // Wrap the tab title in a <span> so that we can inject the close button before it
	        var tabTitle = document.createElement('span');
	        tabTitle.innerText = this.toggle.innerText;
	        // Add the close icon and bind the click event
	        this.btnClose = document.createElement('button');
	        _get__('addClasses')(this.btnClose, ['btn', 'btn--transparent', 'hard', 'push-quarter--right']);
	        this.btnClose.innerHTML = '<i class="fa fa-times"></i>';
	        this.toggle.innerText = '';
	        this.toggle.appendChild(this.btnClose);
	        this.toggle.appendChild(tabTitle);
	        _get__('addEvent')(this.btnClose, 'click', this.remove.bind(this));
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (this.tabs.active === this) {
	        // already open
	        return;
	      }
	      if (this.tabs.active) {
	        this.tabs.active.close();
	      }
	      this.tabs.active = this;
	      this.tab.style.display = 'block';
	      this.toggle.classList.add(this.tabs.activeToggleClassName);
	      if (this.scrollable) {
	        var tabToggleWidth = this.toggle.clientWidth;
	        var tabToggleLeft = this.toggle.offsetLeft;
	        var tabToggleRight = tabToggleLeft + tabToggleWidth;
	        var tabToggleGroupWidth = this.toggleGroup.clientWidth;
	        if (tabToggleLeft < this.toggleGroup.scrollLeft) {
	          this.tabs.scroll(tabToggleLeft);
	        }
	        if (tabToggleRight > this.toggleGroup.scrollLeft + tabToggleGroupWidth) {
	          this.tabs.scroll(tabToggleRight - tabToggleGroupWidth);
	        }
	      }
	      _get__('triggerEvent')(this.toggle, 'open.commonui.tabs');
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.tab.style.display = 'none';
	      this.toggle.classList.remove(this.tabs.activeToggleClassName);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(event) {
	      if (event) {
	        event.stopImmediatePropagation();
	      }
	      var tabIndex = this.tabs.initedTabs.indexOf(this);
	      this.tabs.remove({ index: tabIndex });
	      _get__('removeEvent')(this.btnClose, 'click', this.remove);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get__('removeEvent')(this.toggle, 'click', this.open);
	    }
	  }]);
	
	  return Tab;
	}();
	
	var Tabs = exports.Tabs = function () {
	  function Tabs(container) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Tabs);
	
	    var responsive = config.responsive,
	        scrollable = config.scrollable,
	        vertical = config.vertical;
	
	    this.container = container;
	    this.responsive = responsive;
	
	    if (vertical && scrollable) {
	      /* eslint-disable no-console */
	      console.warn('vertical tabs cannot be scrollable');
	      /* eslint-enable no-console */
	    }
	
	    this.vertical = vertical;
	    this.scrollable = this.vertical === true ? false : scrollable;
	    this.setClassNames();
	
	    this.setDropdown = this.setDropdown.bind(this);
	    this.dropdownUpdate = this.dropdownUpdate.bind(this);
	
	    this.magicNumberForTabToggleOffset = 6;
	    this.magicNumberForResizeThrottling = 100;
	
	    this.init();
	  }
	
	  _createClass(Tabs, [{
	    key: 'init',
	    value: function init() {
	      this.toggleGroup = this.container.querySelector(this.toggleGroupSelector);
	      this.tabsGroup = this.container.querySelector(this.tabsGroupSelector);
	      this.toggleDOMElements = this.container.querySelectorAll(this.toggleSelector);
	      this.tabDOMElements = this.container.querySelectorAll(this.tabSelector);
	      this.toggles = Array.from(this.toggleDOMElements);
	      this.tabs = Array.from(this.tabDOMElements);
	
	      this.initedTabs = [];
	
	      if (!this.isEverythingOk()) {
	        return;
	      }
	
	      for (var index = 0; index < this.toggles.length; index++) {
	        var toggleDOMElement = this.toggles[index];
	        var tabDOMElement = this.tabs[index];
	        var isCloseable = toggleDOMElement.classList.contains('is-closeable');
	        var tabOptions = { scrollable: this.scrollable, closeable: isCloseable };
	        var tab = new (_get__('Tab'))(this, toggleDOMElement, tabDOMElement, this.toggleGroup, tabOptions);
	        this.initedTabs.push(tab);
	      }
	
	      if (this.vertical) {
	        this.container.classList.add('tabs--vertical');
	      }
	
	      if (this.responsive) {
	        this.container.classList.add('tabs--responsive');
	        this.createResponsiveDropdown();
	      }
	
	      this.setScrollableState();
	
	      this.windowScrollResize = new (_get__('Throttle'))(this.setScrollableState.bind(this), this.magicNumberForResizeThrottling);
	      _get__('addEvent')(window, 'resize', this.windowScrollResize.trigger);
	    }
	  }, {
	    key: 'setScrollableState',
	    value: function setScrollableState() {
	      if (!this.scrollable) {
	        return;
	      }
	      if (this.checkScrollableState() && !this.scrollableOn) {
	        _get__('wrap')(this.toggleGroup, 'tabs--scrollable');
	
	        this.scrollLeftButton = document.createElement('button');
	        this.scrollRightButton = document.createElement('button');
	
	        _get__('addClasses')(this.scrollLeftButton, ['tabs__scroller', 'tabs__scroller--left', 'js-action--scroll-left']);
	        _get__('addClasses')(this.scrollRightButton, ['tabs__scroller', 'tabs__scroller--right', 'js-action--scroll-right']);
	
	        this.scrollLeftButton.innerHTML = '<i class="fa fa-chevron-left"></i>';
	        this.scrollRightButton.innerHTML = '<i class="fa fa-chevron-right"></i>';
	
	        this.toggleGroup.parentNode.insertBefore(this.scrollLeftButton, this.toggleGroup);
	        this.toggleGroup.parentNode.appendChild(this.scrollRightButton);
	
	        // Initialize some instance variables
	        this.scrollLeftPosition = 0;
	        this.scrollIndex = 0;
	
	        this.checkScrollButtonState();
	        this.windowResize = new (_get__('Throttle'))(this.checkScrollButtonState.bind(this), this.magicNumberForResizeThrottling);
	
	        _get__('addEvent')(this.scrollLeftButton, 'click', this.scrollLeft.bind(this));
	        _get__('addEvent')(this.scrollRightButton, 'click', this.scrollRight.bind(this));
	        _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	
	        this.scrollableOn = true;
	      } else if (!this.checkScrollableState() && this.scrollableOn) {
	        if (this.scrollLeftButton) {
	          this.scrollLeftButton.remove();
	        }
	        if (this.scrollRightButton) {
	          this.scrollRightButton.remove();
	        }
	        _get__('unwrap')(this.toggleGroup, 'tabs--scrollable');
	        _get__('removeEvent')(window, 'resize', this.windowResize.trigger);
	        this.scrollableOn = false;
	      } else if (this.checkScrollableState() && this.scrollableOn) {
	        this.checkScrollButtonState();
	      }
	    }
	  }, {
	    key: 'checkScrollableState',
	    value: function checkScrollableState() {
	      return this.toggleGroup.scrollWidth > this.toggleGroup.clientWidth;
	    }
	    /**
	     * Scrolls the tab toggle group to the previous tab, i.e. to the left.
	     */
	
	  }, {
	    key: 'scrollLeft',
	    value: function scrollLeft() {
	      // Check that there is room to scroll,
	      // i.e. if we're already on the first tab then don't change the scroll index
	      if (this.scrollIndex > 0) {
	        this.scrollIndex--;
	      }
	      this.scrollLeftPosition -= this.toggles[this.scrollIndex].clientWidth + this.magicNumberForTabToggleOffset;
	      if (this.scrollLeftPosition < 0) {
	        this.scrollLeftPosition = 0;
	      }
	      this.scroll(this.scrollLeftPosition);
	    }
	
	    /**
	     * Scrolls the tab toggle group to the next tab, i.e. to the right.
	     */
	
	  }, {
	    key: 'scrollRight',
	    value: function scrollRight() {
	      this.scrollLeftPosition += this.toggles[this.scrollIndex].clientWidth + this.magicNumberForTabToggleOffset;
	      // Check that there is still room to scroll,
	      // i.e. if we're already on the last tab then don't change the scroll index
	      if (this.scrollIndex < this.toggles.length - 1) {
	        this.scrollIndex++;
	      }
	      this.scroll(this.scrollLeftPosition);
	    }
	
	    /**
	     * Scrolls the tab toggle group to the specified position and then updates the scrolling button state.
	     * @param position
	     */
	
	  }, {
	    key: 'scroll',
	    value: function scroll(position) {
	      _get__('smoothScroll')(this.toggleGroup, { to: position, cbk: this.checkScrollButtonState.bind(this) });
	    }
	
	    /**
	     * Sets the 'disabled' state of each of the left and right scrolling buttons
	     * based on the scroll position of the overflowed container.
	     */
	
	  }, {
	    key: 'checkScrollButtonState',
	    value: function checkScrollButtonState() {
	      if (this.toggleGroup.scrollLeft <= 0) {
	        this.scrollLeftButton.setAttribute('disabled', true);
	      } else {
	        this.scrollLeftButton.removeAttribute('disabled');
	      }
	      if (this.toggleGroup.scrollLeft + this.toggleGroup.clientWidth >= this.toggleGroup.scrollWidth) {
	        this.scrollRightButton.setAttribute('disabled', true);
	      } else {
	        this.scrollRightButton.removeAttribute('disabled');
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var index = options.index,
	          _options$selector = options.selector,
	          selector = _options$selector === undefined ? '' : _options$selector;
	
	      if (index >= 0 && index < this.initedTabs.length) {
	        this.initedTabs[index].open();
	        return;
	      }
	      if (selector === '') {
	        return;
	      }
	      var tabToFind = document.querySelector(selector);
	      if (tabToFind) {
	        /* eslint-disable arrow-parens */
	        var foundTab = this.initedTabs.find(function (x) {
	          return x.tab === tabToFind;
	        });
	        /* eslint-enable arrow-parens */
	        if (foundTab) {
	          foundTab.open();
	          return;
	        }
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var index = options.index,
	          _options$selector2 = options.selector,
	          selector = _options$selector2 === undefined ? '' : _options$selector2;
	
	      if (index >= 0 && index < this.initedTabs.length) {
	        this.initedTabs[index].close();
	        return;
	      }
	      if (selector === '') {
	        return;
	      }
	      var tabToFind = document.querySelector(selector);
	      if (tabToFind) {
	        /* eslint-disable arrow-parens */
	        var foundTab = this.initedTabs.find(function (x) {
	          return x.tab === tabToFind;
	        });
	        /* eslint-enable arrow-parens */
	        if (foundTab) {
	          foundTab.close();
	          return;
	        }
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var index = config.index;
	      var _config$title = config.title,
	          title = _config$title === undefined ? '' : _config$title,
	          _config$scrollable2 = config.scrollable,
	          scrollable = _config$scrollable2 === undefined ? true : _config$scrollable2;
	
	      var newTabToggle = document.createElement('div');
	      var newTab = document.createElement('div');
	      var newTabTitle = document.createElement('span');
	      newTabTitle.innerText = title;
	      newTabToggle.classList.add(this.toggleClassName);
	      newTabToggle.appendChild(newTabTitle);
	
	      newTab.classList.add(this.tabClassName);
	      newTab.style.display = 'none';
	
	      index = index || this.initedTabs.length;
	
	      var tab = new (_get__('Tab'))(this, newTabToggle, newTab, this.toggleGroup, config);
	      if (index >= 0 && index < this.initedTabs.length) {
	        this.toggleGroup.insertBefore(newTabToggle, this.toggleGroup.children[index]);
	        this.tabsGroup.insertBefore(newTab, this.tabsGroup.children[index]);
	        this.toggles.splice(index, 0, newTabToggle);
	        this.initedTabs.splice(index, 0, tab);
	      } else {
	        this.toggleGroup.appendChild(newTabToggle);
	        this.tabsGroup.appendChild(newTab);
	        this.toggles.push(newTabToggle);
	        this.initedTabs.push(tab);
	      }
	
	      // Add the new tab to the dropdown if in responsive mode
	      if (this.responsive) {
	        this.addDropdownItem(index, title, title);
	      }
	
	      if (scrollable) {
	        this.setScrollableState();
	      }
	
	      // Open the tab and autoscroll to it
	      tab.open();
	
	      // Finally, return the tab
	      return tab;
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var tabIndex = options.index;
	      // Ensure that the index of the tab we are going to remove is valid
	      if (tabIndex < 0 || tabIndex >= this.initedTabs.length) {
	        return;
	      }
	      var tabToggle = this.toggleGroup.children[tabIndex];
	      var tab = this.tabsGroup.children[tabIndex];
	      this.toggleGroup.removeChild(tabToggle);
	      this.tabsGroup.removeChild(tab);
	      if (this.responsive) {
	        _get__('removeEvent')(this.initedTabs[tabIndex].toggle, 'open.commonui.tabs', this.setDropdown);
	        this.dropdown.removeChild(this.dropdown.children[tabIndex]);
	      }
	      this.toggles.splice(tabIndex, 1);
	      this.initedTabs.splice(tabIndex, 1);
	      this.setScrollableState();
	      // If the tab being removed is the active tab then
	      // open the tab after this tab, as long as it wasn't the last tab
	      if (tabToggle.classList.contains(this.activeToggleClassName)) {
	        var tabIndexToOpen = tabIndex;
	        if (tabIndexToOpen >= this.initedTabs.length) {
	          tabIndexToOpen = this.initedTabs.length - 1;
	        }
	        this.open({ index: tabIndexToOpen });
	      }
	    }
	  }, {
	    key: 'createResponsiveDropdown',
	    value: function createResponsiveDropdown() {
	      this.dropdown = document.createElement('select');
	      this.dropdown.classList.add('visuallyhidden--xs-and-up');
	      for (var index = 0; index < this.initedTabs.length; index++) {
	        // Create select option for each tab
	        this.addDropdownItem(index, this.toggles[index].textContent, this.toggles[index].textContent);
	      }
	      _get__('addEvent')(this.dropdown, 'change', this.dropdownUpdate);
	      this.container.insertBefore(this.dropdown, this.container.firstChild);
	    }
	
	    /**
	     * Adds an item to the responsive dropdown at the specified index, with the specified value and text.
	     * @param {Number} index  The index that the dropdown item should be injected at.
	     * @param {String} value  The value set on the dropdown item.
	     * @param {String} text   The text to be displayed in the dropdown item.
	     */
	
	  }, {
	    key: 'addDropdownItem',
	    value: function addDropdownItem(index, value, text) {
	      var option = document.createElement('option');
	      option.value = value;
	      option.text = text;
	      if (index < this.dropdown.children.length - 1) {
	        this.dropdown.insertBefore(option, this.dropdown.children[index]);
	      } else {
	        this.dropdown.appendChild(option);
	      }
	      // Add class to hide on xs on the buttons
	      this.toggles[index].classList.add('visuallyhidden--xs-only');
	      // Bind to each open to keep dropdown in sync
	      _get__('addEvent')(this.initedTabs[index].toggle, 'open.commonui.tabs', this.setDropdown);
	    }
	  }, {
	    key: 'setDropdown',
	    value: function setDropdown(event) {
	      this.dropdown.value = event.srcElement.textContent;
	    }
	  }, {
	    key: 'dropdownUpdate',
	    value: function dropdownUpdate(event) {
	      this.initedTabs[event.target.selectedIndex].open();
	    }
	
	    /**
	     * Initializes classes and selectors for blocks
	     */
	
	  }, {
	    key: 'setClassNames',
	    value: function setClassNames() {
	      this.blockClassName = 'tabs';
	      this.toggleGroupSelector = '.tabs__toggle-group';
	      this.tabsGroupSelector = '.tabs__tabs-group';
	      this.toggleClassName = 'tabs__toggle';
	      this.toggleSelector = '.' + this.toggleClassName;
	      this.tabClassName = 'tabs__tab';
	      this.tabSelector = '.' + this.tabClassName;
	      this.activeToggleClassName = 'tabs__toggle--active';
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (this.toggles.length === 0) {
	        console.warn('CommonUI - Tabs - There\'s no toggles for tabs');
	        return false;
	      } else if (this.tabs.length === 0) {
	        console.warn('CommonUI - Tabs - There\'s no content tabs');
	        return false;
	      } else if (this.toggles.length !== this.tabs.length) {
	        console.warn('CommonUI - Tabs - Tabs toggles and tabs amounts are not matching');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.responsive) {
	        for (var index = 0; index < this.initedTabs.length; index++) {
	          _get__('removeEvent')(this.initedTabs[index].toggle, 'open.commonui.tabs', this.setDropdown);
	          _get__('removeEvent')(this.dropdown, 'change', this.dropdownUpdate);
	        }
	        this.dropdown.outerHTML = '';
	      }
	      if (this.scrollable) {
	        _get__('removeEvent')(this.scrollLeftButton, 'click', this.scrollLeft.bind(this));
	        _get__('removeEvent')(this.scrollRightButton, 'click', this.scrollRight.bind(this));
	        _get__('removeEvent')(window, 'resize', this.windowResize.trigger);
	      }
	      while (this.initedTabs.length > 0) {
	        var tab = this.initedTabs.pop();
	        tab.destroy();
	      }
	    }
	  }]);
	
	  return Tabs;
	}();
	
	/**
	 * iterates through all matched blocks and initializes tabs classes
	 * @param  {Object} config
	 */
	
	
	function initTabs() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { selector: '.js-tabs', responsive: false, scrollable: true };
	
	  var tabs = null;
	  if (typeof config.selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(config.selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var container = _step.value;
	
	        tabs = new (_get__('Tabs'))(container, config);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return tabs;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Tab':
	      return Tab;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'wrap':
	      return _html.wrap;
	
	    case 'unwrap':
	      return _html.unwrap;
	
	    case 'smoothScroll':
	      return _html.smoothScroll;
	
	    case 'Tabs':
	      return Tabs;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initTabs === 'undefined' ? 'undefined' : _typeof(initTabs);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initTabs, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initTabs)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Tooltip = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-console, no-underscore-dangle,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     newline-after-var, id-match,  operator-linebreak, prefer-reflect, arrow-body-style */
	
	
	exports.default = initTooltip;
	
	var _popper = __webpack_require__(40);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// const ARROW_HEIGHT = 20;
	var CLASS_PREFIX = 'tooltip';
	// const BSCLS_PREFIX_REGEX = new RegExp(`(^|\\s)${ CLASS_PREFIX }\\S+`, 'g');
	
	var Default = {
	  animation: true,
	  template: '\n    <div class="tooltip">\n      <div class="tooltip__inner"></div>\n      <div class="tooltip__arrow"></div>\n    </div>\n  ',
	  trigger: ['hover', 'focus'],
	  title: '',
	  delay: 0,
	  html: false,
	  selector: false,
	  placement: 'top',
	  offset: 0,
	  container: false,
	  fallbackPlacement: 'flip',
	  boundary: 'scrollParent',
	  theme: false
	};
	
	var AttachmentMap = {
	  AUTO: 'auto',
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	var HoverState = {
	  SHOW: 'show',
	  OUT: 'out'
	};
	//
	var Selector = {
	  // TOOLTIP: '.tooltip',
	  ARROW: '.' + _get__('CLASS_PREFIX') + '__arrow',
	  TOOLTIP_INNER: '.' + _get__('CLASS_PREFIX') + '__inner'
	};
	
	var ClassName = {
	  ANIMATE: _get__('CLASS_PREFIX') + '--animate',
	  SHOW: _get__('CLASS_PREFIX') + '--show'
	};
	
	var Tooltip = exports.Tooltip = function () {
	
	  /**
	   * @param  {Dom}       element       tooltip element
	   * @param  {Object}    config        configuration
	   */
	  function Tooltip(element, config) {
	    _classCallCheck(this, Tooltip);
	
	    this._themes = ['light', 'error', 'alternative', 'white'];
	
	    this.element = element;
	    this.config = this._getConfig(config);
	
	    if (!this._healthCheck()) {
	      return;
	    }
	
	    this.addTooltip = this.addTooltip.bind(this);
	    this.removeTooltip = this.removeTooltip.bind(this);
	    this.toggleTooltip = this.toggleTooltip.bind(this);
	    this.checkForScollVal = this.checkForScollVal.bind(this);
	
	    this.magicNumberForOffsetInPixels = 20;
	    this.magicNumberForTooltipMaxSizeProportion = 1.5;
	
	    this.tooltipOpen = false;
	
	    // Initialize accordion
	    this._setListeners();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'checkForScollVal',
	    value: function checkForScollVal() {
	      var currentElement = this.tooltipElement;
	      var reachedBody = false;
	      var scrollTop = 0;
	      var scrollLeft = 0;
	      do {
	        if (currentElement.tagName === 'BODY') {
	          reachedBody = true;
	        } else if (/(auto|scroll|overlay)/.test(currentElement.style.overflow) || /(auto|scroll|overlay)/.test(currentElement.style.overflowX) || /(auto|scroll|overlay)/.test(currentElement.style.overflowY)) {
	          scrollTop += currentElement.scrollTop;
	          scrollLeft += currentElement.scrollLeft;
	          currentElement = currentElement.parentNode;
	        } else {
	          currentElement = currentElement.parentNode;
	        }
	      } while (reachedBody === false);
	      return {
	        top: scrollTop,
	        left: scrollLeft
	      };
	    }
	  }, {
	    key: 'addTooltip',
	    value: function addTooltip() {
	      var _this = this;
	
	      this.tooltipOpen = true;
	
	      // Get text
	      this.title = this.getTitle();
	
	      var tooltipLength = 140;
	      // Limit tooltip limit to 140 chars
	      if (this.title.length > tooltipLength) {
	        return false;
	      }
	
	      // Remove text from target node
	      this.element.removeAttribute('title');
	
	      // Add tooltip to document
	      var tooltip = this.getTipElement();
	
	      this.setContent();
	
	      if (this.config.animation) {
	        tooltip.classList.add(_get__('ClassName').ANIMATE);
	      }
	
	      this._setTheme(this.config.theme);
	
	      var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tooltip, this.element) : this.config.placement;
	
	      var attachment = this._getAttachment(placement);
	      this.addAttachmentClass(attachment);
	
	      var container = this.config.container === false ? document.body : document.querySelector(this.config.container);
	      container.appendChild(tooltip);
	
	      this._popper = new (_get__('Popper'))(this.element, tooltip, {
	        placement: attachment,
	        modifiers: {
	          offset: {
	            offset: this.config.offset
	          },
	          flip: {
	            behavior: this.config.fallbackPlacement
	          },
	          arrow: {
	            element: _get__('Selector').ARROW
	          },
	          preventOverflow: {
	            boundariesElement: this.config.boundary
	          }
	        },
	        onCreate: function onCreate(info) {
	          if (info.originalPlacement !== info.placement) {
	            _this._handlePopperPlacementChange(info);
	          }
	        },
	        onUpdate: function onUpdate(info) {
	          _this._handlePopperPlacementChange(info);
	        }
	      });
	
	      tooltip.classList.add(_get__('ClassName').SHOW);
	      return true;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.removeTooltip();
	      _get__('removeEvent')(this.element, 'mouseenter', this.addTooltip);
	      _get__('removeEvent')(this.element, 'mouseleave', this.removeTooltip);
	      _get__('removeEvent')(this.element, 'touchend', this.toggleTooltip);
	    }
	
	    // Helpers
	
	  }, {
	    key: 'toggleTooltip',
	    value: function toggleTooltip() {
	      this.tooltipOpen ? this.removeTooltip() : this.addTooltip();
	    }
	  }, {
	    key: 'removeTooltip',
	    value: function removeTooltip() {
	      if (this.tooltipOpen) {
	        var tooltip = this.getTipElement();
	        if (this._hoverState !== _get__('HoverState').SHOW && tooltip.parentNode) {
	          tooltip.parentNode.removeChild(tooltip);
	        }
	        this.tooltipOpen = false;
	      }
	    }
	  }, {
	    key: 'getTipElement',
	    value: function getTipElement() {
	      this.tooltip = this.tooltip || this._buildTooltip();
	      return this.tooltip;
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent() {
	      var tooltip = this.getTipElement();
	      this.setElementContent(tooltip.querySelector(_get__('Selector').TOOLTIP_INNER), this.getTitle());
	      // tooltip.removeClass(`${ ClassName.FADE } ${ ClassName.SHOW }`);
	    }
	  }, {
	    key: 'setElementContent',
	    value: function setElementContent(element, content) {
	      var html = this.config.html;
	
	      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && content.nodeType) {
	        if (html) {
	          if (content.parentNode === element) {
	            while (element.firstChild) {
	              element.removeChild(element.firstChild);
	            }
	            element.appendChild(content);
	          }
	        } else {
	          element.textContent(content.textContent());
	        }
	      } else {
	        element[html ? 'innerHTML' : 'textContent'] = content;
	      }
	    }
	  }, {
	    key: 'addAttachmentClass',
	    value: function addAttachmentClass(attachment) {
	      this.getTipElement().classList.add(_get__('CLASS_PREFIX') + '--' + attachment);
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var title = this.element.getAttribute('data-original-title');
	
	      if (!title) {
	        title = typeof this.config.title === 'function' ? Reflect.apply(this.config.title, this.element) : this.config.title;
	      }
	
	      return title;
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: '_healthCheck',
	    value: function _healthCheck() {
	      if (!this.element) {
	        console.warn('CommonUI - Tooltip - There\'s no tooltip found');
	        return false;
	      }
	      if (!this.element.attributes.title || this.element.attributes.title.value !== '' && !this.element.attributes.title.value) {
	        console.warn('CommonUI - Tooltip - Tooltip is missing the title attribute');
	        return false;
	      }
	
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: '_setListeners',
	    value: function _setListeners() {
	      _get__('addEvent')(this.element, 'mouseenter', this.addTooltip);
	      _get__('addEvent')(this.element, 'mouseleave', this.removeTooltip);
	      _get__('addEvent')(this.element, 'touchstart touchend', this.toggleTooltip);
	
	      if (this.config.selector) {
	        this.config = _extends({}, this.config, {
	          trigger: 'manual',
	          selector: ''
	        });
	      } else {
	        this._fixTitle();
	      }
	    }
	  }, {
	    key: '_getAttachment',
	    value: function _getAttachment(placement) {
	      return _get__('AttachmentMap')[placement.toUpperCase()];
	    }
	  }, {
	    key: '_fixTitle',
	    value: function _fixTitle() {
	      var titleType = _typeof(this.element.getAttribute('data-original-title'));
	      if (this.element.getAttribute('title') || titleType !== 'string') {
	        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
	        this.element.setAttribute('title', '');
	      }
	    }
	
	    // _buildTooltip() {
	    //   this.tooltip = htmlFromString(this.config.template);
	    //
	    //   return this.tooltip;
	    // }
	
	  }, {
	    key: '_buildTooltip',
	    value: function _buildTooltip() {
	      this.tooltip = _get__('htmlFromString')(this.config.template);
	
	      return this.tooltip;
	    }
	  }, {
	    key: '_setTheme',
	    value: function _setTheme(theme) {
	      if (theme !== null && typeof theme === 'string') {
	        if (this._themes.indexOf(theme) >= 0) {
	          this.tooltip.classList.add(_get__('CLASS_PREFIX') + '--' + theme);
	        } else {
	          /* eslint-disable no-console */
	          console.warn('CommonUI - Tooltip - The theme ' + theme + ' does not exist');
	          /* eslint-enable no-console */
	        }
	      }
	    }
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, _get__('Default'), _typeof(this.element.dataset) === 'object' ? _extends({}, this.element.dataset) : {}, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
	
	      if (typeof config.delay === 'number') {
	        config.delay = {
	          show: config.delay,
	          hide: config.delay
	        };
	      }
	
	      if (typeof config.title === 'number') {
	        config.title = config.title.toString();
	      }
	
	      if (typeof config.content === 'number') {
	        config.content = config.content.toString();
	      }
	
	      return config;
	    }
	  }, {
	    key: '_cleanAttachmentClass',
	    value: function _cleanAttachmentClass() {
	      var tooltip = this.getTipElement();
	
	      Object.keys(_get__('AttachmentMap')).forEach(function (key) {
	        if (tooltip.classList.contains(_get__('CLASS_PREFIX') + '--' + _get__('AttachmentMap')[key])) {
	          tooltip.classList.remove(_get__('CLASS_PREFIX') + '--' + _get__('AttachmentMap')[key]);
	        }
	      });
	    }
	  }, {
	    key: '_handlePopperPlacementChange',
	    value: function _handlePopperPlacementChange(info) {
	      this._cleanAttachmentClass();
	      this.addAttachmentClass(this._getAttachment(info.placement));
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	/**
	 * @param  {Dom | String}  target     tooltip DOM object or selector string
	 * @param  {Object}        config     config for tolltip
	 */
	// export default function initTooltip(target = 'abbr[rel="tooltip"]', config = {}) {
	//   if (typeof target === 'string') {
	//     target = document.querySelectorAll(target);
	//   }
	//
	//   let tooltips = null;
	//
	//   for (const tooltip of target) {
	//     tooltips = new Tooltip(tooltip, config);
	//   }
	//
	//   return tooltips;
	// }
	
	function initTooltip() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? 'abbr[rel="tooltip"]' : _config$selector;
	
	  var tooltips = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var tooltip = _step.value;
	
	        tooltips = new (_get__('Tooltip'))(tooltip, config);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return tooltips;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'CLASS_PREFIX':
	      return CLASS_PREFIX;
	
	    case 'ClassName':
	      return ClassName;
	
	    case 'Popper':
	      return _popper2.default;
	
	    case 'Selector':
	      return Selector;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'HoverState':
	      return HoverState;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'AttachmentMap':
	      return AttachmentMap;
	
	    case 'htmlFromString':
	      return _html.htmlFromString;
	
	    case 'Default':
	      return Default;
	
	    case 'Tooltip':
	      return Tooltip;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initTooltip === 'undefined' ? 'undefined' : _typeof(initTooltip);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initTooltip, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initTooltip)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Pagination = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable prefer-reflect */
	
	
	exports.default = initPagination;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(42);
	
	var Pagination = exports.Pagination = function () {
	
	  /**
	   * @param  {Dom}    pagination        pagination container
	   */
	  function Pagination(pagination) {
	    _classCallCheck(this, Pagination);
	
	    this.pagination = pagination;
	    this.magicNumberForResizeThrottling = 100;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    // Initialize pagination
	    this.init();
	  }
	
	  _createClass(Pagination, [{
	    key: 'init',
	    value: function init() {
	      // Cast to real array and not nodeList
	      this.pages = this.pagination.querySelectorAll('li:not(.pagination__first):not(.pagination__prev):not(.pagination__next):not(.pagination__last)');
	      this.totalPages = this.pages.length;
	
	      // Fetch the selected Page
	      this.selectedPageIndex = Array.prototype.slice.call(this.pages).findIndex(function (x) {
	        return x.classList.contains('pagination__current');
	      });
	
	      // Starting point for hidden pages - none
	      this.maxAway = 0;
	
	      // Add 'away-1' etc to the pages in the pagination
	      this.assignAwayClasses();
	
	      // Start the hiding at the maximum shown
	      this.currentHiddenAways = this.maxAway + 1;
	
	      // Bind the context with the event
	      this.updatePagination = this.updatePagination.bind(this);
	
	      this.windowResize = new (_get__('Throttle'))(this.updatePagination, this.magicNumberForResizeThrottling);
	
	      this.addListeners();
	      this.updatePagination();
	    }
	  }, {
	    key: 'assignAwayClasses',
	    value: function assignAwayClasses() {
	      for (var i = 0; i < this.totalPages; i++) {
	        if (i !== this.selectedPageIndex) {
	          this.pages[i].classList.add('away-' + Math.abs(this.selectedPageIndex - i));
	          if (Math.abs(this.selectedPageIndex - i) > this.maxAway) {
	            this.maxAway = Math.abs(this.selectedPageIndex - i);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'removeAwayClasses',
	    value: function removeAwayClasses() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var page = _step.value;
	
	          if (!page.classList.contains('pagination__current')) {
	            page.className = '';
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updatePagination',
	    value: function updatePagination() {
	      if (_get__('isOverflowed')(this.pagination, this.pagination.parentElement)) {
	        this.hidePages();
	      } else {
	        this.showPages();
	      }
	    }
	  }, {
	    key: 'hidePages',
	    value: function hidePages() {
	      if (this.currentHiddenAways !== 0) {
	        this.currentHiddenAways--;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = this.pages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var page = _step2.value;
	
	            if (page.classList.contains('away-' + this.currentHiddenAways)) {
	              page.classList.add('hide');
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        if (_get__('isOverflowed')(this.pagination)) {
	          this.hidePages();
	        }
	      }
	    }
	  }, {
	    key: 'showPages',
	    value: function showPages() {
	      if (this.currentHiddenAways !== this.maxAway + 1) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = this.pages[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var page = _step3.value;
	
	            if (page.classList.contains('away-' + this.currentHiddenAways)) {
	              page.classList.remove('hide');
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        this.currentHiddenAways++;
	        this.updatePagination();
	      }
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get__('removeEvent')(window, 'resize', this.windowResize.trigger);
	      this.removeAwayClasses();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.pagination) {
	        console.warn('CommonUI - Alert - There\'s no pagination found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Pagination;
	}();
	
	/**
	 * Creates a new alert instance
	 * @param  {Object} config
	 */
	
	
	function initPagination() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-pagination' : _config$selector;
	
	  var paginations = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = document.querySelectorAll(selector)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var pagination = _step4.value;
	
	        paginations = new (_get__('Pagination'))(pagination);
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	  }
	  return paginations;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'isOverflowed':
	      return _html.isOverflowed;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Pagination':
	      return Pagination;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initPagination === 'undefined' ? 'undefined' : _typeof(initPagination);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initPagination, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initPagination)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Array.prototype.findIndex = Array.prototype.findIndex || function(callback) {
	  if (this === null) {
	    throw new TypeError('Array.prototype.findIndex called on null or undefined');
	  } else if (typeof callback !== 'function') {
	    throw new TypeError('callback must be a function');
	  }
	  var list = Object(this);
	  // Makes sures is always has an positive integer as length.
	  var length = list.length >>> 0;
	  var thisArg = arguments[1];
	  for (var i = 0; i < length; i++) {
	    if ( callback.call(thisArg, list[i], i, list) ) {
	      return i;
	    }
	  }
	  return -1;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Loader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initModal;
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Loader = exports.Loader = function () {
	
	  /**
	   * @param  {Dom}    loaderTarget     target to cover with the loader
	   * @param  {String} message          text to display on loading
	   * @param  {Bool}   fullscreen       if intended to cover the whole screen
	   */
	  function Loader(loaderTarget, message, fullscreen, theme, deferred) {
	    _classCallCheck(this, Loader);
	
	    this.loaderTarget = loaderTarget;
	    this.message = message;
	    this.fullscreen = fullscreen;
	    this.theme = theme;
	    this.isShowing = false;
	    this.isDeferred = deferred;
	    this.MILLISECONDS_SECONDS_RATIO = 1000;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    // Initialize loader
	    this.init();
	  }
	
	  _createClass(Loader, [{
	    key: 'init',
	    value: function init() {
	      if (!this.isDeferred) {
	        this.createLoader();
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.createLoader();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.destroy();
	    }
	  }, {
	    key: 'createLoader',
	    value: function createLoader() {
	      var _this = this;
	
	      // Create the various bits of the overlay
	      this.loaderOverlay = document.createElement('div');
	      this.loaderOverlay.classList.add('loader-overlay');
	
	      if (this.theme !== 'dark') {
	        this.loaderOverlay.classList.add('loader-overlay--' + this.theme);
	      }
	
	      if (this.fullscreen) {
	        this.loaderOverlay.classList.add('loader-fullscreen');
	      }
	
	      this.wrapper = document.createElement('div');
	      this.wrapper.classList.add('loader-wrapper');
	      this.loader = document.createElement('div');
	      this.loader.classList.add('loader');
	      this.loaderText = document.createElement('p');
	
	      if (Array.isArray(this.message)) {
	        // Message is an array - handle progress wording
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var wording = _step.value;
	
	            if (wording.hasOwnProperty('changeAt') && wording.hasOwnProperty('text')) {
	              if (Number.isInteger(wording.changeAt) && wording.text !== '') {
	                setTimeout(function () {
	                  return _this.setText(wording.text);
	                }, wording.changeAt * _this.MILLISECONDS_SECONDS_RATIO);
	              }
	            }
	          };
	
	          for (var _iterator = this.message[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else {
	        // Set static message
	        this.setText(this.message);
	      }
	
	      // Create the structure
	      this.wrapper.appendChild(this.loader);
	      this.wrapper.appendChild(this.loaderText);
	      this.loaderOverlay.appendChild(this.wrapper);
	      // Add to dom if not already there.
	      if (!_get__('hasDirectDescendant')(this.loaderTarget, this.loaderOverlay)) {
	        this.isShowing = true;
	        this.loaderTarget.appendChild(this.loaderOverlay);
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(message) {
	      this.loaderText.innerHTML = message;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.isShowing) {
	        this.isShowing = false;
	        this.loaderTarget.removeChild(this.loaderOverlay);
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.loaderTarget) {
	        console.warn('CommonUI - Loader - No element found to target');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Loader;
	}();
	
	/**
	 * creates a new loader instance
	 * @param  {Object} config
	 */
	
	
	function initModal() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-loader' : _config$selector,
	      _config$message = config.message,
	      message = _config$message === undefined ? 'Loading...' : _config$message,
	      _config$fullscreen = config.fullscreen,
	      fullscreen = _config$fullscreen === undefined ? true : _config$fullscreen,
	      _config$theme = config.theme,
	      theme = _config$theme === undefined ? 'dark' : _config$theme,
	      _config$deferred = config.deferred,
	      deferred = _config$deferred === undefined ? false : _config$deferred;
	
	  var loader = null;
	  if (typeof selector === 'string') {
	    loader = new (_get__('Loader'))(document.querySelector(selector), message, fullscreen, theme, deferred);
	  }
	  return loader;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'hasDirectDescendant':
	      return _html.hasDirectDescendant;
	
	    case 'Loader':
	      return Loader;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initModal === 'undefined' ? 'undefined' : _typeof(initModal);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initModal, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initModal)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Dropdown = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initDropdown;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Dropdown = exports.Dropdown = function () {
	
	  /**
	   * @param  {Dom}    dropdown          container to hold dropdown
	   * @param  {String} toggleSelector    selector toggle for dropdown reveal
	   */
	  function Dropdown(dropdown, toggleSelector, menuSelector, allSelector) {
	    _classCallCheck(this, Dropdown);
	
	    this.dropdown = dropdown;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.toggleSelector = dropdown.querySelector(toggleSelector);
	    this.menuSelector = dropdown.querySelector(menuSelector);
	    this.allSelector = document.querySelectorAll(allSelector);
	    this.isOpen = false;
	    this.action = 'click';
	    this.mask = null;
	    this.direction = 'down';
	    this.linksSelector = this.menuSelector.querySelectorAll('a');
	
	    this.checkClickOff = this.checkClickOff.bind(this);
	    this.toggle = this.toggle.bind(this);
	    this.linkClick = this.linkClick.bind(this);
	    this.removeMask = this.removeMask.bind(this);
	
	    // Initialize dropdown
	    this.init();
	  }
	
	  _createClass(Dropdown, [{
	    key: 'init',
	    value: function init() {
	      // set direction of dropdown
	      if (this.dropdown.hasAttribute('data-direction')) {
	        if (this.dropdown.getAttribute('data-direction') === 'up') {
	          this.direction = 'up';
	          _get__('addClasses')(this.dropdown, ['dropdown-up']);
	        }
	      }
	      if (this.toggleSelector) {
	        _get__('addEvent')(this.toggleSelector, 'click', this.toggle);
	        if (this.menuSelector) {
	          this.menuSelector.style.width = this.toggleSelector.offsetWidth + 'px';
	          if (this.direction === 'up') {
	            this.menuSelector.style.bottom = this.toggleSelector.offsetHeight + 'px';
	          }
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = this.linksSelector[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var link = _step.value;
	
	              _get__('addEvent')(link, 'click', this.linkClick);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	      if (this.isOpen) {
	        this.close();
	      } else {
	        this.open();
	      }
	    }
	  }, {
	    key: 'closeAll',
	    value: function closeAll() {
	      if (window.commonUI) {
	        if (window.commonUI.dropdowns) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = window.commonUI.dropdowns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var dropdown = _step2.value;
	
	              if (typeof dropdown.close === 'function') {
	                dropdown.close();
	                if (dropdown.mask && dropdown.maskTarget.contains(dropdown.mask)) {
	                  _get__('removeElement')(dropdown.mask);
	                  dropdown.mask = null;
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      }
	    }
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.closeAll();
	      _get__('addClasses')(this.dropdown, [this.direction === 'up' ? 'dropdown-up-open' : 'dropdown-open']);
	      _get__('addEvent')(document, 'click', this.checkClickOff);
	      this.isOpen = true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: 'removeMask',
	    value: function removeMask() {
	      if (this.maskTarget && this.maskTarget.contains(this.mask)) {
	        _get__('removeElement')(this.mask);
	      }
	      this.mask = null;
	    }
	  }, {
	    key: 'checkClickOff',
	    value: function checkClickOff(event) {
	      if (!this.dropdown.contains(event.target)) {
	        this.close();
	      }
	    }
	  }, {
	    key: 'linkClick',
	    value: function linkClick() {
	      this.close();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.isOpen = false;
	      this.toggleSelector.blur();
	      _get__('removeEvent')(document, 'click', this.checkClickOff);
	      if (this.action === 'click') {
	        _get__('removeClasses')(this.dropdown, ['dropdown-open', 'dropdown-up-open']);
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.dropdown) {
	        console.warn('CommonUI - Dropup - There\'s no dropdown found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Dropdown;
	}();
	
	/**
	 * Creates dropdown instances and returns array
	 * @param  {Object} config
	 */
	
	
	function initDropdown() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.dropdown, .dropup' : _config$selector,
	      _config$toggleSelecto = config.toggleSelector,
	      toggleSelector = _config$toggleSelecto === undefined ? 'button[data-toggle="dropdown"]' : _config$toggleSelecto,
	      _config$menuSelector = config.menuSelector,
	      menuSelector = _config$menuSelector === undefined ? '.dropdown-menu, .dropup-menu' : _config$menuSelector;
	
	  var dropdowns = [];
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = document.querySelectorAll(selector)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var dropdown = _step3.value;
	
	        dropdowns.push(new (_get__('Dropdown'))(dropdown, toggleSelector, menuSelector, selector));
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	  }
	  window.commonUI = window.commonUI ? window.commonUI : {};
	  window.commonUI.dropdowns = dropdowns;
	  return dropdowns;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeElement':
	      return _html.removeElement;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'Dropdown':
	      return Dropdown;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDropdown === 'undefined' ? 'undefined' : _typeof(initDropdown);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDropdown, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDropdown)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.BackToTop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initBackToTop;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BackToTop = exports.BackToTop = function () {
	
	  /**
	   * @param {Number} marginBottom Number of pixels to offset vertically from the bottom edge.
	   * @param {Number} marginRight  Number of pixels to offset horizontally from the right edge.
	   */
	  function BackToTop(marginBottom, marginRight) {
	    _classCallCheck(this, BackToTop);
	
	    this.cssClass = 'back-to-top';
	    this.selector = '.' + this.cssClass;
	    this.marginBottom = marginBottom;
	    this.marginRight = marginRight;
	    this.magicNumberForScrollTopTrigger = 100;
	    this.magicNumberForScrollThrottling = 100;
	    this.isTouchDevice = 'ontouchstart' in window || window.DocumentTouch;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    this.init();
	  }
	
	  _createClass(BackToTop, [{
	    key: 'init',
	    value: function init() {
	      this.scrollingElement = document.scrollingElement || document.documentElement;
	      this.backToTop = document.querySelector(this.selector);
	      if (this.backToTop) {
	        return;
	      }
	      this.backToTop = document.createElement('div');
	      if (this.marginBottom || this.marginRight) {
	        if (this.marginBottom) {
	          this.backToTop.style.marginBottom = this.marginBottom + 'px';
	        }
	        if (this.marginRight) {
	          this.backToTop.style.marginRight = this.marginRight + 'px';
	        }
	      }
	      if (!this.backToTop.classList.contains(this.cssClass)) {
	        this.backToTop.classList.add(this.cssClass);
	      }
	      this.backToTop.innerHTML = '<i class="fa fa-angle-up fa-2x"></i>';
	      this.scrollingElement.appendChild(this.backToTop);
	      this.bindEvents();
	      this.toggleBackToTop();
	    }
	
	    /**
	     * Bind a throttled event handler to the window scroll event
	     * to check whether the back to top element should be displayed or not.
	     * Also binds the click event of the back to top element itself to the scrollToTop method.
	     */
	
	  }, {
	    key: 'bindEvents',
	    value: function bindEvents() {
	      this.windowScroll = new (_get__('Throttle'))(this.toggleBackToTop.bind(this), this.magicNumberForScrollThrottling);
	      _get__('addEvent')(window, 'scroll', this.windowScroll.trigger);
	      _get__('addEvent')(this.backToTop, 'touchstart', this.scrollToTop.bind(this));
	      _get__('addEvent')(this.backToTop, 'click', this.scrollToTop.bind(this));
	    }
	
	    /**
	     * Determines whether the back to top element should be displayed or not.
	     * The back to top element will be displayed when the window has been scrolled 100 pixels.
	     */
	
	  }, {
	    key: 'toggleBackToTop',
	    value: function toggleBackToTop() {
	      if (this.scrollingElement.scrollTop > this.magicNumberForScrollTopTrigger) {
	        _get__('fadeIn')(this.backToTop, 'inline');
	      } else {
	        _get__('fadeOut')(this.backToTop);
	      }
	    }
	
	    /**
	     * Scrolls the document body back to the top using a smooth animation.
	     */
	
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop(event) {
	      event.preventDefault();
	      if (this.isTouchDevice) {
	        this.scrollingElement.scrollTop = 0;
	      } else {
	        _get__('smoothScroll')(this.scrollingElement, { axis: 'vertical' });
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      // Ensure that any custom margins are integers
	      if (this.marginBottom && !Number.isInteger(this.marginBottom) || this.marginRight && !Number.isInteger(this.marginRight)) {
	        console.warn('CommonUI - Back to Top - Custom margins must be valid integers.');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return BackToTop;
	}();
	
	/**
	 * Creates a new "Back to Top" instance.
	 * Allows an optional config to be specified for setting of bottom and/or right margins.
	 * @param  {Object} config
	 */
	
	
	function initBackToTop() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$marginBottom = config.marginBottom,
	      marginBottom = _config$marginBottom === undefined ? null : _config$marginBottom,
	      _config$marginRight = config.marginRight,
	      marginRight = _config$marginRight === undefined ? null : _config$marginRight;
	
	  return new (_get__('BackToTop'))(marginBottom, marginRight);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'fadeIn':
	      return _html.fadeIn;
	
	    case 'fadeOut':
	      return _html.fadeOut;
	
	    case 'smoothScroll':
	      return _html.smoothScroll;
	
	    case 'BackToTop':
	      return BackToTop;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initBackToTop === 'undefined' ? 'undefined' : _typeof(initBackToTop);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initBackToTop, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initBackToTop)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Drawer = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */
	
	
	exports.default = initDrawer;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(17);
	
	var ESCAPE_KEYCODE = 27;
	var TABINDEX_VALUE = -1;
	var TRANSITION_DURATION = 300;
	var Default = {
	  customWidth: false,
	  direction: 'right',
	  positiveTrigger: '.js-drawer-positive',
	  negativeTrigger: '.js-drawer-close'
	};
	var ClassName = {
	  OPEN: 'drawer--is-open'
	};
	var Selector = {
	  CONTENT: '.drawer__panel',
	  DATA_TOGGLE: '[data-toggle="drawer"]',
	  DATA_DISMISS: '[data-dismiss="drawer"]'
	};
	
	var Drawer = exports.Drawer = function () {
	
	  /**
	   * @param  {Dom}    drawer     drawer DOM object
	   * @param  {Object} config     config for drawer
	   */
	  function Drawer(drawer, config) {
	    _classCallCheck(this, Drawer);
	
	    this._config = this.getConfig(config);
	    this._element = drawer;
	    this._content = this._element.querySelector(_get__('Selector').CONTENT);
	    if (this._config.trigger) {
	      this._trigger = document.querySelector(this._config.trigger);
	    }
	    this._isOpen = false;
	    this._hasCustomWidth = false;
	
	    // Bind the context with the events
	    this.open = this.open.bind(this);
	    this.close = this.close.bind(this);
	    this.negative = this.negative.bind(this);
	    this.positive = this.positive.bind(this);
	    this.checkEscapeKey = this.checkEscapeKey.bind(this);
	    this.backdropClick = this.backdropClick.bind(this);
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    // Initialize drawer
	    this.init();
	  }
	
	  _createClass(Drawer, [{
	    key: 'getConfig',
	    value: function getConfig(config) {
	      config = _extends({}, _get__('Default'), config);
	
	      return config;
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      if (this._config.customWidth) {
	        this.handleCustomWidth();
	      }
	      this.bindButtons();
	      if (this._trigger) {
	        _get__('addEvent')(this._trigger, 'click', this._config.tabbed ? this.toggle.bind(this) : this.open.bind(this));
	      }
	      this.handleAccessibility();
	    }
	  }, {
	    key: 'bindButtons',
	    value: function bindButtons() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this._element.querySelectorAll(this._config.negativeTrigger)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var closeButton = _step.value;
	
	          _get__('addEvent')(closeButton, 'click', this.negative);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this._element.querySelectorAll(this._config.positiveTrigger)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var positiveButton = _step2.value;
	
	          _get__('addEvent')(positiveButton, 'click', this.positive);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'handleAccessibility',
	    value: function handleAccessibility() {
	      var _this = this;
	
	      if (this._isOpen === true) {
	        this._element.setAttribute('aria-hidden', 'false');
	        this._content.setAttribute('aria-expanded', 'true');
	        this._content.setAttribute('tabindex', _get__('TABINDEX_VALUE'));
	        /**
	         *----
	          [Come back to: Steven] Figure out why right aligned doesnt transition without
	          setTimeout
	         *----
	         */
	        setTimeout(function () {
	          _this._content.focus();
	        }, _get__('TRANSITION_DURATION'));
	      } else {
	        this._element.setAttribute('aria-hidden', 'true');
	        this._content.setAttribute('aria-expanded', 'false');
	        this._content.removeAttribute('tabindex');
	        if (this._trigger) {
	          this._trigger.focus();
	        }
	        setTimeout(function () {
	          if (_this._config.tabbed && _this._trigger) {
	            _this._trigger.querySelector('.btn').blur();
	          }
	        }, _get__('TRANSITION_DURATION'));
	      }
	    }
	
	    /**
	     *----
	      [Come back to: Steven] Look at a way to get this to work responively, px/rem
	      values not likely to be an option
	     *----
	     */
	
	  }, {
	    key: 'handleCustomWidth',
	    value: function handleCustomWidth() {
	      this._element.style.width = this._config.customWidth;
	      this._element.style[this._config.direction] = '-' + this._config.customWidth;
	      this._hasCustomWidth = true;
	    }
	  }, {
	    key: 'setDrawerDirection',
	    value: function setDrawerDirection() {
	      this._config.direction = this._element.className.split(' ').some(function (cla) {
	        return (/.*--left/.test(cla)
	        );
	      }) ? 'left' : 'right';
	    }
	  }, {
	    key: 'backdropClick',
	    value: function backdropClick(event) {
	      if (event.target === this._element) {
	        this.close();
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (!this._element.classList.contains(_get__('ClassName').OPEN)) {
	        this._element.classList.add(_get__('ClassName').OPEN);
	      }
	      if (this._hasCustomWidth) {
	        this._element.style[this._config.direction] = 0;
	      }
	      _get__('addEvent')(document, 'keydown', this.checkEscapeKey);
	      _get__('triggerEvent')(this._element, 'show.commonui.drawer');
	      this._isOpen = true;
	      _get__('addEvent')(this._element, 'click', this.backdropClick);
	      this.handleAccessibility();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.hasCustomWidth) {
	        this._element.style[this._elementDirection] = '-' + this.customWidth;
	      }
	      this._element.classList.remove(_get__('ClassName').OPEN);
	      document.onkeydown = null;
	      _get__('triggerEvent')(this._element, 'hide.commonui.drawer');
	      this._isOpen = false;
	      _get__('removeEvent')(this._element, 'click', this.backdropClick);
	      this.handleAccessibility();
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      return this._isOpen ? this.close() : this.open();
	    }
	  }, {
	    key: 'positive',
	    value: function positive() {
	      _get__('triggerEvent')(this._element, 'positive.commonui.drawer');
	      this.close();
	    }
	  }, {
	    key: 'negative',
	    value: function negative() {
	      _get__('triggerEvent')(this._element, 'negative.commonui.drawer');
	      this.close();
	    }
	  }, {
	    key: 'checkEscapeKey',
	    value: function checkEscapeKey(evt) {
	      if (evt && evt.keyCode === _get__('ESCAPE_KEYCODE')) {
	        this.negative();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	      if (this._trigger) {
	        _get__('removeEvent')(this._trigger, 'click', this.open);
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this._element) {
	        console.warn('CommonUI - Drawer - No drawer contents found');
	        return false;
	      }
	      if (this._config.customWidth && !this._config.customWidth.match(/\d*\.?\d+(?:px|rem|%)?/i) && typeof this._config.customWidth !== 'string') {
	        console.warn('CommonUI - Drawer - The value for customWidth must be a\n        string and an xx(px|rem|%) value (where xx is a number).');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Drawer;
	}();
	
	/**
	 * creates a new drawer instance
	 * @param  {Object} config
	 */
	
	
	function initDrawer(selector) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var drawer = null;
	  if (typeof selector === 'string') {
	    drawer = new (_get__('Drawer'))(document.querySelector(selector), config);
	  } else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object') {
	    drawer = new (_get__('Drawer'))(selector, config);
	  }
	  return drawer;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Selector':
	      return Selector;
	
	    case 'Default':
	      return Default;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'TABINDEX_VALUE':
	      return TABINDEX_VALUE;
	
	    case 'TRANSITION_DURATION':
	      return TRANSITION_DURATION;
	
	    case 'ClassName':
	      return ClassName;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'ESCAPE_KEYCODE':
	      return ESCAPE_KEYCODE;
	
	    case 'Drawer':
	      return Drawer;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDrawer === 'undefined' ? 'undefined' : _typeof(initDrawer);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDrawer, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDrawer)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Filter = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initFilter;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Filter = exports.Filter = function () {
	
	  /**
	   * The filter file assigns open and close
	   * functionality to provided elements. It also provides
	   * toggle functionality around the "Apply" button
	   * which closes the filter but can also be used to
	   * call an action within the application developers code.
	   *
	   * @param  {string} filter               DOM element
	   * @param  {string} openClickArea        Js hook of open area
	   * @param  {string} remoteOpenClickArea  JS hook from content toggles filter
	   * @param  {string} closeClickArea       JS hook of close area
	   * @param  {string} applyFilterClickArea JS hook of action button
	   * @return undefined
	   *
	   * @author  Barry Hassan
	   */
	  function Filter(filter, openClickArea, remoteOpenClickArea, closeClickArea, applyFilterClickArea) {
	    _classCallCheck(this, Filter);
	
	    this.filter = filter;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.closeClickArea = filter.querySelector(closeClickArea);
	    this.openClickArea = filter.querySelector(openClickArea);
	    this.remoteOpenClickArea = filter.querySelector(remoteOpenClickArea);
	    this.applyFilterClickArea = filter.querySelector(applyFilterClickArea);
	    this.sidebarForm = filter.querySelector('form');
	
	    this.isOpen = true;
	
	    this.init();
	  }
	
	  /**
	   * Assigns events to the close button
	   * and the filter action button (Apply)
	   * @return undefined
	   */
	
	
	  _createClass(Filter, [{
	    key: 'init',
	    value: function init() {
	      if (this.closeClickArea) {
	        _get__('addEvent')(this.closeClickArea, 'click', this.close.bind(this));
	      }
	      if (this.applyFilterClickArea) {
	        _get__('addEvent')(this.applyFilterClickArea, 'click', this.apply.bind(this));
	      }
	      if (this.sidebarForm) {
	        _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	        _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	      }
	    }
	
	    /**
	     * Removes the disabled attribute
	     * from the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'enableAction',
	    value: function enableAction() {
	      if (this.applyFilterClickArea) {
	        this.applyFilterClickArea.removeAttribute('disabled');
	        if (this.sidebarForm) {
	          _get__('removeEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('removeEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Adds the disabled attribute
	     * to the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'disableAction',
	    value: function disableAction() {
	      if (this.applyFilterClickArea) {
	        this.applyFilterClickArea.setAttribute('disabled', true);
	        if (this.sidebarForm) {
	          _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Opens the filter, applies classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'open',
	    value: function open(event) {
	      event.stopImmediatePropagation();
	      if (!this.isOpen) {
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('removeClasses')(this.filter, ['is-compact']);
	          _get__('removeEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('removeEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	        this.isOpen = true;
	      }
	    }
	
	    /**
	     * Closes the filter, switches the functionality
	     * of the filter to now open
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'close',
	    value: function close(event) {
	      event.stopImmediatePropagation();
	      if (this.isOpen) {
	        if (this.closeClickArea) {
	          _get__('addClasses')(this.filter, ['is-compact']);
	          _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        }
	        this.isOpen = false;
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('addEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('addEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Toggles content button if present
	     * to switch between icon classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'apply',
	    value: function apply(event) {
	      if (this.applyFilterClickArea) {
	        var remoteIcon = this.filter.querySelector('.js-filter-panel__state');
	        if (remoteIcon) {
	          _get__('removeClasses')(remoteIcon, ['icon-cme-filter']);
	          _get__('addClasses')(remoteIcon, ['fa', 'fa-check']);
	        }
	        this.close(event);
	        _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        _get__('triggerEvent')(this.filter, 'apply.commonui.filter');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.filter) {
	        console.warn('CommonUI - Filter - There\'s no filter found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Filter;
	}();
	
	/**
	 * Creates a new filter instance
	 * @param  {Object} config
	 */
	
	
	function initFilter() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-filter-panel' : _config$selector,
	      _config$openSelector = config.openSelector,
	      openSelector = _config$openSelector === undefined ? '.js-filter-panel__open' : _config$openSelector,
	      _config$remoteOpenCli = config.remoteOpenClickArea,
	      remoteOpenClickArea = _config$remoteOpenCli === undefined ? '.js-filter-panel__remote-open' : _config$remoteOpenCli,
	      _config$closeSelector = config.closeSelector,
	      closeSelector = _config$closeSelector === undefined ? '.js-filter-panel__close' : _config$closeSelector,
	      _config$applyFilterSe = config.applyFilterSelector,
	      applyFilterSelector = _config$applyFilterSe === undefined ? '.js-filter-panel__action' : _config$applyFilterSe;
	
	  var filters = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var filter = _step.value;
	
	        filters = new (_get__('Filter'))(filter, openSelector, remoteOpenClickArea, closeSelector, applyFilterSelector);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return filters;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'Filter':
	      return Filter;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initFilter === 'undefined' ? 'undefined' : _typeof(initFilter);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initFilter, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initFilter)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.DismissableSidebarPanel = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initDismissableSidebarPanel;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DismissableSidebarPanel = exports.DismissableSidebarPanel = function () {
	  function DismissableSidebarPanel(config) {
	    _classCallCheck(this, DismissableSidebarPanel);
	
	    this.dismissableSidebarPanels = config.dismissableSidebarPanel;
	    this.sidePanel = config.dismissableSidebarPanel.firstElementChild.firstElementChild;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.closeClickArea = config.dismissableSidebarPanel.querySelector(config.closeSelector);
	    this.openClickArea = document.querySelector(config.openSelector);
	    this.remoteOpenClickArea = config.dismissableSidebarPanel.querySelector(config.remoteOpenClickArea);
	    this.applyDismissableSidebarPanelClickArea = config.dismissableSidebarPanel.querySelector(config.applyDismissableSidebarPanelSelector);
	    this.sidebarForm = config.dismissableSidebarPanel.querySelector('form');
	
	    this.sidePanel.style.width = config.width;
	
	    this.isOpen = false;
	
	    this.init();
	  }
	
	  /**
	   * Assigns events to the close button
	   * and the dismissable sidebar panel action button (Apply)
	   * @return undefined
	   */
	
	
	  _createClass(DismissableSidebarPanel, [{
	    key: 'init',
	    value: function init() {
	      if (this.closeClickArea) {
	        _get__('addEvent')(this.closeClickArea, 'click', this.close.bind(this));
	      }
	      if (this.applyDismissableSidebarPanelClickArea) {
	        _get__('addEvent')(this.applyDismissableClickArea, 'click', this.apply.bind(this));
	      }
	      if (this.sidebarForm) {
	        _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	        _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	      }
	      if (this.openClickArea || this.remoteOpenClickArea) {
	        _get__('addEvent')(this.openClickArea, 'click', this.open.bind(this));
	        _get__('addEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	      }
	    }
	
	    /**
	     * Removes the disabled attribute
	     * from the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'enableAction',
	    value: function enableAction() {
	      if (this.applyDismissableClickArea) {
	        this.applyDismissableClickArea.removeAttribute('disabled');
	        if (this.sidebarForm) {
	          _get__('removeEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('removeEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Adds the disabled attribute
	     * to the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'disableAction',
	    value: function disableAction() {
	      if (this.applyDismissableClickArea) {
	        this.applyDismissableClickArea.setAttribute('disabled', true);
	        if (this.sidebarForm) {
	          _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Opens the dismissable sidebar panel, applies classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'open',
	    value: function open(event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	      if (!this.isOpen) {
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('removeClasses')(this.dismissableSidebarPanels, ['is-compact']);
	          _get__('removeEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('removeEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	        this.isOpen = true;
	      }
	    }
	
	    /**
	     * Closes the dismissable sidebar panel, switches the functionality
	     * of the dismissable sidebar panel to now open
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'close',
	    value: function close(event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	      if (this.isOpen) {
	        if (this.closeClickArea) {
	          _get__('addClasses')(this.dismissableSidebarPanels, ['is-compact']);
	          _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        }
	        this.isOpen = false;
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('addEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('addEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Toggles content button if present
	     * to switch between icon classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'apply',
	    value: function apply(event) {
	      if (this.applyDismissableClickArea) {
	        var remoteIcon = this.dismissableSidebarPanels.querySelector('.js-dismissable-sidebar-panel__state');
	        if (remoteIcon) {
	          _get__('removeClasses')(remoteIcon, ['icon-cme-filter']);
	          _get__('addClasses')(remoteIcon, ['fa', 'fa-check']);
	        }
	        this.close(event);
	        _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        _get__('triggerEvent')(this.dismissableSidebarPanels, 'apply.commonui.dismissable-side-panel');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.dismissableSidebarPanels) {
	        console.warn('CommonUI - Dismissable Sidebar Panel - There\'s no dismissable sidebar panel found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return DismissableSidebarPanel;
	}();
	
	/**
	 * Creates a new dismissable sidebar panel instance
	 * @param  {Object} config
	 */
	
	
	function initDismissableSidebarPanel() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-dismissable-sidebar-panel' : _config$selector,
	      _config$openSelector = config.openSelector,
	      openSelector = _config$openSelector === undefined ? '.js-dismissable-sidebar-panel__open' : _config$openSelector,
	      _config$remoteOpenCli = config.remoteOpenClickArea,
	      remoteOpenClickArea = _config$remoteOpenCli === undefined ? '.js-dismissable-sidebar-panel__remote-open' : _config$remoteOpenCli,
	      _config$closeSelector = config.closeSelector,
	      closeSelector = _config$closeSelector === undefined ? '.js-dismissable-sidebar-panel__close' : _config$closeSelector,
	      _config$applyDismissa = config.applyDismissableSidebarPanelSelector,
	      applyDismissableSidebarPanelSelector = _config$applyDismissa === undefined ? '.js-dismissable-sidebar-panel__action' : _config$applyDismissa,
	      _config$width = config.width,
	      width = _config$width === undefined ? '25%' : _config$width;
	
	  var dismissableSidebarPanels = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var dismissableSidebarPanel = _step.value;
	
	        dismissableSidebarPanels = new (_get__('DismissableSidebarPanel'))({
	          dismissableSidebarPanel: dismissableSidebarPanel,
	          openSelector: openSelector,
	          remoteOpenClickArea: remoteOpenClickArea,
	          closeSelector: closeSelector,
	          applyDismissableSidebarPanelSelector: applyDismissableSidebarPanelSelector,
	          width: width
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return dismissableSidebarPanels;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'DismissableSidebarPanel':
	      return DismissableSidebarPanel;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDismissableSidebarPanel === 'undefined' ? 'undefined' : _typeof(initDismissableSidebarPanel);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDismissableSidebarPanel, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDismissableSidebarPanel)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.CountdownTimer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initCountdownTimer;
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-console, key-spacing, no-multi-spaces, no-magic-numbers */
	
	var SEC = 1000;
	var MIN = _get__('SEC') * 60;
	var HOUR = _get__('MIN') * 60;
	var DAY = _get__('HOUR') * 24;
	
	var CountdownTimer = exports.CountdownTimer = function () {
	
	  /**
	   * The Countdown Timer component
	   *
	   * @param {Element} timer DOM element that the timer should be injected into
	   * @return void
	   */
	  function CountdownTimer(elem, _ref) {
	    var startDate = _ref.startDate,
	        endDate = _ref.endDate,
	        _ref$extended = _ref.extended,
	        extended = _ref$extended === undefined ? false : _ref$extended,
	        _ref$compact = _ref.compact,
	        compact = _ref$compact === undefined ? false : _ref$compact,
	        _ref$dark = _ref.dark,
	        dark = _ref$dark === undefined ? false : _ref$dark;
	
	    _classCallCheck(this, CountdownTimer);
	
	    console.warn('Timer.constructor:', elem, startDate, endDate);
	    this.container = elem;
	    this.startDate = startDate;
	    this.endDate = endDate;
	    this.extended = extended;
	    this.compact = compact;
	    this.dark = dark;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.stages = [{ color: '#fa0033', percentRemaining: 10 }, { color: '#f68b1f', percentRemaining: 25 }, { color: '#bfd730', percentRemaining: 50 }, { color: '#8ebe3f', percentRemaining: 100 }];
	
	    this.init();
	  }
	
	  _createClass(CountdownTimer, [{
	    key: 'init',
	    value: function init() {
	      this.createDomElements(this.container);
	      this.startTimer();
	    }
	  }, {
	    key: 'createDomElements',
	    value: function createDomElements(container) {
	      var timerEl = document.createElement('div');
	      var timerPartsEl = document.createElement('div');
	      var timerDurationEl = document.createElement('div');
	      var timerRemainingEl = document.createElement('div');
	      this.daysEl = this.createTimePartElement('days');
	      this.hoursEl = this.createTimePartElement('hours');
	      this.minsEl = this.createTimePartElement('mins');
	      this.secsEl = this.createTimePartElement('secs');
	
	      this.daysRemainingEl = this.daysEl.querySelector('.js-days-remaining');
	      this.hoursRemainingEl = this.hoursEl.querySelector('.js-hours-remaining');
	      this.minsRemainingEl = this.minsEl.querySelector('.js-mins-remaining');
	      this.secsRemainingEl = this.secsEl.querySelector('.js-secs-remaining');
	      this.remainingEl = timerRemainingEl;
	
	      var timerElClasses = ['timer'];
	      if (this.extended === true) {
	        timerElClasses.push('timer--extended');
	      }
	      if (this.compact === true) {
	        timerElClasses.push('timer--compact');
	      }
	      if (this.dark === true) {
	        timerElClasses.push('timer--dark');
	      }
	
	      _get__('addClasses')(timerEl, timerElClasses);
	      _get__('addClasses')(timerPartsEl, ['timer__parts']);
	      _get__('addClasses')(timerDurationEl, ['timer__duration']);
	      _get__('addClasses')(timerRemainingEl, ['timer__duration-remaining', 'js-remaining']);
	
	      timerPartsEl.appendChild(this.daysEl);
	      timerPartsEl.appendChild(this.hoursEl);
	      timerPartsEl.appendChild(this.minsEl);
	      timerPartsEl.appendChild(this.secsEl);
	      timerDurationEl.appendChild(timerRemainingEl);
	      timerEl.appendChild(timerPartsEl);
	      timerEl.appendChild(timerDurationEl);
	      container.appendChild(timerEl);
	    }
	  }, {
	    key: 'createTimePartElement',
	    value: function createTimePartElement(timePart) {
	      var timePartEl = document.createElement('span');
	      var timePartValueEl = document.createElement('span');
	      var timePartUnitEl = document.createElement('span');
	      timePartEl.classList.add('timer__part');
	      timePartValueEl.classList.add('timer__part-value');
	      timePartValueEl.classList.add('js-' + timePart + '-remaining');
	      timePartUnitEl.classList.add('timer__part-unit');
	
	      timePartValueEl.innerText = '00';
	      timePartUnitEl.innerText = this.compact ? timePart.charAt(0) : timePart;
	
	      timePartEl.appendChild(timePartValueEl);
	      timePartEl.appendChild(timePartUnitEl);
	
	      return timePartEl;
	    }
	  }, {
	    key: 'renderTimeUnitRemaining',
	    value: function renderTimeUnitRemaining(val, elem) {
	      var valText = val < 10 ? '0' + val : '' + val;
	      if (elem.innerText !== valText) {
	        elem.innerText = valText;
	      }
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this = this;
	
	      this.countdownTimer = setInterval(function () {
	        _this.updateTimer();
	      }, 100);
	    }
	  }, {
	    key: 'stopTimer',
	    value: function stopTimer() {
	      clearInterval(this.countdownTimer);
	    }
	
	    /**
	    * Checks that the timer is still required.
	    * If no longer required, then the timer is stopped.
	    */
	
	  }, {
	    key: 'checkTimer',
	    value: function checkTimer() {
	      if (Date.now() > this.endDate) {
	        this.stopTimer();
	      }
	    }
	  }, {
	    key: 'updateTimer',
	    value: function updateTimer() {
	      this.checkTimer();
	
	      var _getTimeRemaining = this.getTimeRemaining(),
	          percentRemaining = _getTimeRemaining.percentRemaining,
	          daysRemaining = _getTimeRemaining.daysRemaining,
	          hoursRemaining = _getTimeRemaining.hoursRemaining,
	          minsRemaining = _getTimeRemaining.minsRemaining,
	          secsRemaining = _getTimeRemaining.secsRemaining;
	
	      this.updateProgressBar(percentRemaining);
	
	      if (daysRemaining === 0) {
	        this.muteValue(this.daysEl);
	        if (hoursRemaining === 0) {
	          this.muteValue(this.hoursEl);
	          if (minsRemaining === 0) {
	            this.muteValue(this.minsEl);
	            if (secsRemaining === 0) {
	              this.muteValue(this.secsEl);
	            }
	          }
	        }
	      }
	
	      this.renderTimeUnitRemaining(daysRemaining, this.daysRemainingEl);
	      this.renderTimeUnitRemaining(hoursRemaining, this.hoursRemainingEl);
	      this.renderTimeUnitRemaining(minsRemaining, this.minsRemainingEl);
	      this.renderTimeUnitRemaining(secsRemaining, this.secsRemainingEl);
	
	      this.remainingEl.style.width = percentRemaining + '%';
	    }
	  }, {
	    key: 'getTimeRemaining',
	    value: function getTimeRemaining() {
	      var NOW = Date.now();
	      var totalDuration = this.endDate - this.startDate;
	      // const totalElapsed	= NOW - this.startDate;
	      var totalRemaining = this.endDate - NOW;
	      if (totalRemaining < 0) {
	        totalRemaining = 0;
	      }
	
	      return {
	        totalRemaining: totalRemaining,
	        percentRemaining: totalRemaining / totalDuration * 100,
	        daysRemaining: Math.floor(totalRemaining / _get__('DAY')),
	        hoursRemaining: Math.floor(totalRemaining / _get__('HOUR') % 24),
	        minsRemaining: Math.floor(totalRemaining / _get__('MIN') % 60),
	        secsRemaining: Math.floor(totalRemaining / _get__('SEC') % 60)
	      };
	    }
	  }, {
	    key: 'muteValue',
	    value: function muteValue(elem) {
	      var muteClass = this.extended ? 'text--disabled' : 'display--none';
	      _get__('addClasses')(elem, [muteClass]);
	    }
	  }, {
	    key: 'updateProgressBar',
	    value: function updateProgressBar(percentRemaining) {
	      var color = this.stages[0].color;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.stages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var stage = _step.value;
	
	          if (percentRemaining < stage.percentRemaining) {
	            color = stage.color;
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (this.remainingEl.style.backgroundColor !== color) {
	        this.remainingEl.style.backgroundColor = color;
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.container) {
	        console.warn('CommonUI - Countdown Timer - There\'s no timer found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return CountdownTimer;
	}();
	
	/**
	 * Creates a new countdown timer instance
	 * @param  {Object} config
	 */
	
	
	function initCountdownTimer() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-timer' : _config$selector;
	
	  return new (_get__('CountdownTimer'))(document.querySelector(selector), config);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'SEC':
	      return SEC;
	
	    case 'MIN':
	      return MIN;
	
	    case 'HOUR':
	      return HOUR;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'DAY':
	      return DAY;
	
	    case 'CountdownTimer':
	      return CountdownTimer;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initCountdownTimer === 'undefined' ? 'undefined' : _typeof(initCountdownTimer);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initCountdownTimer, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initCountdownTimer)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.PriceTick = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initFilter;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PriceTick = exports.PriceTick = function () {
	  function PriceTick(tickComponent, upButtonComponent, downButtonComponent, componentInput) {
	    _classCallCheck(this, PriceTick);
	
	    this.priceTickComponent = tickComponent;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.upButton = tickComponent.querySelector(upButtonComponent);
	    this.downButton = tickComponent.querySelector(downButtonComponent);
	    this.componentInputElement = tickComponent.querySelector(componentInput);
	
	    this.init();
	  }
	
	  /**
	   * Assigns events to the close button
	   * and the filter action button (Apply)
	   * @return undefined
	   */
	
	
	  _createClass(PriceTick, [{
	    key: 'init',
	    value: function init() {
	      if (this.upButton) {
	        _get__('addEvent')(this.upButton, 'click', this.triggerUp.bind(this));
	      }
	      if (this.downButton) {
	        _get__('addEvent')(this.downButton, 'click', this.triggerDown.bind(this));
	      }
	    }
	  }, {
	    key: 'triggerUp',
	    value: function triggerUp() {
	      _get__('triggerEvent')(this.priceTickComponent, 'up.commonui.pricetick');
	    }
	  }, {
	    key: 'triggerDown',
	    value: function triggerDown() {
	      _get__('triggerEvent')(this.priceTickComponent, 'down.commonui.pricetick');
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get__('removeEvent')(this.upButton, 'click', this.triggerUp.bind(this));
	      _get__('removeEvent')(this.downButton, 'click', this.triggerDown.bind(this));
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.priceTickComponent) {
	        console.warn('CommonUI - Price Tick - There\'s no tick found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return PriceTick;
	}();
	
	/**
	 * Creates a new filter instance
	 * @param  {Object} config
	 */
	
	
	function initFilter() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-price-tick' : _config$selector,
	      _config$upButtonCompo = config.upButtonComponent,
	      upButtonComponent = _config$upButtonCompo === undefined ? '.js-price-tick__up' : _config$upButtonCompo,
	      _config$downButtonCom = config.downButtonComponent,
	      downButtonComponent = _config$downButtonCom === undefined ? '.js-price-tick__down' : _config$downButtonCom,
	      _config$componentInpu = config.componentInput,
	      componentInput = _config$componentInpu === undefined ? '.js-price-tick__value' : _config$componentInpu;
	
	  var priceTicks = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var tick = _step.value;
	
	        priceTicks = new (_get__('PriceTick'))(tick, upButtonComponent, downButtonComponent, componentInput);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return priceTicks;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'PriceTick':
	      return PriceTick;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initFilter === 'undefined' ? 'undefined' : _typeof(initFilter);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initFilter, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initFilter)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initToasts;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultToastsOptions = {
	  container: 'body',
	  cssClass: 'js-toasts',
	  maxToasts: 3,
	  position: 'top|right'
	};
	
	var defaultToastOptions = {
	  message: '',
	  type: 'info',
	  minDuration: 2000,
	  maxDuration: 7000,
	  outline: false
	};
	
	var defaultIcons = {
	  'info': 'fa fa-info',
	  'success': 'fa fa-check',
	  'warning': 'fa fa-exclamation',
	  'error': 'fa fa-remove'
	};
	
	var DURATION_PER_CHARACTER = 50;
	var DELAY = 100;
	
	var Toast = function () {
	  function Toast(container) {
	    var _this = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Toast);
	
	    this.toastsEl = container;
	
	    options = _extends({}, _get__('defaultToastOptions'), options);
	
	    this.render(options);
	    setTimeout(function () {
	      return _this.show();
	    }, 0);
	  }
	
	  _createClass(Toast, [{
	    key: 'render',
	    value: function render() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var icon = options.icon,
	          message = options.message,
	          type = options.type,
	          outline = options.outline;
	
	      var toastIconEl = document.createElement('span');
	      var toastMessageEl = document.createElement('span');
	      this.toastDismissBtn = document.createElement('button');
	      // Create the toast element
	      this.toastEl = document.createElement('li');
	
	      // Apply the relevant css classes to the toast element
	      var toastClasses = ['toast', 'toast--' + type];
	      if (outline) {
	        toastClasses.push('toast--outline');
	      }
	      _get__('addClasses')(this.toastEl, toastClasses);
	
	      // Determine the duration of the toast
	      this.duration = this.getDuration(message, options);
	
	      // Set up the toast icon element
	      toastIconEl.innerHTML = '<i class="' + (icon || _get__('defaultIcons')[type]) + '"></i>';
	      toastIconEl.classList.add('toast__icon');
	
	      // Set up the toast message element
	      toastMessageEl.innerHTML = message;
	      toastMessageEl.classList.add('toast__message');
	
	      // Set up the dismiss button
	      this.toastDismissBtn.innerHTML = '<i class="fa fa-remove"></i>';
	      this.toastDismissBtn.classList.add('toast__action');
	
	      // Bind the 'click' event handler for the dismiss button
	      _get__('addEvent')(this.toastDismissBtn, 'click', this.dismiss.bind(this));
	
	      // Apply the 'is-landing' css class to the toast to provide the animations
	      this.toastEl.classList.add('is-landing');
	
	      // Finally, inject the elements to the DOM
	      this.toastEl.appendChild(toastIconEl);
	      this.toastEl.appendChild(toastMessageEl);
	      this.toastEl.appendChild(this.toastDismissBtn);
	      this.toastsEl.appendChild(this.toastEl);
	    }
	
	    /**
	     * Calculates the duration that the message should be displayed for.
	     * Based on 50ms per character, with a default minimum duration of 2s and a default maximum of 7s.
	     * @param {String} message The message to be displayed in the toast.
	     * @param {Object} minDuration, maxDuration The minimum and maximum duration that the toast should be displayed for.
	     */
	
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var _ref = arguments[1];
	      var minDuration = _ref.minDuration,
	          maxDuration = _ref.maxDuration;
	
	      var duration = message.replace(' ', '').length * _get__('DURATION_PER_CHARACTER');
	      if (duration < minDuration) {
	        duration = minDuration;
	      } else if (duration > maxDuration) {
	        duration = maxDuration;
	      }
	      return duration;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return _this2.toastEl.classList.remove('is-landing');
	      }, _get__('DELAY'));
	      this.startTimer();
	      _get__('removeEvent')(this.toastEl, 'mouseleave', this.show);
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this3 = this;
	
	      this.timer = setTimeout(function () {
	        return _this3.dismiss();
	      }, this.duration);
	    }
	  }, {
	    key: 'stopTimer',
	    value: function stopTimer() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      var _this4 = this;
	
	      if (this.isDismissing) {
	        return;
	      }
	
	      this.isDismissing = true;
	
	      this.onDismissTransitionEnd = function () {
	        _get__('removeElement')(_this4.toastEl);
	        _get__('removeEvent')(_this4.toastDismissBtn, 'click', _this4.dismiss);
	        _get__('removeEvent')(_this4.toastEl, 'mouseeneter', _this4.cancelDismiss);
	        _get__('removeEvent')(_this4.toastEl, 'transitionend', _this4.onDismissTransitionEnd);
	      };
	
	      _get__('addEvent')(this.toastEl, 'mouseenter', this.cancelDismiss.bind(this));
	      _get__('addEvent')(this.toastEl, 'transitionend', this.onDismissTransitionEnd);
	
	      this.toastEl.classList.add('is-dismissing');
	    }
	  }, {
	    key: 'cancelDismiss',
	    value: function cancelDismiss() {
	      this.isDismissing = false;
	      this.stopTimer();
	      _get__('removeEvent')(this.toastEl, 'mouseenter', this.cancelDismiss);
	      _get__('removeEvent')(this.toastEl, 'transitionend', this.onDismissTransitionEnd);
	      this.toastEl.classList.remove('is-dismissing');
	      _get__('addEvent')(this.toastEl, 'mouseleave', this.show.bind(this));
	    }
	  }]);
	
	  return Toast;
	}();
	
	var Toasts = function () {
	  function Toasts() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Toasts);
	
	    this.init(options);
	    return this;
	  }
	
	  _createClass(Toasts, [{
	    key: 'init',
	    value: function init(options) {
	      this.toasts = [];
	      this.toastsEl = this.getContainer(options);
	      this.setPositioning(options);
	
	      // Set the maximum number of toasts allowed
	      this.maxToasts = options.maxToasts;
	    }
	  }, {
	    key: 'getContainer',
	    value: function getContainer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var container = options.container,
	          cssClass = options.cssClass,
	          position = options.position;
	
	      var toastsEl = document.querySelector('.' + cssClass);
	      if (!toastsEl) {
	        toastsEl = document.createElement('ul');
	        var toastClasses = ['toasts', '' + cssClass];
	        var positions = position.split('|');
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = positions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var pos = _step.value;
	
	            toastClasses.push('toasts--position-' + pos);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        _get__('addClasses')(toastsEl, toastClasses);
	        var toastsContainer = document.querySelector(container);
	        toastsContainer.insertBefore(toastsEl, toastsContainer.firstChild);
	      }
	
	      return toastsEl;
	    }
	
	    /**
	     * Checks the options for positioning instructions and applies them accordingly.
	     * @param {*} options The configuration options specified when initializing the Toasts.
	     */
	
	  }, {
	    key: 'setPositioning',
	    value: function setPositioning(options) {
	      var top = options.top,
	          right = options.right,
	          bottom = options.bottom,
	          left = options.left;
	
	      if (top || right || bottom || left) {
	        var styles = {};
	        // Apply either top OR bottom, not both
	        if (top) {
	          styles = _extends({}, styles, { top: top + 'px' });
	        } else if (bottom) {
	          styles = _extends({}, styles, { bottom: bottom + 'px' });
	        }
	        // Apply either right OR left, not both
	        if (right) {
	          styles = _extends({}, styles, { right: right + 'px' });
	        } else if (left) {
	          styles = _extends({}, styles, { left: left + 'px' });
	        }
	        _get__('setStyles')(this.toastsEl, styles);
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var toast = new (_get__('Toast'))(this.toastsEl, options);
	      this.clearOldToasts(options);
	      this.toasts.push(toast);
	    }
	  }, {
	    key: 'clearOldToasts',
	    value: function clearOldToasts() {
	      // Ensure the number of toasts does not exceed the maximum number of allowed toasts
	      if (this.toasts.length < this.maxToasts) {
	        return;
	      }
	
	      // If the number of toasts exceeds the maximum,
	      // remove the first/oldest one and check again
	      while (this.toasts.length >= this.maxToasts) {
	        var oldToast = this.toasts.shift();
	        oldToast.dismiss();
	      }
	    }
	  }]);
	
	  return Toasts;
	}();
	
	function initToasts() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  options = _extends({}, _get__('defaultToastsOptions'), options);
	  return new (_get__('Toasts'))(options);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'defaultToastOptions':
	      return defaultToastOptions;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'defaultIcons':
	      return defaultIcons;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'DURATION_PER_CHARACTER':
	      return DURATION_PER_CHARACTER;
	
	    case 'DELAY':
	      return DELAY;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeElement':
	      return _html.removeElement;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'Toast':
	      return Toast;
	
	    case 'defaultToastsOptions':
	      return defaultToastsOptions;
	
	    case 'Toasts':
	      return Toasts;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initToasts === 'undefined' ? 'undefined' : _typeof(initToasts);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initToasts, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initToasts)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initSplitPanel;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-console */
	
	var DEFAULT_SPLIT_PANEL_OPTIONS = {
	  container: '.js-split-panel',
	  handle: '.js-splitter',
	  launchPanel: '.split-panel__launch',
	  backToMainPanel: '.split-panel__back'
	};
	
	var PERCENTAGE = 100;
	var TIMEOUT_RESIZE_INTERVAL = 20;
	var MAGIC_BREAKPOINT = 480;
	
	var SplitPanel = function () {
	  function SplitPanel() {
	    var _this = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, SplitPanel);
	
	    options = _extends({}, _get__('DEFAULT_SPLIT_PANEL_OPTIONS'), options);
	
	    this.resizes = [];
	    this.currentElement = null;
	
	    this.splitPanel = document.querySelector(options.container);
	    this.launchPanelButtons = document.querySelectorAll(options.launchPanel);
	    this.backToMainPanelButtons = document.querySelectorAll(options.backToMainPanel);
	    this.openPanelTriggers = document.querySelectorAll(options.openPanel);
	    this.closePanelTriggers = document.querySelectorAll(options.closePanel);
	    this.vertical = options.vertical;
	    this.horizontal = options.horizontal;
	
	    var verticalDividers = document.querySelectorAll('.js-vertically-divided');
	    var horizontalDividers = document.querySelectorAll('.js-horizontally-divided');
	
	    var verticalArray = Array.from(verticalDividers);
	    var horizontalArray = Array.from(horizontalDividers);
	    this.resizes = verticalArray.concat(horizontalArray);
	
	    this.setUpSplitters(this.resizes);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = this.openPanelTriggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var openPanel = _step.value;
	
	        _get__('addEvent')(openPanel, 'click', function () {
	          return _this.openSplitPanel();
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = this.closePanelTriggers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var closePanel = _step2.value;
	
	        _get__('addEvent')(closePanel, 'click', function () {
	          return _this.closeSplitPanel();
	        });
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	
	  _createClass(SplitPanel, [{
	    key: 'setUpSplitters',
	    value: function setUpSplitters(resizes) {
	      var _this2 = this;
	
	      resizes.forEach(function (elem) {
	        var isVertical = _get__('hasClass')(elem, 'js-vertically-divided');
	        elem.vertical = isVertical;
	        var children = _get__('filterByTagName')(elem.children, 'div');
	
	        var firstItem = children[0];
	        var secondItem = children[1];
	        _get__('setStyles')(secondItem, {
	          position: 'absolute',
	          'overflow-x': 'hidden',
	          top: 0,
	          bottom: 0,
	          left: 0
	        });
	
	        _get__('setStyles')(firstItem, {
	          position: 'absolute',
	          'overflow-x': 'hidden',
	          top: 0,
	          bottom: 0,
	          left: 0
	        });
	
	        _get__('setStyles')(secondItem, { right: 0 });
	
	        _get__('setStyles')(elem, {
	          overflow: 'hidden',
	          position: elem.style.position === 'absolute' ? 'absolute' : 'relative'
	        });
	
	        if (isVertical) {
	          firstItem.style.bottom = '0';
	          secondItem.style.top = '0';
	        } else {
	          firstItem.style.right = '0';
	          secondItem.style.left = '0';
	        }
	
	        elem.firstItem = firstItem;
	        elem.secondItem = secondItem;
	        elem.percent = 50;
	
	        var divider = document.createElement('div');
	        var handle = document.createElement('div');
	        handle.className = 'split-panel__handle';
	
	        var indicator = document.createElement('i');
	        indicator.className = 'icon-cme-draggable-two';
	        handle.appendChild(indicator);
	        indicator = null;
	
	        divider.appendChild(handle);
	        divider.className = isVertical ? 'split-panel--vertical--divider js-vertical-divider' : 'split-panel--horizontal--divider js-horizontal-divider';
	        divider.style.cssText = isVertical ? 'top:0; bottom:0; position:absolute;' : 'left:0; right:0; position:absolute;';
	
	        divider.onmousedown = function (event) {
	          _get__('addClass')(elem.splitter, 'dragged');
	          _this2.currentElement = elem;
	          if (event) {
	            event.preventDefault();
	          }
	          return false;
	        };
	
	        elem.splitter = divider;
	        elem.appendChild(divider);
	        if (window.innerWidth <= _get__('MAGIC_BREAKPOINT')) {
	          _this2.setResponsiveLayout(elem);
	        } else {
	          _this2.update(elem);
	        }
	      });
	
	      if (this.splitPanel.classList.contains('is-closable')) {
	        this.splitPanel.children[1].classList.add('display--none');
	        this.splitPanel.children[2].classList.add('display--none');
	        if (this.vertical) {
	          this.splitPanel.children[0].classList.add('width--100');
	        }
	        if (this.horizontal) {
	          this.splitPanel.children[0].classList.add('height--100');
	        }
	      }
	
	      _get__('addEvent')(document, 'mousemove', this.onMouseMoveEvent.bind(this));
	      _get__('addEvent')(document, 'mouseup', this.onMouseUpEvent.bind(this));
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = this.launchPanelButtons[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var launchPanelButton = _step3.value;
	
	          _get__('addEvent')(launchPanelButton, 'click', function () {
	            return _this2.launchPanel();
	          });
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.backToMainPanelButtons[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var backToMainPanelButton = _step4.value;
	
	          _get__('addEvent')(backToMainPanelButton, 'click', function () {
	            return _this2.backToMainPanel();
	          });
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      this.windowResizeListener = this.onWindowResize.bind(this);
	      this.windowResize = new (_get__('Throttle'))(this.windowResizeListener, _get__('TIMEOUT_RESIZE_INTERVAL'));
	      _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	    }
	  }, {
	    key: 'openSplitPanel',
	    value: function openSplitPanel() {
	      this.splitPanel.children[1].classList.remove('display--none');
	      this.splitPanel.children[2].classList.remove('display--none');
	      if (this.vertical) {
	        this.splitPanel.children[0].classList.remove('width--100');
	      }
	      if (this.horizontal) {
	        this.splitPanel.children[0].classList.remove('height--100');
	      }
	      this.launchPanel();
	    }
	  }, {
	    key: 'closeSplitPanel',
	    value: function closeSplitPanel() {
	      this.splitPanel.children[1].classList.add('display--none');
	      this.splitPanel.children[2].classList.add('display--none');
	      if (this.vertical) {
	        this.splitPanel.children[0].classList.add('width--100');
	      }
	      if (this.horizontal) {
	        this.splitPanel.children[0].classList.add('height--100');
	      }
	      this.backToMainPanel();
	    }
	  }, {
	    key: 'onWindowResize',
	    value: function onWindowResize() {
	      for (var index in this.resizes) {
	        if (window.innerWidth <= _get__('MAGIC_BREAKPOINT')) {
	          this.setResponsiveLayout(this.resizes[index]);
	        } else {
	          this.update(this.resizes[index]);
	        }
	      }
	    }
	  }, {
	    key: 'setResponsiveLayout',
	    value: function setResponsiveLayout(element) {
	      if (element.classList) {
	        _get__('addClass')(element.splitter, 'hide');
	        if (element.classList.contains('split-panel--stacked')) {
	          _get__('setStyles')(element.firstItem, { position: 'relative', left: 0, width: '100%', bottom: '0' });
	          _get__('setStyles')(element.secondItem, { position: 'relative', left: 0, width: '100%', top: '0', transform: 0 });
	          _get__('setStyles')(element, { 'overflow': 'auto' });
	        } else {
	          _get__('setStyles')(element.firstItem, { position: 'absolute', left: 0, width: '100%', bottom: '0' });
	          _get__('setStyles')(element.secondItem, { position: 'absolute', left: 0, width: '100%', top: '0' });
	          _get__('setStyles')(element, { 'overflow': 'hidden' });
	        }
	        element.isInResponsiveState = true;
	      }
	    }
	  }, {
	    key: 'unsetResponsiveLayout',
	    value: function unsetResponsiveLayout(element) {
	      if (element) {
	        _get__('removeClass')(element.splitter, 'hide');
	        _get__('setStyles')(element, { 'overflow': 'hidden' });
	        _get__('setStyles')(element.firstItem, { position: 'absolute', left: 0, width: 'inherit' });
	        _get__('setStyles')(element.secondItem, { position: 'absolute', left: '50%', width: 'inherit' });
	        element.secondItem.style.removeProperty('transform');
	        element.isInResponsiveState = false;
	      }
	    }
	  }, {
	    key: 'onMouseUpEvent',
	    value: function onMouseUpEvent() {
	      if (this.currentElement) {
	        this.currentElement.splitter.className = this.currentElement.vertical ? 'split-panel--vertical--divider js-vertical-divider' : 'split-panel--horizontal--divider js-horizontal-divider';
	        this.currentElement = null;
	        _get__('triggerEvent')(this.splitPanel, 'resized.commonui.splitpanel');
	      }
	    }
	  }, {
	    key: 'onMouseMoveEvent',
	    value: function onMouseMoveEvent(event) {
	      if (this.currentElement) {
	        var isVerticalState = this.currentElement.vertical;
	
	        var splitterState = isVerticalState ? this.currentElement.splitter.offsetWidth : this.currentElement.splitter.offsetHeight;
	        var elementState = isVerticalState ? this.currentElement.clientWidth : this.currentElement.clientHeight;
	        var newPos = (isVerticalState ? event.clientX : event.clientY) - this.currentElement.getBoundingClientRect()[isVerticalState ? 'left' : 'top'] - splitterState / 2;
	        var newPercentage = newPos > elementState - splitterState ? elementState - splitterState : newPos;
	        this.currentElement.percent = (newPos < 0 ? 0 : newPercentage) / elementState * _get__('PERCENTAGE');
	        this.update(this.currentElement);
	
	        if (event) {
	          event.preventDefault();
	        }
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'update',
	    value: function update(element) {
	      if (!element.splitter) {
	        return;
	      }
	      var elementState = element.vertical ? element.clientWidth : element.clientHeight;
	      var newPos = element.percent / _get__('PERCENTAGE') * elementState;
	      var splitterWidth = element.vertical ? element.splitter.offsetWidth : element.splitter.offsetHeight;
	      var bPercentage = (newPos + splitterWidth) / elementState * _get__('PERCENTAGE') + '%';
	      var aPercentage = (elementState - newPos) / elementState * _get__('PERCENTAGE') + '%';
	      element.splitter.style[element.vertical ? 'left' : 'top'] = element.percent + '%';
	      if (element.isInResponsiveState) {
	        this.unsetResponsiveLayout(element);
	      }
	      if (element.vertical) {
	        _get__('setStyles')(element.secondItem, { left: bPercentage, right: 0, top: 0, bottom: 0 });
	        _get__('setStyles')(element.firstItem, { right: aPercentage, left: 0, top: 0, bottom: 0 });
	      } else {
	        _get__('setStyles')(element.secondItem, { top: bPercentage, bottom: 0, left: 0, right: 0 });
	        _get__('setStyles')(element.firstItem, { bottom: aPercentage, top: 0, left: 0, right: 0 });
	      }
	    }
	  }, {
	    key: 'launchPanel',
	    value: function launchPanel() {
	      this.splitPanel.children[1].style.transform = 'translateX(0)';
	    }
	  }, {
	    key: 'backToMainPanel',
	    value: function backToMainPanel() {
	      this.splitPanel.children[1].style.transform = 'translateX(100%)';
	    }
	  }]);
	
	  return SplitPanel;
	}();
	
	function initSplitPanel() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  options = _extends({}, _get__('DEFAULT_SPLIT_PANEL_OPTIONS'), options);
	  return new (_get__('SplitPanel'))(options);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'DEFAULT_SPLIT_PANEL_OPTIONS':
	      return DEFAULT_SPLIT_PANEL_OPTIONS;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'filterByTagName':
	      return _html.filterByTagName;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'addClass':
	      return _html.addClass;
	
	    case 'MAGIC_BREAKPOINT':
	      return MAGIC_BREAKPOINT;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'TIMEOUT_RESIZE_INTERVAL':
	      return TIMEOUT_RESIZE_INTERVAL;
	
	    case 'removeClass':
	      return _html.removeClass;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'PERCENTAGE':
	      return PERCENTAGE;
	
	    case 'SplitPanel':
	      return SplitPanel;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initSplitPanel === 'undefined' ? 'undefined' : _typeof(initSplitPanel);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initSplitPanel, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initSplitPanel)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = initDatepicker;
	
	var _flatpickr = __webpack_require__(54);
	
	var _flatpickr2 = _interopRequireDefault(_flatpickr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initDatepicker(selector) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return _get__('flatpickr')(selector, config);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'flatpickr':
	      return _flatpickr2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDatepicker === 'undefined' ? 'undefined' : _typeof(initDatepicker);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDatepicker, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDatepicker)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/* flatpickr v4.6.3, @license MIT */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global = global || self, global.flatpickr = factory());
	}(this, function () { 'use strict';
	
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation. All rights reserved.
	    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	    this file except in compliance with the License. You may obtain a copy of the
	    License at http://www.apache.org/licenses/LICENSE-2.0
	
	    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	    MERCHANTABLITY OR NON-INFRINGEMENT.
	
	    See the Apache Version 2.0 License for specific language governing permissions
	    and limitations under the License.
	    ***************************************************************************** */
	
	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };
	
	    var HOOKS = [
	        "onChange",
	        "onClose",
	        "onDayCreate",
	        "onDestroy",
	        "onKeyDown",
	        "onMonthChange",
	        "onOpen",
	        "onParseConfig",
	        "onReady",
	        "onValueUpdate",
	        "onYearChange",
	        "onPreCalendarPosition",
	    ];
	    var defaults = {
	        _disable: [],
	        _enable: [],
	        allowInput: false,
	        altFormat: "F j, Y",
	        altInput: false,
	        altInputClass: "form-control input",
	        animate: typeof window === "object" &&
	            window.navigator.userAgent.indexOf("MSIE") === -1,
	        ariaDateFormat: "F j, Y",
	        clickOpens: true,
	        closeOnSelect: true,
	        conjunction: ", ",
	        dateFormat: "Y-m-d",
	        defaultHour: 12,
	        defaultMinute: 0,
	        defaultSeconds: 0,
	        disable: [],
	        disableMobile: false,
	        enable: [],
	        enableSeconds: false,
	        enableTime: false,
	        errorHandler: function (err) {
	            return typeof console !== "undefined" && console.warn(err);
	        },
	        getWeek: function (givenDate) {
	            var date = new Date(givenDate.getTime());
	            date.setHours(0, 0, 0, 0);
	            // Thursday in current week decides the year.
	            date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
	            // January 4 is always in week 1.
	            var week1 = new Date(date.getFullYear(), 0, 4);
	            // Adjust to Thursday in week 1 and count number of weeks from date to week1.
	            return (1 +
	                Math.round(((date.getTime() - week1.getTime()) / 86400000 -
	                    3 +
	                    ((week1.getDay() + 6) % 7)) /
	                    7));
	        },
	        hourIncrement: 1,
	        ignoredFocusElements: [],
	        inline: false,
	        locale: "default",
	        minuteIncrement: 5,
	        mode: "single",
	        monthSelectorType: "dropdown",
	        nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
	        noCalendar: false,
	        now: new Date(),
	        onChange: [],
	        onClose: [],
	        onDayCreate: [],
	        onDestroy: [],
	        onKeyDown: [],
	        onMonthChange: [],
	        onOpen: [],
	        onParseConfig: [],
	        onReady: [],
	        onValueUpdate: [],
	        onYearChange: [],
	        onPreCalendarPosition: [],
	        plugins: [],
	        position: "auto",
	        positionElement: undefined,
	        prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
	        shorthandCurrentMonth: false,
	        showMonths: 1,
	        static: false,
	        time_24hr: false,
	        weekNumbers: false,
	        wrap: false
	    };
	
	    var english = {
	        weekdays: {
	            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	            longhand: [
	                "Sunday",
	                "Monday",
	                "Tuesday",
	                "Wednesday",
	                "Thursday",
	                "Friday",
	                "Saturday",
	            ]
	        },
	        months: {
	            shorthand: [
	                "Jan",
	                "Feb",
	                "Mar",
	                "Apr",
	                "May",
	                "Jun",
	                "Jul",
	                "Aug",
	                "Sep",
	                "Oct",
	                "Nov",
	                "Dec",
	            ],
	            longhand: [
	                "January",
	                "February",
	                "March",
	                "April",
	                "May",
	                "June",
	                "July",
	                "August",
	                "September",
	                "October",
	                "November",
	                "December",
	            ]
	        },
	        daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	        firstDayOfWeek: 0,
	        ordinal: function (nth) {
	            var s = nth % 100;
	            if (s > 3 && s < 21)
	                return "th";
	            switch (s % 10) {
	                case 1:
	                    return "st";
	                case 2:
	                    return "nd";
	                case 3:
	                    return "rd";
	                default:
	                    return "th";
	            }
	        },
	        rangeSeparator: " to ",
	        weekAbbreviation: "Wk",
	        scrollTitle: "Scroll to increment",
	        toggleTitle: "Click to toggle",
	        amPM: ["AM", "PM"],
	        yearAriaLabel: "Year",
	        hourAriaLabel: "Hour",
	        minuteAriaLabel: "Minute",
	        time_24hr: false
	    };
	
	    var pad = function (number) { return ("0" + number).slice(-2); };
	    var int = function (bool) { return (bool === true ? 1 : 0); };
	    /* istanbul ignore next */
	    function debounce(func, wait, immediate) {
	        if (immediate === void 0) { immediate = false; }
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            timeout !== null && clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                timeout = null;
	                if (!immediate)
	                    func.apply(context, args);
	            }, wait);
	            if (immediate && !timeout)
	                func.apply(context, args);
	        };
	    }
	    var arrayify = function (obj) {
	        return obj instanceof Array ? obj : [obj];
	    };
	
	    function toggleClass(elem, className, bool) {
	        if (bool === true)
	            return elem.classList.add(className);
	        elem.classList.remove(className);
	    }
	    function createElement(tag, className, content) {
	        var e = window.document.createElement(tag);
	        className = className || "";
	        content = content || "";
	        e.className = className;
	        if (content !== undefined)
	            e.textContent = content;
	        return e;
	    }
	    function clearNode(node) {
	        while (node.firstChild)
	            node.removeChild(node.firstChild);
	    }
	    function findParent(node, condition) {
	        if (condition(node))
	            return node;
	        else if (node.parentNode)
	            return findParent(node.parentNode, condition);
	        return undefined; // nothing found
	    }
	    function createNumberInput(inputClassName, opts) {
	        var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
	        if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
	            numInput.type = "number";
	        }
	        else {
	            numInput.type = "text";
	            numInput.pattern = "\\d*";
	        }
	        if (opts !== undefined)
	            for (var key in opts)
	                numInput.setAttribute(key, opts[key]);
	        wrapper.appendChild(numInput);
	        wrapper.appendChild(arrowUp);
	        wrapper.appendChild(arrowDown);
	        return wrapper;
	    }
	    function getEventTarget(event) {
	        if (typeof event.composedPath === "function") {
	            var path = event.composedPath();
	            return path[0];
	        }
	        return event.target;
	    }
	
	    var doNothing = function () { return undefined; };
	    var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber]; };
	    var revFormat = {
	        D: doNothing,
	        F: function (dateObj, monthName, locale) {
	            dateObj.setMonth(locale.months.longhand.indexOf(monthName));
	        },
	        G: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        H: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        J: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        K: function (dateObj, amPM, locale) {
	            dateObj.setHours((dateObj.getHours() % 12) +
	                12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
	        },
	        M: function (dateObj, shortMonth, locale) {
	            dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
	        },
	        S: function (dateObj, seconds) {
	            dateObj.setSeconds(parseFloat(seconds));
	        },
	        U: function (_, unixSeconds) { return new Date(parseFloat(unixSeconds) * 1000); },
	        W: function (dateObj, weekNum, locale) {
	            var weekNumber = parseInt(weekNum);
	            var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
	            date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
	            return date;
	        },
	        Y: function (dateObj, year) {
	            dateObj.setFullYear(parseFloat(year));
	        },
	        Z: function (_, ISODate) { return new Date(ISODate); },
	        d: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        h: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        i: function (dateObj, minutes) {
	            dateObj.setMinutes(parseFloat(minutes));
	        },
	        j: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        l: doNothing,
	        m: function (dateObj, month) {
	            dateObj.setMonth(parseFloat(month) - 1);
	        },
	        n: function (dateObj, month) {
	            dateObj.setMonth(parseFloat(month) - 1);
	        },
	        s: function (dateObj, seconds) {
	            dateObj.setSeconds(parseFloat(seconds));
	        },
	        u: function (_, unixMillSeconds) {
	            return new Date(parseFloat(unixMillSeconds));
	        },
	        w: doNothing,
	        y: function (dateObj, year) {
	            dateObj.setFullYear(2000 + parseFloat(year));
	        }
	    };
	    var tokenRegex = {
	        D: "(\\w+)",
	        F: "(\\w+)",
	        G: "(\\d\\d|\\d)",
	        H: "(\\d\\d|\\d)",
	        J: "(\\d\\d|\\d)\\w+",
	        K: "",
	        M: "(\\w+)",
	        S: "(\\d\\d|\\d)",
	        U: "(.+)",
	        W: "(\\d\\d|\\d)",
	        Y: "(\\d{4})",
	        Z: "(.+)",
	        d: "(\\d\\d|\\d)",
	        h: "(\\d\\d|\\d)",
	        i: "(\\d\\d|\\d)",
	        j: "(\\d\\d|\\d)",
	        l: "(\\w+)",
	        m: "(\\d\\d|\\d)",
	        n: "(\\d\\d|\\d)",
	        s: "(\\d\\d|\\d)",
	        u: "(.+)",
	        w: "(\\d\\d|\\d)",
	        y: "(\\d{2})"
	    };
	    var formats = {
	        // get the date in UTC
	        Z: function (date) { return date.toISOString(); },
	        // weekday name, short, e.g. Thu
	        D: function (date, locale, options) {
	            return locale.weekdays.shorthand[formats.w(date, locale, options)];
	        },
	        // full month name e.g. January
	        F: function (date, locale, options) {
	            return monthToStr(formats.n(date, locale, options) - 1, false, locale);
	        },
	        // padded hour 1-12
	        G: function (date, locale, options) {
	            return pad(formats.h(date, locale, options));
	        },
	        // hours with leading zero e.g. 03
	        H: function (date) { return pad(date.getHours()); },
	        // day (1-30) with ordinal suffix e.g. 1st, 2nd
	        J: function (date, locale) {
	            return locale.ordinal !== undefined
	                ? date.getDate() + locale.ordinal(date.getDate())
	                : date.getDate();
	        },
	        // AM/PM
	        K: function (date, locale) { return locale.amPM[int(date.getHours() > 11)]; },
	        // shorthand month e.g. Jan, Sep, Oct, etc
	        M: function (date, locale) {
	            return monthToStr(date.getMonth(), true, locale);
	        },
	        // seconds 00-59
	        S: function (date) { return pad(date.getSeconds()); },
	        // unix timestamp
	        U: function (date) { return date.getTime() / 1000; },
	        W: function (date, _, options) {
	            return options.getWeek(date);
	        },
	        // full year e.g. 2016
	        Y: function (date) { return date.getFullYear(); },
	        // day in month, padded (01-30)
	        d: function (date) { return pad(date.getDate()); },
	        // hour from 1-12 (am/pm)
	        h: function (date) { return (date.getHours() % 12 ? date.getHours() % 12 : 12); },
	        // minutes, padded with leading zero e.g. 09
	        i: function (date) { return pad(date.getMinutes()); },
	        // day in month (1-30)
	        j: function (date) { return date.getDate(); },
	        // weekday name, full, e.g. Thursday
	        l: function (date, locale) {
	            return locale.weekdays.longhand[date.getDay()];
	        },
	        // padded month number (01-12)
	        m: function (date) { return pad(date.getMonth() + 1); },
	        // the month number (1-12)
	        n: function (date) { return date.getMonth() + 1; },
	        // seconds 0-59
	        s: function (date) { return date.getSeconds(); },
	        // Unix Milliseconds
	        u: function (date) { return date.getTime(); },
	        // number of the day of the week
	        w: function (date) { return date.getDay(); },
	        // last two digits of year e.g. 16 for 2016
	        y: function (date) { return String(date.getFullYear()).substring(2); }
	    };
	
	    var createDateFormatter = function (_a) {
	        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
	        return function (dateObj, frmt, overrideLocale) {
	            var locale = overrideLocale || l10n;
	            if (config.formatDate !== undefined) {
	                return config.formatDate(dateObj, frmt, locale);
	            }
	            return frmt
	                .split("")
	                .map(function (c, i, arr) {
	                return formats[c] && arr[i - 1] !== "\\"
	                    ? formats[c](dateObj, locale, config)
	                    : c !== "\\"
	                        ? c
	                        : "";
	            })
	                .join("");
	        };
	    };
	    var createDateParser = function (_a) {
	        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
	        return function (date, givenFormat, timeless, customLocale) {
	            if (date !== 0 && !date)
	                return undefined;
	            var locale = customLocale || l10n;
	            var parsedDate;
	            var dateOrig = date;
	            if (date instanceof Date)
	                parsedDate = new Date(date.getTime());
	            else if (typeof date !== "string" &&
	                date.toFixed !== undefined // timestamp
	            )
	                // create a copy
	                parsedDate = new Date(date);
	            else if (typeof date === "string") {
	                // date string
	                var format = givenFormat || (config || defaults).dateFormat;
	                var datestr = String(date).trim();
	                if (datestr === "today") {
	                    parsedDate = new Date();
	                    timeless = true;
	                }
	                else if (/Z$/.test(datestr) ||
	                    /GMT$/.test(datestr) // datestrings w/ timezone
	                )
	                    parsedDate = new Date(date);
	                else if (config && config.parseDate)
	                    parsedDate = config.parseDate(date, format);
	                else {
	                    parsedDate =
	                        !config || !config.noCalendar
	                            ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
	                            : new Date(new Date().setHours(0, 0, 0, 0));
	                    var matched = void 0, ops = [];
	                    for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
	                        var token_1 = format[i];
	                        var isBackSlash = token_1 === "\\";
	                        var escaped = format[i - 1] === "\\" || isBackSlash;
	                        if (tokenRegex[token_1] && !escaped) {
	                            regexStr += tokenRegex[token_1];
	                            var match = new RegExp(regexStr).exec(date);
	                            if (match && (matched = true)) {
	                                ops[token_1 !== "Y" ? "push" : "unshift"]({
	                                    fn: revFormat[token_1],
	                                    val: match[++matchIndex]
	                                });
	                            }
	                        }
	                        else if (!isBackSlash)
	                            regexStr += "."; // don't really care
	                        ops.forEach(function (_a) {
	                            var fn = _a.fn, val = _a.val;
	                            return (parsedDate = fn(parsedDate, val, locale) || parsedDate);
	                        });
	                    }
	                    parsedDate = matched ? parsedDate : undefined;
	                }
	            }
	            /* istanbul ignore next */
	            if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
	                config.errorHandler(new Error("Invalid date provided: " + dateOrig));
	                return undefined;
	            }
	            if (timeless === true)
	                parsedDate.setHours(0, 0, 0, 0);
	            return parsedDate;
	        };
	    };
	    /**
	     * Compute the difference in dates, measured in ms
	     */
	    function compareDates(date1, date2, timeless) {
	        if (timeless === void 0) { timeless = true; }
	        if (timeless !== false) {
	            return (new Date(date1.getTime()).setHours(0, 0, 0, 0) -
	                new Date(date2.getTime()).setHours(0, 0, 0, 0));
	        }
	        return date1.getTime() - date2.getTime();
	    }
	    var isBetween = function (ts, ts1, ts2) {
	        return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
	    };
	    var duration = {
	        DAY: 86400000
	    };
	
	    if (typeof Object.assign !== "function") {
	        Object.assign = function (target) {
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            if (!target) {
	                throw TypeError("Cannot convert undefined or null to object");
	            }
	            var _loop_1 = function (source) {
	                if (source) {
	                    Object.keys(source).forEach(function (key) { return (target[key] = source[key]); });
	                }
	            };
	            for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	                var source = args_1[_a];
	                _loop_1(source);
	            }
	            return target;
	        };
	    }
	
	    var DEBOUNCED_CHANGE_MS = 300;
	    function FlatpickrInstance(element, instanceConfig) {
	        var self = {
	            config: __assign({}, defaults, flatpickr.defaultConfig),
	            l10n: english
	        };
	        self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
	        self._handlers = [];
	        self.pluginElements = [];
	        self.loadedPlugins = [];
	        self._bind = bind;
	        self._setHoursFromDate = setHoursFromDate;
	        self._positionCalendar = positionCalendar;
	        self.changeMonth = changeMonth;
	        self.changeYear = changeYear;
	        self.clear = clear;
	        self.close = close;
	        self._createElement = createElement;
	        self.destroy = destroy;
	        self.isEnabled = isEnabled;
	        self.jumpToDate = jumpToDate;
	        self.open = open;
	        self.redraw = redraw;
	        self.set = set;
	        self.setDate = setDate;
	        self.toggle = toggle;
	        function setupHelperFunctions() {
	            self.utils = {
	                getDaysInMonth: function (month, yr) {
	                    if (month === void 0) { month = self.currentMonth; }
	                    if (yr === void 0) { yr = self.currentYear; }
	                    if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0))
	                        return 29;
	                    return self.l10n.daysInMonth[month];
	                }
	            };
	        }
	        function init() {
	            self.element = self.input = element;
	            self.isOpen = false;
	            parseConfig();
	            setupLocale();
	            setupInputs();
	            setupDates();
	            setupHelperFunctions();
	            if (!self.isMobile)
	                build();
	            bindEvents();
	            if (self.selectedDates.length || self.config.noCalendar) {
	                if (self.config.enableTime) {
	                    setHoursFromDate(self.config.noCalendar
	                        ? self.latestSelectedDateObj || self.config.minDate
	                        : undefined);
	                }
	                updateValue(false);
	            }
	            setCalendarWidth();
	            self.showTimeInput =
	                self.selectedDates.length > 0 || self.config.noCalendar;
	            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	            /* TODO: investigate this further
	        
	              Currently, there is weird positioning behavior in safari causing pages
	              to scroll up. https://github.com/chmln/flatpickr/issues/563
	        
	              However, most browsers are not Safari and positioning is expensive when used
	              in scale. https://github.com/chmln/flatpickr/issues/1096
	            */
	            if (!self.isMobile && isSafari) {
	                positionCalendar();
	            }
	            triggerEvent("onReady");
	        }
	        function bindToInstance(fn) {
	            return fn.bind(self);
	        }
	        function setCalendarWidth() {
	            var config = self.config;
	            if (config.weekNumbers === false && config.showMonths === 1)
	                return;
	            else if (config.noCalendar !== true) {
	                window.requestAnimationFrame(function () {
	                    if (self.calendarContainer !== undefined) {
	                        self.calendarContainer.style.visibility = "hidden";
	                        self.calendarContainer.style.display = "block";
	                    }
	                    if (self.daysContainer !== undefined) {
	                        var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
	                        self.daysContainer.style.width = daysWidth + "px";
	                        self.calendarContainer.style.width =
	                            daysWidth +
	                                (self.weekWrapper !== undefined
	                                    ? self.weekWrapper.offsetWidth
	                                    : 0) +
	                                "px";
	                        self.calendarContainer.style.removeProperty("visibility");
	                        self.calendarContainer.style.removeProperty("display");
	                    }
	                });
	            }
	        }
	        /**
	         * The handler for all events targeting the time inputs
	         */
	        function updateTime(e) {
	            if (self.selectedDates.length === 0) {
	                setDefaultTime();
	            }
	            if (e !== undefined && e.type !== "blur") {
	                timeWrapper(e);
	            }
	            var prevValue = self._input.value;
	            setHoursFromInputs();
	            updateValue();
	            if (self._input.value !== prevValue) {
	                self._debouncedChange();
	            }
	        }
	        function ampm2military(hour, amPM) {
	            return (hour % 12) + 12 * int(amPM === self.l10n.amPM[1]);
	        }
	        function military2ampm(hour) {
	            switch (hour % 24) {
	                case 0:
	                case 12:
	                    return 12;
	                default:
	                    return hour % 12;
	            }
	        }
	        /**
	         * Syncs the selected date object time with user's time input
	         */
	        function setHoursFromInputs() {
	            if (self.hourElement === undefined || self.minuteElement === undefined)
	                return;
	            var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined
	                ? (parseInt(self.secondElement.value, 10) || 0) % 60
	                : 0;
	            if (self.amPM !== undefined) {
	                hours = ampm2military(hours, self.amPM.textContent);
	            }
	            var limitMinHours = self.config.minTime !== undefined ||
	                (self.config.minDate &&
	                    self.minDateHasTime &&
	                    self.latestSelectedDateObj &&
	                    compareDates(self.latestSelectedDateObj, self.config.minDate, true) ===
	                        0);
	            var limitMaxHours = self.config.maxTime !== undefined ||
	                (self.config.maxDate &&
	                    self.maxDateHasTime &&
	                    self.latestSelectedDateObj &&
	                    compareDates(self.latestSelectedDateObj, self.config.maxDate, true) ===
	                        0);
	            if (limitMaxHours) {
	                var maxTime = self.config.maxTime !== undefined
	                    ? self.config.maxTime
	                    : self.config.maxDate;
	                hours = Math.min(hours, maxTime.getHours());
	                if (hours === maxTime.getHours())
	                    minutes = Math.min(minutes, maxTime.getMinutes());
	                if (minutes === maxTime.getMinutes())
	                    seconds = Math.min(seconds, maxTime.getSeconds());
	            }
	            if (limitMinHours) {
	                var minTime = self.config.minTime !== undefined
	                    ? self.config.minTime
	                    : self.config.minDate;
	                hours = Math.max(hours, minTime.getHours());
	                if (hours === minTime.getHours())
	                    minutes = Math.max(minutes, minTime.getMinutes());
	                if (minutes === minTime.getMinutes())
	                    seconds = Math.max(seconds, minTime.getSeconds());
	            }
	            setHours(hours, minutes, seconds);
	        }
	        /**
	         * Syncs time input values with a date
	         */
	        function setHoursFromDate(dateObj) {
	            var date = dateObj || self.latestSelectedDateObj;
	            if (date)
	                setHours(date.getHours(), date.getMinutes(), date.getSeconds());
	        }
	        function setDefaultHours() {
	            var hours = self.config.defaultHour;
	            var minutes = self.config.defaultMinute;
	            var seconds = self.config.defaultSeconds;
	            if (self.config.minDate !== undefined) {
	                var minHr = self.config.minDate.getHours();
	                var minMinutes = self.config.minDate.getMinutes();
	                hours = Math.max(hours, minHr);
	                if (hours === minHr)
	                    minutes = Math.max(minMinutes, minutes);
	                if (hours === minHr && minutes === minMinutes)
	                    seconds = self.config.minDate.getSeconds();
	            }
	            if (self.config.maxDate !== undefined) {
	                var maxHr = self.config.maxDate.getHours();
	                var maxMinutes = self.config.maxDate.getMinutes();
	                hours = Math.min(hours, maxHr);
	                if (hours === maxHr)
	                    minutes = Math.min(maxMinutes, minutes);
	                if (hours === maxHr && minutes === maxMinutes)
	                    seconds = self.config.maxDate.getSeconds();
	            }
	            setHours(hours, minutes, seconds);
	        }
	        /**
	         * Sets the hours, minutes, and optionally seconds
	         * of the latest selected date object and the
	         * corresponding time inputs
	         * @param {Number} hours the hour. whether its military
	         *                 or am-pm gets inferred from config
	         * @param {Number} minutes the minutes
	         * @param {Number} seconds the seconds (optional)
	         */
	        function setHours(hours, minutes, seconds) {
	            if (self.latestSelectedDateObj !== undefined) {
	                self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
	            }
	            if (!self.hourElement || !self.minuteElement || self.isMobile)
	                return;
	            self.hourElement.value = pad(!self.config.time_24hr
	                ? ((12 + hours) % 12) + 12 * int(hours % 12 === 0)
	                : hours);
	            self.minuteElement.value = pad(minutes);
	            if (self.amPM !== undefined)
	                self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
	            if (self.secondElement !== undefined)
	                self.secondElement.value = pad(seconds);
	        }
	        /**
	         * Handles the year input and incrementing events
	         * @param {Event} event the keyup or increment event
	         */
	        function onYearInput(event) {
	            var year = parseInt(event.target.value) + (event.delta || 0);
	            if (year / 1000 > 1 ||
	                (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
	                changeYear(year);
	            }
	        }
	        /**
	         * Essentially addEventListener + tracking
	         * @param {Element} element the element to addEventListener to
	         * @param {String} event the event name
	         * @param {Function} handler the event handler
	         */
	        function bind(element, event, handler, options) {
	            if (event instanceof Array)
	                return event.forEach(function (ev) { return bind(element, ev, handler, options); });
	            if (element instanceof Array)
	                return element.forEach(function (el) { return bind(el, event, handler, options); });
	            element.addEventListener(event, handler, options);
	            self._handlers.push({
	                element: element,
	                event: event,
	                handler: handler,
	                options: options
	            });
	        }
	        /**
	         * A mousedown handler which mimics click.
	         * Minimizes latency, since we don't need to wait for mouseup in most cases.
	         * Also, avoids handling right clicks.
	         *
	         * @param {Function} handler the event handler
	         */
	        function onClick(handler) {
	            return function (evt) {
	                evt.which === 1 && handler(evt);
	            };
	        }
	        function triggerChange() {
	            triggerEvent("onChange");
	        }
	        /**
	         * Adds all the necessary event listeners
	         */
	        function bindEvents() {
	            if (self.config.wrap) {
	                ["open", "close", "toggle", "clear"].forEach(function (evt) {
	                    Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
	                        return bind(el, "click", self[evt]);
	                    });
	                });
	            }
	            if (self.isMobile) {
	                setupMobile();
	                return;
	            }
	            var debouncedResize = debounce(onResize, 50);
	            self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
	            if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
	                bind(self.daysContainer, "mouseover", function (e) {
	                    if (self.config.mode === "range")
	                        onMouseOver(e.target);
	                });
	            bind(window.document.body, "keydown", onKeyDown);
	            if (!self.config.inline && !self.config.static)
	                bind(window, "resize", debouncedResize);
	            if (window.ontouchstart !== undefined)
	                bind(window.document, "touchstart", documentClick);
	            else
	                bind(window.document, "mousedown", onClick(documentClick));
	            bind(window.document, "focus", documentClick, { capture: true });
	            if (self.config.clickOpens === true) {
	                bind(self._input, "focus", self.open);
	                bind(self._input, "mousedown", onClick(self.open));
	            }
	            if (self.daysContainer !== undefined) {
	                bind(self.monthNav, "mousedown", onClick(onMonthNavClick));
	                bind(self.monthNav, ["keyup", "increment"], onYearInput);
	                bind(self.daysContainer, "mousedown", onClick(selectDate));
	            }
	            if (self.timeContainer !== undefined &&
	                self.minuteElement !== undefined &&
	                self.hourElement !== undefined) {
	                var selText = function (e) {
	                    return e.target.select();
	                };
	                bind(self.timeContainer, ["increment"], updateTime);
	                bind(self.timeContainer, "blur", updateTime, { capture: true });
	                bind(self.timeContainer, "mousedown", onClick(timeIncrement));
	                bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
	                if (self.secondElement !== undefined)
	                    bind(self.secondElement, "focus", function () { return self.secondElement && self.secondElement.select(); });
	                if (self.amPM !== undefined) {
	                    bind(self.amPM, "mousedown", onClick(function (e) {
	                        updateTime(e);
	                        triggerChange();
	                    }));
	                }
	            }
	        }
	        /**
	         * Set the calendar view to a particular date.
	         * @param {Date} jumpDate the date to set the view to
	         * @param {boolean} triggerChange if change events should be triggered
	         */
	        function jumpToDate(jumpDate, triggerChange) {
	            var jumpTo = jumpDate !== undefined
	                ? self.parseDate(jumpDate)
	                : self.latestSelectedDateObj ||
	                    (self.config.minDate && self.config.minDate > self.now
	                        ? self.config.minDate
	                        : self.config.maxDate && self.config.maxDate < self.now
	                            ? self.config.maxDate
	                            : self.now);
	            var oldYear = self.currentYear;
	            var oldMonth = self.currentMonth;
	            try {
	                if (jumpTo !== undefined) {
	                    self.currentYear = jumpTo.getFullYear();
	                    self.currentMonth = jumpTo.getMonth();
	                }
	            }
	            catch (e) {
	                /* istanbul ignore next */
	                e.message = "Invalid date supplied: " + jumpTo;
	                self.config.errorHandler(e);
	            }
	            if (triggerChange && self.currentYear !== oldYear) {
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	            if (triggerChange &&
	                (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
	                triggerEvent("onMonthChange");
	            }
	            self.redraw();
	        }
	        /**
	         * The up/down arrow handler for time inputs
	         * @param {Event} e the click event
	         */
	        function timeIncrement(e) {
	            if (~e.target.className.indexOf("arrow"))
	                incrementNumInput(e, e.target.classList.contains("arrowUp") ? 1 : -1);
	        }
	        /**
	         * Increments/decrements the value of input associ-
	         * ated with the up/down arrow by dispatching an
	         * "increment" event on the input.
	         *
	         * @param {Event} e the click event
	         * @param {Number} delta the diff (usually 1 or -1)
	         * @param {Element} inputElem the input element
	         */
	        function incrementNumInput(e, delta, inputElem) {
	            var target = e && e.target;
	            var input = inputElem ||
	                (target && target.parentNode && target.parentNode.firstChild);
	            var event = createEvent("increment");
	            event.delta = delta;
	            input && input.dispatchEvent(event);
	        }
	        function build() {
	            var fragment = window.document.createDocumentFragment();
	            self.calendarContainer = createElement("div", "flatpickr-calendar");
	            self.calendarContainer.tabIndex = -1;
	            if (!self.config.noCalendar) {
	                fragment.appendChild(buildMonthNav());
	                self.innerContainer = createElement("div", "flatpickr-innerContainer");
	                if (self.config.weekNumbers) {
	                    var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
	                    self.innerContainer.appendChild(weekWrapper);
	                    self.weekNumbers = weekNumbers;
	                    self.weekWrapper = weekWrapper;
	                }
	                self.rContainer = createElement("div", "flatpickr-rContainer");
	                self.rContainer.appendChild(buildWeekdays());
	                if (!self.daysContainer) {
	                    self.daysContainer = createElement("div", "flatpickr-days");
	                    self.daysContainer.tabIndex = -1;
	                }
	                buildDays();
	                self.rContainer.appendChild(self.daysContainer);
	                self.innerContainer.appendChild(self.rContainer);
	                fragment.appendChild(self.innerContainer);
	            }
	            if (self.config.enableTime) {
	                fragment.appendChild(buildTime());
	            }
	            toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
	            toggleClass(self.calendarContainer, "animate", self.config.animate === true);
	            toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
	            self.calendarContainer.appendChild(fragment);
	            var customAppend = self.config.appendTo !== undefined &&
	                self.config.appendTo.nodeType !== undefined;
	            if (self.config.inline || self.config.static) {
	                self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
	                if (self.config.inline) {
	                    if (!customAppend && self.element.parentNode)
	                        self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
	                    else if (self.config.appendTo !== undefined)
	                        self.config.appendTo.appendChild(self.calendarContainer);
	                }
	                if (self.config.static) {
	                    var wrapper = createElement("div", "flatpickr-wrapper");
	                    if (self.element.parentNode)
	                        self.element.parentNode.insertBefore(wrapper, self.element);
	                    wrapper.appendChild(self.element);
	                    if (self.altInput)
	                        wrapper.appendChild(self.altInput);
	                    wrapper.appendChild(self.calendarContainer);
	                }
	            }
	            if (!self.config.static && !self.config.inline)
	                (self.config.appendTo !== undefined
	                    ? self.config.appendTo
	                    : window.document.body).appendChild(self.calendarContainer);
	        }
	        function createDay(className, date, dayNumber, i) {
	            var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
	            dayElement.dateObj = date;
	            dayElement.$i = i;
	            dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
	            if (className.indexOf("hidden") === -1 &&
	                compareDates(date, self.now) === 0) {
	                self.todayDateElem = dayElement;
	                dayElement.classList.add("today");
	                dayElement.setAttribute("aria-current", "date");
	            }
	            if (dateIsEnabled) {
	                dayElement.tabIndex = -1;
	                if (isDateSelected(date)) {
	                    dayElement.classList.add("selected");
	                    self.selectedDateElem = dayElement;
	                    if (self.config.mode === "range") {
	                        toggleClass(dayElement, "startRange", self.selectedDates[0] &&
	                            compareDates(date, self.selectedDates[0], true) === 0);
	                        toggleClass(dayElement, "endRange", self.selectedDates[1] &&
	                            compareDates(date, self.selectedDates[1], true) === 0);
	                        if (className === "nextMonthDay")
	                            dayElement.classList.add("inRange");
	                    }
	                }
	            }
	            else {
	                dayElement.classList.add("flatpickr-disabled");
	            }
	            if (self.config.mode === "range") {
	                if (isDateInRange(date) && !isDateSelected(date))
	                    dayElement.classList.add("inRange");
	            }
	            if (self.weekNumbers &&
	                self.config.showMonths === 1 &&
	                className !== "prevMonthDay" &&
	                dayNumber % 7 === 1) {
	                self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
	            }
	            triggerEvent("onDayCreate", dayElement);
	            return dayElement;
	        }
	        function focusOnDayElem(targetNode) {
	            targetNode.focus();
	            if (self.config.mode === "range")
	                onMouseOver(targetNode);
	        }
	        function getFirstAvailableDay(delta) {
	            var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
	            var endMonth = delta > 0 ? self.config.showMonths : -1;
	            for (var m = startMonth; m != endMonth; m += delta) {
	                var month = self.daysContainer.children[m];
	                var startIndex = delta > 0 ? 0 : month.children.length - 1;
	                var endIndex = delta > 0 ? month.children.length : -1;
	                for (var i = startIndex; i != endIndex; i += delta) {
	                    var c = month.children[i];
	                    if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
	                        return c;
	                }
	            }
	            return undefined;
	        }
	        function getNextAvailableDay(current, delta) {
	            var givenMonth = current.className.indexOf("Month") === -1
	                ? current.dateObj.getMonth()
	                : self.currentMonth;
	            var endMonth = delta > 0 ? self.config.showMonths : -1;
	            var loopDelta = delta > 0 ? 1 : -1;
	            for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
	                var month = self.daysContainer.children[m];
	                var startIndex = givenMonth - self.currentMonth === m
	                    ? current.$i + delta
	                    : delta < 0
	                        ? month.children.length - 1
	                        : 0;
	                var numMonthDays = month.children.length;
	                for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
	                    var c = month.children[i];
	                    if (c.className.indexOf("hidden") === -1 &&
	                        isEnabled(c.dateObj) &&
	                        Math.abs(current.$i - i) >= Math.abs(delta))
	                        return focusOnDayElem(c);
	                }
	            }
	            self.changeMonth(loopDelta);
	            focusOnDay(getFirstAvailableDay(loopDelta), 0);
	            return undefined;
	        }
	        function focusOnDay(current, offset) {
	            var dayFocused = isInView(document.activeElement || document.body);
	            var startElem = current !== undefined
	                ? current
	                : dayFocused
	                    ? document.activeElement
	                    : self.selectedDateElem !== undefined && isInView(self.selectedDateElem)
	                        ? self.selectedDateElem
	                        : self.todayDateElem !== undefined && isInView(self.todayDateElem)
	                            ? self.todayDateElem
	                            : getFirstAvailableDay(offset > 0 ? 1 : -1);
	            if (startElem === undefined)
	                return self._input.focus();
	            if (!dayFocused)
	                return focusOnDayElem(startElem);
	            getNextAvailableDay(startElem, offset);
	        }
	        function buildMonthDays(year, month) {
	            var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
	            var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12);
	            var daysInMonth = self.utils.getDaysInMonth(month), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
	            var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
	            // prepend days from the ending of previous month
	            for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
	                days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
	            }
	            // Start at 1 since there is no 0th day
	            for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
	                days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
	            }
	            // append days from the next month
	            for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth &&
	                (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
	                days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
	            }
	            //updateNavigationCurrentMonth();
	            var dayContainer = createElement("div", "dayContainer");
	            dayContainer.appendChild(days);
	            return dayContainer;
	        }
	        function buildDays() {
	            if (self.daysContainer === undefined) {
	                return;
	            }
	            clearNode(self.daysContainer);
	            // TODO: week numbers for each month
	            if (self.weekNumbers)
	                clearNode(self.weekNumbers);
	            var frag = document.createDocumentFragment();
	            for (var i = 0; i < self.config.showMonths; i++) {
	                var d = new Date(self.currentYear, self.currentMonth, 1);
	                d.setMonth(self.currentMonth + i);
	                frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
	            }
	            self.daysContainer.appendChild(frag);
	            self.days = self.daysContainer.firstChild;
	            if (self.config.mode === "range" && self.selectedDates.length === 1) {
	                onMouseOver();
	            }
	        }
	        function buildMonthSwitch() {
	            if (self.config.showMonths > 1 ||
	                self.config.monthSelectorType !== "dropdown")
	                return;
	            var shouldBuildMonth = function (month) {
	                if (self.config.minDate !== undefined &&
	                    self.currentYear === self.config.minDate.getFullYear() &&
	                    month < self.config.minDate.getMonth()) {
	                    return false;
	                }
	                return !(self.config.maxDate !== undefined &&
	                    self.currentYear === self.config.maxDate.getFullYear() &&
	                    month > self.config.maxDate.getMonth());
	            };
	            self.monthsDropdownContainer.tabIndex = -1;
	            self.monthsDropdownContainer.innerHTML = "";
	            for (var i = 0; i < 12; i++) {
	                if (!shouldBuildMonth(i))
	                    continue;
	                var month = createElement("option", "flatpickr-monthDropdown-month");
	                month.value = new Date(self.currentYear, i).getMonth().toString();
	                month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
	                month.tabIndex = -1;
	                if (self.currentMonth === i) {
	                    month.selected = true;
	                }
	                self.monthsDropdownContainer.appendChild(month);
	            }
	        }
	        function buildMonth() {
	            var container = createElement("div", "flatpickr-month");
	            var monthNavFragment = window.document.createDocumentFragment();
	            var monthElement;
	            if (self.config.showMonths > 1 ||
	                self.config.monthSelectorType === "static") {
	                monthElement = createElement("span", "cur-month");
	            }
	            else {
	                self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
	                bind(self.monthsDropdownContainer, "change", function (e) {
	                    var target = e.target;
	                    var selectedMonth = parseInt(target.value, 10);
	                    self.changeMonth(selectedMonth - self.currentMonth);
	                    triggerEvent("onMonthChange");
	                });
	                buildMonthSwitch();
	                monthElement = self.monthsDropdownContainer;
	            }
	            var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
	            var yearElement = yearInput.getElementsByTagName("input")[0];
	            yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
	            if (self.config.minDate) {
	                yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
	            }
	            if (self.config.maxDate) {
	                yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
	                yearElement.disabled =
	                    !!self.config.minDate &&
	                        self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
	            }
	            var currentMonth = createElement("div", "flatpickr-current-month");
	            currentMonth.appendChild(monthElement);
	            currentMonth.appendChild(yearInput);
	            monthNavFragment.appendChild(currentMonth);
	            container.appendChild(monthNavFragment);
	            return {
	                container: container,
	                yearElement: yearElement,
	                monthElement: monthElement
	            };
	        }
	        function buildMonths() {
	            clearNode(self.monthNav);
	            self.monthNav.appendChild(self.prevMonthNav);
	            if (self.config.showMonths) {
	                self.yearElements = [];
	                self.monthElements = [];
	            }
	            for (var m = self.config.showMonths; m--;) {
	                var month = buildMonth();
	                self.yearElements.push(month.yearElement);
	                self.monthElements.push(month.monthElement);
	                self.monthNav.appendChild(month.container);
	            }
	            self.monthNav.appendChild(self.nextMonthNav);
	        }
	        function buildMonthNav() {
	            self.monthNav = createElement("div", "flatpickr-months");
	            self.yearElements = [];
	            self.monthElements = [];
	            self.prevMonthNav = createElement("span", "flatpickr-prev-month");
	            self.prevMonthNav.innerHTML = self.config.prevArrow;
	            self.nextMonthNav = createElement("span", "flatpickr-next-month");
	            self.nextMonthNav.innerHTML = self.config.nextArrow;
	            buildMonths();
	            Object.defineProperty(self, "_hidePrevMonthArrow", {
	                get: function () { return self.__hidePrevMonthArrow; },
	                set: function (bool) {
	                    if (self.__hidePrevMonthArrow !== bool) {
	                        toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
	                        self.__hidePrevMonthArrow = bool;
	                    }
	                }
	            });
	            Object.defineProperty(self, "_hideNextMonthArrow", {
	                get: function () { return self.__hideNextMonthArrow; },
	                set: function (bool) {
	                    if (self.__hideNextMonthArrow !== bool) {
	                        toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
	                        self.__hideNextMonthArrow = bool;
	                    }
	                }
	            });
	            self.currentYearElement = self.yearElements[0];
	            updateNavigationCurrentMonth();
	            return self.monthNav;
	        }
	        function buildTime() {
	            self.calendarContainer.classList.add("hasTime");
	            if (self.config.noCalendar)
	                self.calendarContainer.classList.add("noCalendar");
	            self.timeContainer = createElement("div", "flatpickr-time");
	            self.timeContainer.tabIndex = -1;
	            var separator = createElement("span", "flatpickr-time-separator", ":");
	            var hourInput = createNumberInput("flatpickr-hour", {
	                "aria-label": self.l10n.hourAriaLabel
	            });
	            self.hourElement = hourInput.getElementsByTagName("input")[0];
	            var minuteInput = createNumberInput("flatpickr-minute", {
	                "aria-label": self.l10n.minuteAriaLabel
	            });
	            self.minuteElement = minuteInput.getElementsByTagName("input")[0];
	            self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
	            self.hourElement.value = pad(self.latestSelectedDateObj
	                ? self.latestSelectedDateObj.getHours()
	                : self.config.time_24hr
	                    ? self.config.defaultHour
	                    : military2ampm(self.config.defaultHour));
	            self.minuteElement.value = pad(self.latestSelectedDateObj
	                ? self.latestSelectedDateObj.getMinutes()
	                : self.config.defaultMinute);
	            self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
	            self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
	            self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
	            self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
	            self.minuteElement.setAttribute("min", "0");
	            self.minuteElement.setAttribute("max", "59");
	            self.timeContainer.appendChild(hourInput);
	            self.timeContainer.appendChild(separator);
	            self.timeContainer.appendChild(minuteInput);
	            if (self.config.time_24hr)
	                self.timeContainer.classList.add("time24hr");
	            if (self.config.enableSeconds) {
	                self.timeContainer.classList.add("hasSeconds");
	                var secondInput = createNumberInput("flatpickr-second");
	                self.secondElement = secondInput.getElementsByTagName("input")[0];
	                self.secondElement.value = pad(self.latestSelectedDateObj
	                    ? self.latestSelectedDateObj.getSeconds()
	                    : self.config.defaultSeconds);
	                self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
	                self.secondElement.setAttribute("min", "0");
	                self.secondElement.setAttribute("max", "59");
	                self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
	                self.timeContainer.appendChild(secondInput);
	            }
	            if (!self.config.time_24hr) {
	                // add self.amPM if appropriate
	                self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj
	                    ? self.hourElement.value
	                    : self.config.defaultHour) > 11)]);
	                self.amPM.title = self.l10n.toggleTitle;
	                self.amPM.tabIndex = -1;
	                self.timeContainer.appendChild(self.amPM);
	            }
	            return self.timeContainer;
	        }
	        function buildWeekdays() {
	            if (!self.weekdayContainer)
	                self.weekdayContainer = createElement("div", "flatpickr-weekdays");
	            else
	                clearNode(self.weekdayContainer);
	            for (var i = self.config.showMonths; i--;) {
	                var container = createElement("div", "flatpickr-weekdaycontainer");
	                self.weekdayContainer.appendChild(container);
	            }
	            updateWeekdays();
	            return self.weekdayContainer;
	        }
	        function updateWeekdays() {
	            if (!self.weekdayContainer) {
	                return;
	            }
	            var firstDayOfWeek = self.l10n.firstDayOfWeek;
	            var weekdays = self.l10n.weekdays.shorthand.slice();
	            if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
	                weekdays = weekdays.splice(firstDayOfWeek, weekdays.length).concat(weekdays.splice(0, firstDayOfWeek));
	            }
	            for (var i = self.config.showMonths; i--;) {
	                self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
	            }
	        }
	        /* istanbul ignore next */
	        function buildWeeks() {
	            self.calendarContainer.classList.add("hasWeeks");
	            var weekWrapper = createElement("div", "flatpickr-weekwrapper");
	            weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
	            var weekNumbers = createElement("div", "flatpickr-weeks");
	            weekWrapper.appendChild(weekNumbers);
	            return {
	                weekWrapper: weekWrapper,
	                weekNumbers: weekNumbers
	            };
	        }
	        function changeMonth(value, isOffset) {
	            if (isOffset === void 0) { isOffset = true; }
	            var delta = isOffset ? value : value - self.currentMonth;
	            if ((delta < 0 && self._hidePrevMonthArrow === true) ||
	                (delta > 0 && self._hideNextMonthArrow === true))
	                return;
	            self.currentMonth += delta;
	            if (self.currentMonth < 0 || self.currentMonth > 11) {
	                self.currentYear += self.currentMonth > 11 ? 1 : -1;
	                self.currentMonth = (self.currentMonth + 12) % 12;
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	            buildDays();
	            triggerEvent("onMonthChange");
	            updateNavigationCurrentMonth();
	        }
	        function clear(triggerChangeEvent, toInitial) {
	            if (triggerChangeEvent === void 0) { triggerChangeEvent = true; }
	            if (toInitial === void 0) { toInitial = true; }
	            self.input.value = "";
	            if (self.altInput !== undefined)
	                self.altInput.value = "";
	            if (self.mobileInput !== undefined)
	                self.mobileInput.value = "";
	            self.selectedDates = [];
	            self.latestSelectedDateObj = undefined;
	            if (toInitial === true) {
	                self.currentYear = self._initialDate.getFullYear();
	                self.currentMonth = self._initialDate.getMonth();
	            }
	            self.showTimeInput = false;
	            if (self.config.enableTime === true) {
	                setDefaultHours();
	            }
	            self.redraw();
	            if (triggerChangeEvent)
	                // triggerChangeEvent is true (default) or an Event
	                triggerEvent("onChange");
	        }
	        function close() {
	            self.isOpen = false;
	            if (!self.isMobile) {
	                if (self.calendarContainer !== undefined) {
	                    self.calendarContainer.classList.remove("open");
	                }
	                if (self._input !== undefined) {
	                    self._input.classList.remove("active");
	                }
	            }
	            triggerEvent("onClose");
	        }
	        function destroy() {
	            if (self.config !== undefined)
	                triggerEvent("onDestroy");
	            for (var i = self._handlers.length; i--;) {
	                var h = self._handlers[i];
	                h.element.removeEventListener(h.event, h.handler, h.options);
	            }
	            self._handlers = [];
	            if (self.mobileInput) {
	                if (self.mobileInput.parentNode)
	                    self.mobileInput.parentNode.removeChild(self.mobileInput);
	                self.mobileInput = undefined;
	            }
	            else if (self.calendarContainer && self.calendarContainer.parentNode) {
	                if (self.config.static && self.calendarContainer.parentNode) {
	                    var wrapper = self.calendarContainer.parentNode;
	                    wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
	                    if (wrapper.parentNode) {
	                        while (wrapper.firstChild)
	                            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
	                        wrapper.parentNode.removeChild(wrapper);
	                    }
	                }
	                else
	                    self.calendarContainer.parentNode.removeChild(self.calendarContainer);
	            }
	            if (self.altInput) {
	                self.input.type = "text";
	                if (self.altInput.parentNode)
	                    self.altInput.parentNode.removeChild(self.altInput);
	                delete self.altInput;
	            }
	            if (self.input) {
	                self.input.type = self.input._type;
	                self.input.classList.remove("flatpickr-input");
	                self.input.removeAttribute("readonly");
	                self.input.value = "";
	            }
	            [
	                "_showTimeInput",
	                "latestSelectedDateObj",
	                "_hideNextMonthArrow",
	                "_hidePrevMonthArrow",
	                "__hideNextMonthArrow",
	                "__hidePrevMonthArrow",
	                "isMobile",
	                "isOpen",
	                "selectedDateElem",
	                "minDateHasTime",
	                "maxDateHasTime",
	                "days",
	                "daysContainer",
	                "_input",
	                "_positionElement",
	                "innerContainer",
	                "rContainer",
	                "monthNav",
	                "todayDateElem",
	                "calendarContainer",
	                "weekdayContainer",
	                "prevMonthNav",
	                "nextMonthNav",
	                "monthsDropdownContainer",
	                "currentMonthElement",
	                "currentYearElement",
	                "navigationCurrentMonth",
	                "selectedDateElem",
	                "config",
	            ].forEach(function (k) {
	                try {
	                    delete self[k];
	                }
	                catch (_) { }
	            });
	        }
	        function isCalendarElem(elem) {
	            if (self.config.appendTo && self.config.appendTo.contains(elem))
	                return true;
	            return self.calendarContainer.contains(elem);
	        }
	        function documentClick(e) {
	            if (self.isOpen && !self.config.inline) {
	                var eventTarget_1 = getEventTarget(e);
	                var isCalendarElement = isCalendarElem(eventTarget_1);
	                var isInput = eventTarget_1 === self.input ||
	                    eventTarget_1 === self.altInput ||
	                    self.element.contains(eventTarget_1) ||
	                    // web components
	                    // e.path is not present in all browsers. circumventing typechecks
	                    (e.path &&
	                        e.path.indexOf &&
	                        (~e.path.indexOf(self.input) ||
	                            ~e.path.indexOf(self.altInput)));
	                var lostFocus = e.type === "blur"
	                    ? isInput &&
	                        e.relatedTarget &&
	                        !isCalendarElem(e.relatedTarget)
	                    : !isInput &&
	                        !isCalendarElement &&
	                        !isCalendarElem(e.relatedTarget);
	                var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
	                    return elem.contains(eventTarget_1);
	                });
	                if (lostFocus && isIgnored) {
	                    if (self.timeContainer !== undefined &&
	                        self.minuteElement !== undefined &&
	                        self.hourElement !== undefined) {
	                        updateTime();
	                    }
	                    self.close();
	                    if (self.config.mode === "range" && self.selectedDates.length === 1) {
	                        self.clear(false);
	                        self.redraw();
	                    }
	                }
	            }
	        }
	        function changeYear(newYear) {
	            if (!newYear ||
	                (self.config.minDate && newYear < self.config.minDate.getFullYear()) ||
	                (self.config.maxDate && newYear > self.config.maxDate.getFullYear()))
	                return;
	            var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
	            self.currentYear = newYearNum || self.currentYear;
	            if (self.config.maxDate &&
	                self.currentYear === self.config.maxDate.getFullYear()) {
	                self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
	            }
	            else if (self.config.minDate &&
	                self.currentYear === self.config.minDate.getFullYear()) {
	                self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
	            }
	            if (isNewYear) {
	                self.redraw();
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	        }
	        function isEnabled(date, timeless) {
	            if (timeless === void 0) { timeless = true; }
	            var dateToCheck = self.parseDate(date, undefined, timeless); // timeless
	            if ((self.config.minDate &&
	                dateToCheck &&
	                compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) ||
	                (self.config.maxDate &&
	                    dateToCheck &&
	                    compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0))
	                return false;
	            if (self.config.enable.length === 0 && self.config.disable.length === 0)
	                return true;
	            if (dateToCheck === undefined)
	                return false;
	            var bool = self.config.enable.length > 0, array = bool ? self.config.enable : self.config.disable;
	            for (var i = 0, d = void 0; i < array.length; i++) {
	                d = array[i];
	                if (typeof d === "function" &&
	                    d(dateToCheck) // disabled by function
	                )
	                    return bool;
	                else if (d instanceof Date &&
	                    dateToCheck !== undefined &&
	                    d.getTime() === dateToCheck.getTime())
	                    // disabled by date
	                    return bool;
	                else if (typeof d === "string" && dateToCheck !== undefined) {
	                    // disabled by date string
	                    var parsed = self.parseDate(d, undefined, true);
	                    return parsed && parsed.getTime() === dateToCheck.getTime()
	                        ? bool
	                        : !bool;
	                }
	                else if (
	                // disabled by range
	                typeof d === "object" &&
	                    dateToCheck !== undefined &&
	                    d.from &&
	                    d.to &&
	                    dateToCheck.getTime() >= d.from.getTime() &&
	                    dateToCheck.getTime() <= d.to.getTime())
	                    return bool;
	            }
	            return !bool;
	        }
	        function isInView(elem) {
	            if (self.daysContainer !== undefined)
	                return (elem.className.indexOf("hidden") === -1 &&
	                    self.daysContainer.contains(elem));
	            return false;
	        }
	        function onKeyDown(e) {
	            // e.key                      e.keyCode
	            // "Backspace"                        8
	            // "Tab"                              9
	            // "Enter"                           13
	            // "Escape"     (IE "Esc")           27
	            // "ArrowLeft"  (IE "Left")          37
	            // "ArrowUp"    (IE "Up")            38
	            // "ArrowRight" (IE "Right")         39
	            // "ArrowDown"  (IE "Down")          40
	            // "Delete"     (IE "Del")           46
	            var isInput = e.target === self._input;
	            var allowInput = self.config.allowInput;
	            var allowKeydown = self.isOpen && (!allowInput || !isInput);
	            var allowInlineKeydown = self.config.inline && isInput && !allowInput;
	            if (e.keyCode === 13 && isInput) {
	                if (allowInput) {
	                    self.setDate(self._input.value, true, e.target === self.altInput
	                        ? self.config.altFormat
	                        : self.config.dateFormat);
	                    return e.target.blur();
	                }
	                else {
	                    self.open();
	                }
	            }
	            else if (isCalendarElem(e.target) ||
	                allowKeydown ||
	                allowInlineKeydown) {
	                var isTimeObj = !!self.timeContainer &&
	                    self.timeContainer.contains(e.target);
	                switch (e.keyCode) {
	                    case 13:
	                        if (isTimeObj) {
	                            e.preventDefault();
	                            updateTime();
	                            focusAndClose();
	                        }
	                        else
	                            selectDate(e);
	                        break;
	                    case 27: // escape
	                        e.preventDefault();
	                        focusAndClose();
	                        break;
	                    case 8:
	                    case 46:
	                        if (isInput && !self.config.allowInput) {
	                            e.preventDefault();
	                            self.clear();
	                        }
	                        break;
	                    case 37:
	                    case 39:
	                        if (!isTimeObj && !isInput) {
	                            e.preventDefault();
	                            if (self.daysContainer !== undefined &&
	                                (allowInput === false ||
	                                    (document.activeElement && isInView(document.activeElement)))) {
	                                var delta_1 = e.keyCode === 39 ? 1 : -1;
	                                if (!e.ctrlKey)
	                                    focusOnDay(undefined, delta_1);
	                                else {
	                                    e.stopPropagation();
	                                    changeMonth(delta_1);
	                                    focusOnDay(getFirstAvailableDay(1), 0);
	                                }
	                            }
	                        }
	                        else if (self.hourElement)
	                            self.hourElement.focus();
	                        break;
	                    case 38:
	                    case 40:
	                        e.preventDefault();
	                        var delta = e.keyCode === 40 ? 1 : -1;
	                        if ((self.daysContainer && e.target.$i !== undefined) ||
	                            e.target === self.input ||
	                            e.target === self.altInput) {
	                            if (e.ctrlKey) {
	                                e.stopPropagation();
	                                changeYear(self.currentYear - delta);
	                                focusOnDay(getFirstAvailableDay(1), 0);
	                            }
	                            else if (!isTimeObj)
	                                focusOnDay(undefined, delta * 7);
	                        }
	                        else if (e.target === self.currentYearElement) {
	                            changeYear(self.currentYear - delta);
	                        }
	                        else if (self.config.enableTime) {
	                            if (!isTimeObj && self.hourElement)
	                                self.hourElement.focus();
	                            updateTime(e);
	                            self._debouncedChange();
	                        }
	                        break;
	                    case 9:
	                        if (isTimeObj) {
	                            var elems = [
	                                self.hourElement,
	                                self.minuteElement,
	                                self.secondElement,
	                                self.amPM,
	                            ]
	                                .concat(self.pluginElements)
	                                .filter(function (x) { return x; });
	                            var i = elems.indexOf(e.target);
	                            if (i !== -1) {
	                                var target = elems[i + (e.shiftKey ? -1 : 1)];
	                                e.preventDefault();
	                                (target || self._input).focus();
	                            }
	                        }
	                        else if (!self.config.noCalendar &&
	                            self.daysContainer &&
	                            self.daysContainer.contains(e.target) &&
	                            e.shiftKey) {
	                            e.preventDefault();
	                            self._input.focus();
	                        }
	                        break;
	                    default:
	                        break;
	                }
	            }
	            if (self.amPM !== undefined && e.target === self.amPM) {
	                switch (e.key) {
	                    case self.l10n.amPM[0].charAt(0):
	                    case self.l10n.amPM[0].charAt(0).toLowerCase():
	                        self.amPM.textContent = self.l10n.amPM[0];
	                        setHoursFromInputs();
	                        updateValue();
	                        break;
	                    case self.l10n.amPM[1].charAt(0):
	                    case self.l10n.amPM[1].charAt(0).toLowerCase():
	                        self.amPM.textContent = self.l10n.amPM[1];
	                        setHoursFromInputs();
	                        updateValue();
	                        break;
	                }
	            }
	            if (isInput || isCalendarElem(e.target)) {
	                triggerEvent("onKeyDown", e);
	            }
	        }
	        function onMouseOver(elem) {
	            if (self.selectedDates.length !== 1 ||
	                (elem &&
	                    (!elem.classList.contains("flatpickr-day") ||
	                        elem.classList.contains("flatpickr-disabled"))))
	                return;
	            var hoverDate = elem
	                ? elem.dateObj.getTime()
	                : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
	            var containsDisabled = false;
	            var minRange = 0, maxRange = 0;
	            for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
	                if (!isEnabled(new Date(t), true)) {
	                    containsDisabled =
	                        containsDisabled || (t > rangeStartDate && t < rangeEndDate);
	                    if (t < initialDate && (!minRange || t > minRange))
	                        minRange = t;
	                    else if (t > initialDate && (!maxRange || t < maxRange))
	                        maxRange = t;
	                }
	            }
	            for (var m = 0; m < self.config.showMonths; m++) {
	                var month = self.daysContainer.children[m];
	                var _loop_1 = function (i, l) {
	                    var dayElem = month.children[i], date = dayElem.dateObj;
	                    var timestamp = date.getTime();
	                    var outOfRange = (minRange > 0 && timestamp < minRange) ||
	                        (maxRange > 0 && timestamp > maxRange);
	                    if (outOfRange) {
	                        dayElem.classList.add("notAllowed");
	                        ["inRange", "startRange", "endRange"].forEach(function (c) {
	                            dayElem.classList.remove(c);
	                        });
	                        return "continue";
	                    }
	                    else if (containsDisabled && !outOfRange)
	                        return "continue";
	                    ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
	                        dayElem.classList.remove(c);
	                    });
	                    if (elem !== undefined) {
	                        elem.classList.add(hoverDate <= self.selectedDates[0].getTime()
	                            ? "startRange"
	                            : "endRange");
	                        if (initialDate < hoverDate && timestamp === initialDate)
	                            dayElem.classList.add("startRange");
	                        else if (initialDate > hoverDate && timestamp === initialDate)
	                            dayElem.classList.add("endRange");
	                        if (timestamp >= minRange &&
	                            (maxRange === 0 || timestamp <= maxRange) &&
	                            isBetween(timestamp, initialDate, hoverDate))
	                            dayElem.classList.add("inRange");
	                    }
	                };
	                for (var i = 0, l = month.children.length; i < l; i++) {
	                    _loop_1(i, l);
	                }
	            }
	        }
	        function onResize() {
	            if (self.isOpen && !self.config.static && !self.config.inline)
	                positionCalendar();
	        }
	        function setDefaultTime() {
	            self.setDate(self.config.minDate !== undefined
	                ? new Date(self.config.minDate.getTime())
	                : new Date(), true);
	            setDefaultHours();
	            updateValue();
	        }
	        function open(e, positionElement) {
	            if (positionElement === void 0) { positionElement = self._positionElement; }
	            if (self.isMobile === true) {
	                if (e) {
	                    e.preventDefault();
	                    e.target && e.target.blur();
	                }
	                if (self.mobileInput !== undefined) {
	                    self.mobileInput.focus();
	                    self.mobileInput.click();
	                }
	                triggerEvent("onOpen");
	                return;
	            }
	            if (self._input.disabled || self.config.inline)
	                return;
	            var wasOpen = self.isOpen;
	            self.isOpen = true;
	            if (!wasOpen) {
	                self.calendarContainer.classList.add("open");
	                self._input.classList.add("active");
	                triggerEvent("onOpen");
	                positionCalendar(positionElement);
	            }
	            if (self.config.enableTime === true && self.config.noCalendar === true) {
	                if (self.selectedDates.length === 0) {
	                    setDefaultTime();
	                }
	                if (self.config.allowInput === false &&
	                    (e === undefined ||
	                        !self.timeContainer.contains(e.relatedTarget))) {
	                    setTimeout(function () { return self.hourElement.select(); }, 50);
	                }
	            }
	        }
	        function minMaxDateSetter(type) {
	            return function (date) {
	                var dateObj = (self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat));
	                var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
	                if (dateObj !== undefined) {
	                    self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] =
	                        dateObj.getHours() > 0 ||
	                            dateObj.getMinutes() > 0 ||
	                            dateObj.getSeconds() > 0;
	                }
	                if (self.selectedDates) {
	                    self.selectedDates = self.selectedDates.filter(function (d) { return isEnabled(d); });
	                    if (!self.selectedDates.length && type === "min")
	                        setHoursFromDate(dateObj);
	                    updateValue();
	                }
	                if (self.daysContainer) {
	                    redraw();
	                    if (dateObj !== undefined)
	                        self.currentYearElement[type] = dateObj.getFullYear().toString();
	                    else
	                        self.currentYearElement.removeAttribute(type);
	                    self.currentYearElement.disabled =
	                        !!inverseDateObj &&
	                            dateObj !== undefined &&
	                            inverseDateObj.getFullYear() === dateObj.getFullYear();
	                }
	            };
	        }
	        function parseConfig() {
	            var boolOpts = [
	                "wrap",
	                "weekNumbers",
	                "allowInput",
	                "clickOpens",
	                "time_24hr",
	                "enableTime",
	                "noCalendar",
	                "altInput",
	                "shorthandCurrentMonth",
	                "inline",
	                "static",
	                "enableSeconds",
	                "disableMobile",
	            ];
	            var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
	            var formats = {};
	            self.config.parseDate = userConfig.parseDate;
	            self.config.formatDate = userConfig.formatDate;
	            Object.defineProperty(self.config, "enable", {
	                get: function () { return self.config._enable; },
	                set: function (dates) {
	                    self.config._enable = parseDateRules(dates);
	                }
	            });
	            Object.defineProperty(self.config, "disable", {
	                get: function () { return self.config._disable; },
	                set: function (dates) {
	                    self.config._disable = parseDateRules(dates);
	                }
	            });
	            var timeMode = userConfig.mode === "time";
	            if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
	                var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
	                formats.dateFormat =
	                    userConfig.noCalendar || timeMode
	                        ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
	                        : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
	            }
	            if (userConfig.altInput &&
	                (userConfig.enableTime || timeMode) &&
	                !userConfig.altFormat) {
	                var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
	                formats.altFormat =
	                    userConfig.noCalendar || timeMode
	                        ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K")
	                        : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
	            }
	            if (!userConfig.altInputClass) {
	                self.config.altInputClass =
	                    self.input.className + " " + self.config.altInputClass;
	            }
	            Object.defineProperty(self.config, "minDate", {
	                get: function () { return self.config._minDate; },
	                set: minMaxDateSetter("min")
	            });
	            Object.defineProperty(self.config, "maxDate", {
	                get: function () { return self.config._maxDate; },
	                set: minMaxDateSetter("max")
	            });
	            var minMaxTimeSetter = function (type) { return function (val) {
	                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
	            }; };
	            Object.defineProperty(self.config, "minTime", {
	                get: function () { return self.config._minTime; },
	                set: minMaxTimeSetter("min")
	            });
	            Object.defineProperty(self.config, "maxTime", {
	                get: function () { return self.config._maxTime; },
	                set: minMaxTimeSetter("max")
	            });
	            if (userConfig.mode === "time") {
	                self.config.noCalendar = true;
	                self.config.enableTime = true;
	            }
	            Object.assign(self.config, formats, userConfig);
	            for (var i = 0; i < boolOpts.length; i++)
	                self.config[boolOpts[i]] =
	                    self.config[boolOpts[i]] === true ||
	                        self.config[boolOpts[i]] === "true";
	            HOOKS.filter(function (hook) { return self.config[hook] !== undefined; }).forEach(function (hook) {
	                self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
	            });
	            self.isMobile =
	                !self.config.disableMobile &&
	                    !self.config.inline &&
	                    self.config.mode === "single" &&
	                    !self.config.disable.length &&
	                    !self.config.enable.length &&
	                    !self.config.weekNumbers &&
	                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	            for (var i = 0; i < self.config.plugins.length; i++) {
	                var pluginConf = self.config.plugins[i](self) || {};
	                for (var key in pluginConf) {
	                    if (HOOKS.indexOf(key) > -1) {
	                        self.config[key] = arrayify(pluginConf[key])
	                            .map(bindToInstance)
	                            .concat(self.config[key]);
	                    }
	                    else if (typeof userConfig[key] === "undefined")
	                        self.config[key] = pluginConf[key];
	                }
	            }
	            triggerEvent("onParseConfig");
	        }
	        function setupLocale() {
	            if (typeof self.config.locale !== "object" &&
	                typeof flatpickr.l10ns[self.config.locale] === "undefined")
	                self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
	            self.l10n = __assign({}, flatpickr.l10ns["default"], (typeof self.config.locale === "object"
	                ? self.config.locale
	                : self.config.locale !== "default"
	                    ? flatpickr.l10ns[self.config.locale]
	                    : undefined));
	            tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
	            var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
	            if (userConfig.time_24hr === undefined &&
	                flatpickr.defaultConfig.time_24hr === undefined) {
	                self.config.time_24hr = self.l10n.time_24hr;
	            }
	            self.formatDate = createDateFormatter(self);
	            self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
	        }
	        function positionCalendar(customPositionElement) {
	            if (self.calendarContainer === undefined)
	                return;
	            triggerEvent("onPreCalendarPosition");
	            var positionElement = customPositionElement || self._positionElement;
	            var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, (function (acc, child) { return acc + child.offsetHeight; }), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" ||
	                (configPosVertical !== "below" &&
	                    distanceFromBottom < calendarHeight &&
	                    inputBounds.top > calendarHeight);
	            var top = window.pageYOffset +
	                inputBounds.top +
	                (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
	            toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
	            toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
	            if (self.config.inline)
	                return;
	            var left = window.pageXOffset +
	                inputBounds.left -
	                (configPosHorizontal != null && configPosHorizontal === "center"
	                    ? (calendarWidth - inputBounds.width) / 2
	                    : 0);
	            var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
	            var rightMost = left + calendarWidth > window.document.body.offsetWidth;
	            var centerMost = right + calendarWidth > window.document.body.offsetWidth;
	            toggleClass(self.calendarContainer, "rightMost", rightMost);
	            if (self.config.static)
	                return;
	            self.calendarContainer.style.top = top + "px";
	            if (!rightMost) {
	                self.calendarContainer.style.left = left + "px";
	                self.calendarContainer.style.right = "auto";
	            }
	            else if (!centerMost) {
	                self.calendarContainer.style.left = "auto";
	                self.calendarContainer.style.right = right + "px";
	            }
	            else {
	                var doc = document.styleSheets[0];
	                // some testing environments don't have css support
	                if (doc === undefined)
	                    return;
	                var bodyWidth = window.document.body.offsetWidth;
	                var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
	                var centerBefore = ".flatpickr-calendar.centerMost:before";
	                var centerAfter = ".flatpickr-calendar.centerMost:after";
	                var centerIndex = doc.cssRules.length;
	                var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
	                toggleClass(self.calendarContainer, "rightMost", false);
	                toggleClass(self.calendarContainer, "centerMost", true);
	                doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
	                self.calendarContainer.style.left = centerLeft + "px";
	                self.calendarContainer.style.right = "auto";
	            }
	        }
	        function redraw() {
	            if (self.config.noCalendar || self.isMobile)
	                return;
	            updateNavigationCurrentMonth();
	            buildDays();
	        }
	        function focusAndClose() {
	            self._input.focus();
	            if (window.navigator.userAgent.indexOf("MSIE") !== -1 ||
	                navigator.msMaxTouchPoints !== undefined) {
	                // hack - bugs in the way IE handles focus keeps the calendar open
	                setTimeout(self.close, 0);
	            }
	            else {
	                self.close();
	            }
	        }
	        function selectDate(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            var isSelectable = function (day) {
	                return day.classList &&
	                    day.classList.contains("flatpickr-day") &&
	                    !day.classList.contains("flatpickr-disabled") &&
	                    !day.classList.contains("notAllowed");
	            };
	            var t = findParent(e.target, isSelectable);
	            if (t === undefined)
	                return;
	            var target = t;
	            var selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
	            var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth ||
	                selectedDate.getMonth() >
	                    self.currentMonth + self.config.showMonths - 1) &&
	                self.config.mode !== "range";
	            self.selectedDateElem = target;
	            if (self.config.mode === "single")
	                self.selectedDates = [selectedDate];
	            else if (self.config.mode === "multiple") {
	                var selectedIndex = isDateSelected(selectedDate);
	                if (selectedIndex)
	                    self.selectedDates.splice(parseInt(selectedIndex), 1);
	                else
	                    self.selectedDates.push(selectedDate);
	            }
	            else if (self.config.mode === "range") {
	                if (self.selectedDates.length === 2) {
	                    self.clear(false, false);
	                }
	                self.latestSelectedDateObj = selectedDate;
	                self.selectedDates.push(selectedDate);
	                // unless selecting same date twice, sort ascendingly
	                if (compareDates(selectedDate, self.selectedDates[0], true) !== 0)
	                    self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
	            }
	            setHoursFromInputs();
	            if (shouldChangeMonth) {
	                var isNewYear = self.currentYear !== selectedDate.getFullYear();
	                self.currentYear = selectedDate.getFullYear();
	                self.currentMonth = selectedDate.getMonth();
	                if (isNewYear) {
	                    triggerEvent("onYearChange");
	                    buildMonthSwitch();
	                }
	                triggerEvent("onMonthChange");
	            }
	            updateNavigationCurrentMonth();
	            buildDays();
	            updateValue();
	            if (self.config.enableTime)
	                setTimeout(function () { return (self.showTimeInput = true); }, 50);
	            // maintain focus
	            if (!shouldChangeMonth &&
	                self.config.mode !== "range" &&
	                self.config.showMonths === 1)
	                focusOnDayElem(target);
	            else if (self.selectedDateElem !== undefined &&
	                self.hourElement === undefined) {
	                self.selectedDateElem && self.selectedDateElem.focus();
	            }
	            if (self.hourElement !== undefined)
	                self.hourElement !== undefined && self.hourElement.focus();
	            if (self.config.closeOnSelect) {
	                var single = self.config.mode === "single" && !self.config.enableTime;
	                var range = self.config.mode === "range" &&
	                    self.selectedDates.length === 2 &&
	                    !self.config.enableTime;
	                if (single || range) {
	                    focusAndClose();
	                }
	            }
	            triggerChange();
	        }
	        var CALLBACKS = {
	            locale: [setupLocale, updateWeekdays],
	            showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
	            minDate: [jumpToDate],
	            maxDate: [jumpToDate]
	        };
	        function set(option, value) {
	            if (option !== null && typeof option === "object") {
	                Object.assign(self.config, option);
	                for (var key in option) {
	                    if (CALLBACKS[key] !== undefined)
	                        CALLBACKS[key].forEach(function (x) { return x(); });
	                }
	            }
	            else {
	                self.config[option] = value;
	                if (CALLBACKS[option] !== undefined)
	                    CALLBACKS[option].forEach(function (x) { return x(); });
	                else if (HOOKS.indexOf(option) > -1)
	                    self.config[option] = arrayify(value);
	            }
	            self.redraw();
	            updateValue(false);
	        }
	        function setSelectedDate(inputDate, format) {
	            var dates = [];
	            if (inputDate instanceof Array)
	                dates = inputDate.map(function (d) { return self.parseDate(d, format); });
	            else if (inputDate instanceof Date || typeof inputDate === "number")
	                dates = [self.parseDate(inputDate, format)];
	            else if (typeof inputDate === "string") {
	                switch (self.config.mode) {
	                    case "single":
	                    case "time":
	                        dates = [self.parseDate(inputDate, format)];
	                        break;
	                    case "multiple":
	                        dates = inputDate
	                            .split(self.config.conjunction)
	                            .map(function (date) { return self.parseDate(date, format); });
	                        break;
	                    case "range":
	                        dates = inputDate
	                            .split(self.l10n.rangeSeparator)
	                            .map(function (date) { return self.parseDate(date, format); });
	                        break;
	                    default:
	                        break;
	                }
	            }
	            else
	                self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
	            self.selectedDates = dates.filter(function (d) { return d instanceof Date && isEnabled(d, false); });
	            if (self.config.mode === "range")
	                self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
	        }
	        function setDate(date, triggerChange, format) {
	            if (triggerChange === void 0) { triggerChange = false; }
	            if (format === void 0) { format = self.config.dateFormat; }
	            if ((date !== 0 && !date) || (date instanceof Array && date.length === 0))
	                return self.clear(triggerChange);
	            setSelectedDate(date, format);
	            self.showTimeInput = self.selectedDates.length > 0;
	            self.latestSelectedDateObj =
	                self.selectedDates[self.selectedDates.length - 1];
	            self.redraw();
	            jumpToDate();
	            setHoursFromDate();
	            if (self.selectedDates.length === 0) {
	                self.clear(false);
	            }
	            updateValue(triggerChange);
	            if (triggerChange)
	                triggerEvent("onChange");
	        }
	        function parseDateRules(arr) {
	            return arr
	                .slice()
	                .map(function (rule) {
	                if (typeof rule === "string" ||
	                    typeof rule === "number" ||
	                    rule instanceof Date) {
	                    return self.parseDate(rule, undefined, true);
	                }
	                else if (rule &&
	                    typeof rule === "object" &&
	                    rule.from &&
	                    rule.to)
	                    return {
	                        from: self.parseDate(rule.from, undefined),
	                        to: self.parseDate(rule.to, undefined)
	                    };
	                return rule;
	            })
	                .filter(function (x) { return x; }); // remove falsy values
	        }
	        function setupDates() {
	            self.selectedDates = [];
	            self.now = self.parseDate(self.config.now) || new Date();
	            // Workaround IE11 setting placeholder as the input's value
	            var preloadedDate = self.config.defaultDate ||
	                ((self.input.nodeName === "INPUT" ||
	                    self.input.nodeName === "TEXTAREA") &&
	                    self.input.placeholder &&
	                    self.input.value === self.input.placeholder
	                    ? null
	                    : self.input.value);
	            if (preloadedDate)
	                setSelectedDate(preloadedDate, self.config.dateFormat);
	            self._initialDate =
	                self.selectedDates.length > 0
	                    ? self.selectedDates[0]
	                    : self.config.minDate &&
	                        self.config.minDate.getTime() > self.now.getTime()
	                        ? self.config.minDate
	                        : self.config.maxDate &&
	                            self.config.maxDate.getTime() < self.now.getTime()
	                            ? self.config.maxDate
	                            : self.now;
	            self.currentYear = self._initialDate.getFullYear();
	            self.currentMonth = self._initialDate.getMonth();
	            if (self.selectedDates.length > 0)
	                self.latestSelectedDateObj = self.selectedDates[0];
	            if (self.config.minTime !== undefined)
	                self.config.minTime = self.parseDate(self.config.minTime, "H:i");
	            if (self.config.maxTime !== undefined)
	                self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
	            self.minDateHasTime =
	                !!self.config.minDate &&
	                    (self.config.minDate.getHours() > 0 ||
	                        self.config.minDate.getMinutes() > 0 ||
	                        self.config.minDate.getSeconds() > 0);
	            self.maxDateHasTime =
	                !!self.config.maxDate &&
	                    (self.config.maxDate.getHours() > 0 ||
	                        self.config.maxDate.getMinutes() > 0 ||
	                        self.config.maxDate.getSeconds() > 0);
	            Object.defineProperty(self, "showTimeInput", {
	                get: function () { return self._showTimeInput; },
	                set: function (bool) {
	                    self._showTimeInput = bool;
	                    if (self.calendarContainer)
	                        toggleClass(self.calendarContainer, "showTimeInput", bool);
	                    self.isOpen && positionCalendar();
	                }
	            });
	        }
	        function setupInputs() {
	            self.input = self.config.wrap
	                ? element.querySelector("[data-input]")
	                : element;
	            /* istanbul ignore next */
	            if (!self.input) {
	                self.config.errorHandler(new Error("Invalid input element specified"));
	                return;
	            }
	            // hack: store previous type to restore it after destroy()
	            self.input._type = self.input.type;
	            self.input.type = "text";
	            self.input.classList.add("flatpickr-input");
	            self._input = self.input;
	            if (self.config.altInput) {
	                // replicate self.element
	                self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
	                self._input = self.altInput;
	                self.altInput.placeholder = self.input.placeholder;
	                self.altInput.disabled = self.input.disabled;
	                self.altInput.required = self.input.required;
	                self.altInput.tabIndex = self.input.tabIndex;
	                self.altInput.type = "text";
	                self.input.setAttribute("type", "hidden");
	                if (!self.config.static && self.input.parentNode)
	                    self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
	            }
	            if (!self.config.allowInput)
	                self._input.setAttribute("readonly", "readonly");
	            self._positionElement = self.config.positionElement || self._input;
	        }
	        function setupMobile() {
	            var inputType = self.config.enableTime
	                ? self.config.noCalendar
	                    ? "time"
	                    : "datetime-local"
	                : "date";
	            self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
	            self.mobileInput.step = self.input.getAttribute("step") || "any";
	            self.mobileInput.tabIndex = 1;
	            self.mobileInput.type = inputType;
	            self.mobileInput.disabled = self.input.disabled;
	            self.mobileInput.required = self.input.required;
	            self.mobileInput.placeholder = self.input.placeholder;
	            self.mobileFormatStr =
	                inputType === "datetime-local"
	                    ? "Y-m-d\\TH:i:S"
	                    : inputType === "date"
	                        ? "Y-m-d"
	                        : "H:i:S";
	            if (self.selectedDates.length > 0) {
	                self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
	            }
	            if (self.config.minDate)
	                self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
	            if (self.config.maxDate)
	                self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
	            self.input.type = "hidden";
	            if (self.altInput !== undefined)
	                self.altInput.type = "hidden";
	            try {
	                if (self.input.parentNode)
	                    self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
	            }
	            catch (_a) { }
	            bind(self.mobileInput, "change", function (e) {
	                self.setDate(e.target.value, false, self.mobileFormatStr);
	                triggerEvent("onChange");
	                triggerEvent("onClose");
	            });
	        }
	        function toggle(e) {
	            if (self.isOpen === true)
	                return self.close();
	            self.open(e);
	        }
	        function triggerEvent(event, data) {
	            // If the instance has been destroyed already, all hooks have been removed
	            if (self.config === undefined)
	                return;
	            var hooks = self.config[event];
	            if (hooks !== undefined && hooks.length > 0) {
	                for (var i = 0; hooks[i] && i < hooks.length; i++)
	                    hooks[i](self.selectedDates, self.input.value, self, data);
	            }
	            if (event === "onChange") {
	                self.input.dispatchEvent(createEvent("change"));
	                // many front-end frameworks bind to the input event
	                self.input.dispatchEvent(createEvent("input"));
	            }
	        }
	        function createEvent(name) {
	            var e = document.createEvent("Event");
	            e.initEvent(name, true, true);
	            return e;
	        }
	        function isDateSelected(date) {
	            for (var i = 0; i < self.selectedDates.length; i++) {
	                if (compareDates(self.selectedDates[i], date) === 0)
	                    return "" + i;
	            }
	            return false;
	        }
	        function isDateInRange(date) {
	            if (self.config.mode !== "range" || self.selectedDates.length < 2)
	                return false;
	            return (compareDates(date, self.selectedDates[0]) >= 0 &&
	                compareDates(date, self.selectedDates[1]) <= 0);
	        }
	        function updateNavigationCurrentMonth() {
	            if (self.config.noCalendar || self.isMobile || !self.monthNav)
	                return;
	            self.yearElements.forEach(function (yearElement, i) {
	                var d = new Date(self.currentYear, self.currentMonth, 1);
	                d.setMonth(self.currentMonth + i);
	                if (self.config.showMonths > 1 ||
	                    self.config.monthSelectorType === "static") {
	                    self.monthElements[i].textContent =
	                        monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
	                }
	                else {
	                    self.monthsDropdownContainer.value = d.getMonth().toString();
	                }
	                yearElement.value = d.getFullYear().toString();
	            });
	            self._hidePrevMonthArrow =
	                self.config.minDate !== undefined &&
	                    (self.currentYear === self.config.minDate.getFullYear()
	                        ? self.currentMonth <= self.config.minDate.getMonth()
	                        : self.currentYear < self.config.minDate.getFullYear());
	            self._hideNextMonthArrow =
	                self.config.maxDate !== undefined &&
	                    (self.currentYear === self.config.maxDate.getFullYear()
	                        ? self.currentMonth + 1 > self.config.maxDate.getMonth()
	                        : self.currentYear > self.config.maxDate.getFullYear());
	        }
	        function getDateStr(format) {
	            return self.selectedDates
	                .map(function (dObj) { return self.formatDate(dObj, format); })
	                .filter(function (d, i, arr) {
	                return self.config.mode !== "range" ||
	                    self.config.enableTime ||
	                    arr.indexOf(d) === i;
	            })
	                .join(self.config.mode !== "range"
	                ? self.config.conjunction
	                : self.l10n.rangeSeparator);
	        }
	        /**
	         * Updates the values of inputs associated with the calendar
	         */
	        function updateValue(triggerChange) {
	            if (triggerChange === void 0) { triggerChange = true; }
	            if (self.mobileInput !== undefined && self.mobileFormatStr) {
	                self.mobileInput.value =
	                    self.latestSelectedDateObj !== undefined
	                        ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr)
	                        : "";
	            }
	            self.input.value = getDateStr(self.config.dateFormat);
	            if (self.altInput !== undefined) {
	                self.altInput.value = getDateStr(self.config.altFormat);
	            }
	            if (triggerChange !== false)
	                triggerEvent("onValueUpdate");
	        }
	        function onMonthNavClick(e) {
	            var isPrevMonth = self.prevMonthNav.contains(e.target);
	            var isNextMonth = self.nextMonthNav.contains(e.target);
	            if (isPrevMonth || isNextMonth) {
	                changeMonth(isPrevMonth ? -1 : 1);
	            }
	            else if (self.yearElements.indexOf(e.target) >= 0) {
	                e.target.select();
	            }
	            else if (e.target.classList.contains("arrowUp")) {
	                self.changeYear(self.currentYear + 1);
	            }
	            else if (e.target.classList.contains("arrowDown")) {
	                self.changeYear(self.currentYear - 1);
	            }
	        }
	        function timeWrapper(e) {
	            e.preventDefault();
	            var isKeyDown = e.type === "keydown", input = e.target;
	            if (self.amPM !== undefined && e.target === self.amPM) {
	                self.amPM.textContent =
	                    self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	            }
	            var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta ||
	                (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
	            var newValue = curValue + step * delta;
	            if (typeof input.value !== "undefined" && input.value.length === 2) {
	                var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
	                if (newValue < min) {
	                    newValue =
	                        max +
	                            newValue +
	                            int(!isHourElem) +
	                            (int(isHourElem) && int(!self.amPM));
	                    if (isMinuteElem)
	                        incrementNumInput(undefined, -1, self.hourElement);
	                }
	                else if (newValue > max) {
	                    newValue =
	                        input === self.hourElement ? newValue - max - int(!self.amPM) : min;
	                    if (isMinuteElem)
	                        incrementNumInput(undefined, 1, self.hourElement);
	                }
	                if (self.amPM &&
	                    isHourElem &&
	                    (step === 1
	                        ? newValue + curValue === 23
	                        : Math.abs(newValue - curValue) > step)) {
	                    self.amPM.textContent =
	                        self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	                }
	                input.value = pad(newValue);
	            }
	        }
	        init();
	        return self;
	    }
	    /* istanbul ignore next */
	    function _flatpickr(nodeList, config) {
	        // static list
	        var nodes = Array.prototype.slice
	            .call(nodeList)
	            .filter(function (x) { return x instanceof HTMLElement; });
	        var instances = [];
	        for (var i = 0; i < nodes.length; i++) {
	            var node = nodes[i];
	            try {
	                if (node.getAttribute("data-fp-omit") !== null)
	                    continue;
	                if (node._flatpickr !== undefined) {
	                    node._flatpickr.destroy();
	                    node._flatpickr = undefined;
	                }
	                node._flatpickr = FlatpickrInstance(node, config || {});
	                instances.push(node._flatpickr);
	            }
	            catch (e) {
	                console.error(e);
	            }
	        }
	        return instances.length === 1 ? instances[0] : instances;
	    }
	    /* istanbul ignore next */
	    if (typeof HTMLElement !== "undefined" &&
	        typeof HTMLCollection !== "undefined" &&
	        typeof NodeList !== "undefined") {
	        // browser env
	        HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
	            return _flatpickr(this, config);
	        };
	        HTMLElement.prototype.flatpickr = function (config) {
	            return _flatpickr([this], config);
	        };
	    }
	    /* istanbul ignore next */
	    var flatpickr = function (selector, config) {
	        if (typeof selector === "string") {
	            return _flatpickr(window.document.querySelectorAll(selector), config);
	        }
	        else if (selector instanceof Node) {
	            return _flatpickr([selector], config);
	        }
	        else {
	            return _flatpickr(selector, config);
	        }
	    };
	    /* istanbul ignore next */
	    flatpickr.defaultConfig = {};
	    flatpickr.l10ns = {
	        en: __assign({}, english),
	        "default": __assign({}, english)
	    };
	    flatpickr.localize = function (l10n) {
	        flatpickr.l10ns["default"] = __assign({}, flatpickr.l10ns["default"], l10n);
	    };
	    flatpickr.setDefaults = function (config) {
	        flatpickr.defaultConfig = __assign({}, flatpickr.defaultConfig, config);
	    };
	    flatpickr.parseDate = createDateParser({});
	    flatpickr.formatDate = createDateFormatter({});
	    flatpickr.compareDates = compareDates;
	    /* istanbul ignore next */
	    if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
	        jQuery.fn.flatpickr = function (config) {
	            return _flatpickr(this, config);
	        };
	    }
	    // eslint-disable-next-line @typescript-eslint/camelcase
	    Date.prototype.fp_incr = function (days) {
	        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
	    };
	    if (typeof window !== "undefined") {
	        window.flatpickr = flatpickr;
	    }
	
	    return flatpickr;
	
	}));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(56);
	__webpack_require__(106);
	__webpack_require__(108);
	__webpack_require__(109);
	module.exports = __webpack_require__(62).Symbol;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(57);
	var has = __webpack_require__(58);
	var DESCRIPTORS = __webpack_require__(59);
	var $export = __webpack_require__(61);
	var redefine = __webpack_require__(71);
	var META = __webpack_require__(78).KEY;
	var $fails = __webpack_require__(60);
	var shared = __webpack_require__(74);
	var setToStringTag = __webpack_require__(79);
	var uid = __webpack_require__(72);
	var wks = __webpack_require__(80);
	var wksExt = __webpack_require__(81);
	var wksDefine = __webpack_require__(82);
	var enumKeys = __webpack_require__(83);
	var isArray = __webpack_require__(98);
	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(66);
	var toObject = __webpack_require__(99);
	var toIObject = __webpack_require__(86);
	var toPrimitive = __webpack_require__(69);
	var createDesc = __webpack_require__(70);
	var _create = __webpack_require__(100);
	var gOPNExt = __webpack_require__(103);
	var $GOPD = __webpack_require__(105);
	var $GOPS = __webpack_require__(96);
	var $DP = __webpack_require__(64);
	var $keys = __webpack_require__(84);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(104).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(97).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(75)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(63)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(60)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var core = __webpack_require__(62);
	var hide = __webpack_require__(63);
	var redefine = __webpack_require__(71);
	var ctx = __webpack_require__(76);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(64);
	var createDesc = __webpack_require__(70);
	module.exports = __webpack_require__(59) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(65);
	var IE8_DOM_DEFINE = __webpack_require__(67);
	var toPrimitive = __webpack_require__(69);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(59) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(59) && !__webpack_require__(60)(function () {
	  return Object.defineProperty(__webpack_require__(68)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	var document = __webpack_require__(57).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(66);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var hide = __webpack_require__(63);
	var has = __webpack_require__(58);
	var SRC = __webpack_require__(72)('src');
	var $toString = __webpack_require__(73);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(62).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(74)('native-function-to-string', Function.toString);


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(62);
	var global = __webpack_require__(57);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(75) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(77);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(72)('meta');
	var isObject = __webpack_require__(66);
	var has = __webpack_require__(58);
	var setDesc = __webpack_require__(64).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(60)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(64).f;
	var has = __webpack_require__(58);
	var TAG = __webpack_require__(80)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(74)('wks');
	var uid = __webpack_require__(72);
	var Symbol = __webpack_require__(57).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(80);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var core = __webpack_require__(62);
	var LIBRARY = __webpack_require__(75);
	var wksExt = __webpack_require__(81);
	var defineProperty = __webpack_require__(64).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(84);
	var gOPS = __webpack_require__(96);
	var pIE = __webpack_require__(97);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(85);
	var enumBugKeys = __webpack_require__(95);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var toIObject = __webpack_require__(86);
	var arrayIndexOf = __webpack_require__(90)(false);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(87);
	var defined = __webpack_require__(89);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(88);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(86);
	var toLength = __webpack_require__(91);
	var toAbsoluteIndex = __webpack_require__(93);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(92);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(92);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(74)('keys');
	var uid = __webpack_require__(72);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(88);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(89);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(65);
	var dPs = __webpack_require__(101);
	var enumBugKeys = __webpack_require__(95);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(68)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(102).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(64);
	var anObject = __webpack_require__(65);
	var getKeys = __webpack_require__(84);
	
	module.exports = __webpack_require__(59) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(57).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(86);
	var gOPN = __webpack_require__(104).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(85);
	var hiddenKeys = __webpack_require__(95).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(97);
	var createDesc = __webpack_require__(70);
	var toIObject = __webpack_require__(86);
	var toPrimitive = __webpack_require__(69);
	var has = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(67);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(59) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(107);
	var test = {};
	test[__webpack_require__(80)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(71)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(88);
	var TAG = __webpack_require__(80)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('asyncIterator');


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('observable');


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(111);
	__webpack_require__(117);
	module.exports = __webpack_require__(81).f('iterator');


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(112)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(113)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(92);
	var defined = __webpack_require__(89);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(75);
	var $export = __webpack_require__(61);
	var redefine = __webpack_require__(71);
	var hide = __webpack_require__(63);
	var Iterators = __webpack_require__(114);
	var $iterCreate = __webpack_require__(115);
	var setToStringTag = __webpack_require__(79);
	var getPrototypeOf = __webpack_require__(116);
	var ITERATOR = __webpack_require__(80)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(100);
	var descriptor = __webpack_require__(70);
	var setToStringTag = __webpack_require__(79);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(63)(IteratorPrototype, __webpack_require__(80)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(58);
	var toObject = __webpack_require__(99);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(118);
	var getKeys = __webpack_require__(84);
	var redefine = __webpack_require__(71);
	var global = __webpack_require__(57);
	var hide = __webpack_require__(63);
	var Iterators = __webpack_require__(114);
	var wks = __webpack_require__(80);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(119);
	var step = __webpack_require__(120);
	var Iterators = __webpack_require__(114);
	var toIObject = __webpack_require__(86);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(113)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(80)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(63)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(111);
	__webpack_require__(122);
	module.exports = __webpack_require__(62).Array.from;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(76);
	var $export = __webpack_require__(61);
	var toObject = __webpack_require__(99);
	var call = __webpack_require__(123);
	var isArrayIter = __webpack_require__(124);
	var toLength = __webpack_require__(91);
	var createProperty = __webpack_require__(125);
	var getIterFn = __webpack_require__(126);
	
	$export($export.S + $export.F * !__webpack_require__(127)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(65);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(114);
	var ITERATOR = __webpack_require__(80)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(64);
	var createDesc = __webpack_require__(70);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(107);
	var ITERATOR = __webpack_require__(80)('iterator');
	var Iterators = __webpack_require__(114);
	module.exports = __webpack_require__(62).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(80)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(129);
	module.exports = __webpack_require__(62).Number.isInteger;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(130) });


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(66);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// js/commonUI.js